import "./luna-vue-ui.css";
import { inject as Re, defineComponent as le, useAttrs as Ut, computed as C, openBlock as l, createBlock as _, resolveDynamicComponent as gt, mergeProps as He, createCommentVNode as k, useSlots as Xt, createElementBlock as s, normalizeClass as E, renderSlot as N, toDisplayString as I, ref as P, onBeforeUnmount as it, Transition as ke, withCtx as se, createVNode as U, createElementVNode as u, createTextVNode as we, watch as ce, nextTick as pe, onUnmounted as Ie, Teleport as De, normalizeStyle as re, Fragment as te, createSlots as It, useId as qt, unref as Z, withDirectives as ht, withModifiers as me, vModelText as Dt, renderList as oe, onMounted as yt, toValue as Ue, toRef as dt, provide as lt, TransitionGroup as qe, vShow as Yt, withKeys as xt, resolveComponent as Gt, shallowRef as Zt } from "vue";
import { X as Jt, Trash2 as Qt, Star as _t, Search as ea, Save as ta, Plus as aa, Pencil as la, Minimize2 as ra, Maximize2 as na, Loader2 as sa, List as oa, Lightbulb as ia, Inbox as ua, Info as da, HelpCircle as ca, FolderTree as fa, Database as ma, ChevronsRight as va, ChevronsLeft as ba, ChevronRight as ga, ChevronLeft as ha, ChevronDown as ya, CheckCircle2 as pa, Check as xa, ArrowLeft as wa, AlertTriangle as ka, AlertCircle as $a, RotateCw as Vt, LoaderCircle as Ca, EyeOff as La, Eye as Sa } from "lucide-vue-next";
const At = /* @__PURE__ */ Symbol.for("lunagoai.vue-ui.iconRegistry"), za = {
  AlertCircle: $a,
  AlertTriangle: ka,
  ArrowLeft: wa,
  Check: xa,
  CheckCircle2: pa,
  ChevronDown: ya,
  ChevronLeft: ha,
  ChevronRight: ga,
  ChevronsLeft: ba,
  ChevronsRight: va,
  Database: ma,
  FolderTree: fa,
  HelpCircle: ca,
  Info: da,
  Inbox: ua,
  Lightbulb: ia,
  List: oa,
  Loader2: sa,
  Maximize2: na,
  Minimize2: ra,
  Pencil: la,
  Plus: aa,
  Save: ta,
  Search: ea,
  Star: _t,
  Trash2: Qt,
  X: Jt
};
function st(e) {
  return e.split(/[-_\s]+/).filter(Boolean).map((r) => r.charAt(0).toUpperCase() + r.slice(1)).join("");
}
function Pt(e = {}) {
  const r = {
    custom: /* @__PURE__ */ new Map(),
    defaults: /* @__PURE__ */ new Map()
  };
  for (const [t, a] of Object.entries(za))
    r.defaults.set(t, a), r.defaults.set(st(t), a);
  return Ta(e, r), r;
}
const tt = Pt();
function Ba(e, r, t = tt) {
  t.custom.set(e, r), t.custom.set(st(e), r);
}
function Ta(e, r = tt) {
  for (const [t, a] of Object.entries(e))
    Ba(t, a, r);
}
function Ma(e, r = tt) {
  return r.custom.get(e) ?? r.custom.get(st(e)) ?? r.defaults.get(e) ?? r.defaults.get(st(e)) ?? null;
}
function No() {
  tt.custom.clear();
}
function Ea() {
  return Re(At, tt);
}
const Ia = /* @__PURE__ */ le({
  inheritAttrs: !1,
  __name: "BaseIcon",
  props: {
    name: {},
    size: { default: 16 },
    color: {},
    strokeWidth: { default: 2 },
    label: {},
    decorative: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const r = e, t = Ut(), a = Ea(), n = C(() => {
      if (!r.name) return null;
      if (typeof r.name != "string") return r.name;
      const c = r.name.split(/[-_\s]+/).filter(Boolean).map((d) => d.charAt(0).toUpperCase() + d.slice(1)).join("");
      return Ma(c, a);
    }), o = C(() => {
      const c = !!(r.label || t["aria-label"]);
      return {
        ...t,
        "aria-label": r.label ?? t["aria-label"],
        "aria-hidden": r.decorative === !0 || !c && t["aria-hidden"] === void 0 ? "true" : t["aria-hidden"],
        role: c ? t.role ?? "img" : t.role
      };
    });
    return (c, d) => n.value ? (l(), _(gt(n.value), He({
      key: 0,
      size: e.size,
      color: e.color,
      "stroke-width": e.strokeWidth
    }, o.value, { class: "luna-icon" }), null, 16, ["size", "color", "stroke-width"])) : k("", !0);
  }
}), fe = (e, r) => {
  const t = e.__vccOpts || e;
  for (const [a, n] of r)
    t[a] = n;
  return t;
}, q = /* @__PURE__ */ fe(Ia, [["__scopeId", "data-v-7dcfc498"]]), Da = ["type", "data-variant", "disabled", "aria-busy", "aria-label"], Va = { key: 3 }, Aa = /* @__PURE__ */ le({
  __name: "BaseButton",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    icon: {},
    label: {},
    loadingLabel: { default: "Loading" },
    block: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    align: { default: "center" },
    display: { default: "inline-flex" }
  },
  emits: ["click"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = Xt(), o = C(() => (t.icon || t.loading) && !t.label && !n.default), c = C(() => t.display === "grid" ? "grid" : t.display === "flex" ? "flex items-center" : "inline-flex items-center"), d = C(
      () => [
        "font-semibold transition-all duration-200 outline-none",
        "focus-visible:ring-2 focus-visible:ring-offset-1 disabled:opacity-60 disabled:cursor-not-allowed",
        "active:scale-95 whitespace-nowrap",
        t.rounded ? "rounded-full" : "rounded-lg"
      ].join(" ")
    ), i = C(() => t.display === "grid" ? t.align === "start" ? "place-items-start" : t.align === "end" ? "place-items-end" : "place-items-center" : t.align === "start" ? "justify-start" : t.align === "end" ? "justify-end" : "justify-center"), h = C(() => {
      switch (t.variant) {
        case "primary":
          return "bg-primary text-white hover:bg-primary-hover shadow-md shadow-primary/20 focus:ring-primary/50 border border-transparent";
        case "primary-glass":
          return "bg-primary/10 text-primary-400 hover:bg-primary/20 hover:text-primary-300 ring-1 ring-inset ring-primary-400/10 border-transparent focus:ring-primary-500/50";
        case "secondary":
          return "bg-surface-muted text-ui-muted hover:bg-surface-elevated border border-ui focus:ring-ui-focus";
        case "danger":
          return "bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/40 border border-red-100 dark:border-red-900/30 focus:ring-red-200 dark:focus:ring-red-800";
        case "danger-solid":
          return "bg-red-600 text-white hover:bg-red-700 shadow-sm shadow-red-900/20 focus:ring-red-500 border border-transparent";
        case "danger-glass":
          return "bg-red-500/15 text-red-400 hover:bg-red-500/25 hover:text-red-300 ring-1 ring-inset ring-red-400/10 border-transparent focus:ring-red-500/50";
        case "success":
          return "bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-900/40 border border-emerald-100 dark:border-emerald-900/30 focus:ring-emerald-200 dark:focus:ring-emerald-800";
        case "success-solid":
          return "bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm shadow-emerald-900/20 focus:ring-emerald-500 border border-transparent";
        case "info":
          return "bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/40 border border-blue-100 dark:border-blue-900/30 focus:ring-blue-200 dark:focus:ring-blue-800";
        case "info-solid":
          return "bg-blue-600 text-white hover:bg-blue-700 shadow-sm shadow-blue-900/20 focus:ring-blue-500 border border-transparent";
        case "warning":
          return "bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-900/40 border border-amber-100 dark:border-amber-900/30 focus:ring-amber-200 dark:focus:ring-amber-800";
        case "outline":
          return "bg-transparent border border-primary text-primary hover:bg-primary/5 focus:ring-primary/30 dark:border-dark-200 dark:text-dark-text-muted dark:hover:bg-dark-100";
        case "ghost":
          return "bg-transparent text-ui-muted hover:bg-surface-muted hover:text-ui border border-transparent focus:ring-ui-focus";
        case "accent-ghost":
          return "bg-transparent text-ui-muted hover:bg-primary/15 hover:text-primary-light border border-transparent focus:ring-primary/40";
        case "accent-outline":
          return "bg-surface-muted text-ui-muted hover:bg-primary/15 hover:text-primary-light border border-ui focus:ring-primary/40";
        case "transparent":
          return "focus:ring-0";
        default:
          return "bg-primary text-white hover:bg-primary-hover";
      }
    }), x = C(() => o.value ? t.size === "sm" ? "w-8 h-8 p-0" : t.size === "lg" ? "w-12 h-12 p-0" : "w-10 h-10 p-0" : t.size === "sm" ? "px-4 py-1.5 text-xs gap-1" : t.size === "lg" ? "px-8 py-3 text-base gap-2.5" : "px-6 py-2 text-sm gap-1.5");
    function y(S) {
      !t.disabled && !t.loading && a("click", S);
    }
    return (S, m) => (l(), s("button", {
      type: e.type,
      "data-variant": e.variant,
      disabled: e.disabled || e.loading,
      "aria-busy": e.loading || void 0,
      "aria-label": e.loading && !e.label && !S.$slots.default ? e.loadingLabel : void 0,
      class: E([c.value, d.value, i.value, h.value, x.value, e.block ? "w-full" : "", S.$attrs.class]),
      onClick: y
    }, [
      e.loading ? (l(), _(q, {
        key: 0,
        name: "Loader2",
        class: "animate-spin",
        decorative: ""
      })) : k("", !0),
      e.icon && !e.loading ? (l(), _(q, {
        key: 1,
        name: e.icon,
        size: e.size === "sm" ? 16 : 18
      }, null, 8, ["name", "size"])) : k("", !0),
      !e.loading && S.$slots.start && !e.icon ? N(S.$slots, "start", { key: 2 }, void 0, !0) : k("", !0),
      e.label ? (l(), s("span", Va, I(e.label), 1)) : N(S.$slots, "default", { key: 4 }, void 0, !0),
      N(S.$slots, "end", {}, void 0, !0)
    ], 10, Da));
  }
}), et = /* @__PURE__ */ fe(Aa, [["__scopeId", "data-v-f4f744b3"]]), Pa = ["role", "aria-live"], Ra = { class: "min-w-0 flex-1" }, Pe = 200, Uo = /* @__PURE__ */ le({
  __name: "BaseAlert",
  props: {
    severity: { default: "info" },
    dismissible: { type: Boolean, default: !0 },
    closeLabel: { default: "Close" }
  },
  emits: ["close"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = C(() => {
      switch (t.severity) {
        case "success":
          return "CheckCircle2";
        case "error":
          return "AlertCircle";
        case "warning":
          return "AlertTriangle";
        case "info":
          return "Info";
      }
    }), o = C(() => t.severity === "error" ? "alert" : "status"), c = P(!1), d = /* @__PURE__ */ new WeakMap();
    let i, h;
    const x = C(() => {
      switch (t.severity) {
        case "success":
          return "bg-success/10 text-success border-success/30";
        case "error":
          return "bg-danger/10 text-danger border-danger/30";
        case "warning":
          return "bg-warning/10 text-warning border-warning/30";
        case "info":
          return "bg-info/10 text-info border-info/30";
      }
    });
    function y(w) {
      const M = window.getComputedStyle(w);
      return {
        maxHeight: "",
        opacity: "1",
        paddingTop: M.paddingTop,
        paddingBottom: M.paddingBottom,
        marginBottom: M.marginBottom,
        borderColor: M.borderColor
      };
    }
    function S(w) {
      w.style.overflow = "hidden", w.style.transition = [
        `opacity ${Pe}ms ease-out`,
        `max-height ${Pe}ms ease-out`,
        `padding-top ${Pe}ms ease-out`,
        `padding-bottom ${Pe}ms ease-out`,
        `margin-bottom ${Pe}ms ease-out`,
        `border-color ${Pe}ms ease-out`
      ].join(", ");
    }
    function m(w) {
      w.style.overflow = "", w.style.transition = "", w.style.maxHeight = "", w.style.opacity = "", w.style.paddingTop = "", w.style.paddingBottom = "", w.style.marginBottom = "", w.style.borderColor = "";
    }
    function v(w) {
      const M = w;
      d.set(M, y(M)), S(M), M.style.maxHeight = "0px", M.style.opacity = "0", M.style.paddingTop = "0px", M.style.paddingBottom = "0px", M.style.marginBottom = "0px", M.style.borderColor = "transparent";
    }
    function f(w, M) {
      const F = w, V = {
        ...d.get(F) ?? y(F),
        maxHeight: `${F.scrollHeight}px`
      };
      i = requestAnimationFrame(() => {
        Object.assign(F.style, V), h = setTimeout(() => {
          m(F), d.delete(F), M();
        }, Pe);
      });
    }
    function b(w) {
      const M = w, F = {
        ...y(M),
        maxHeight: `${M.scrollHeight}px`
      };
      d.set(M, F), S(M), Object.assign(M.style, F);
    }
    function p(w, M) {
      const F = w;
      i = requestAnimationFrame(() => {
        F.style.maxHeight = "0px", F.style.opacity = "0", F.style.paddingTop = "0px", F.style.paddingBottom = "0px", F.style.marginBottom = "0px", F.style.borderColor = "transparent", h = setTimeout(() => {
          m(F), d.delete(F), M(), a("close");
        }, Pe);
      });
    }
    function L() {
      c.value || (c.value = !0);
    }
    return it(() => {
      i !== void 0 && cancelAnimationFrame(i), h && clearTimeout(h);
    }), (w, M) => (l(), _(ke, {
      appear: "",
      css: !1,
      onBeforeEnter: v,
      onEnter: f,
      onBeforeLeave: b,
      onLeave: p
    }, {
      default: se(() => [
        c.value ? k("", !0) : (l(), s("div", {
          key: 0,
          class: E(["flex min-w-0 items-center gap-3 overflow-hidden rounded-[9px] border px-3.5 py-3 leading-[1.45]", x.value]),
          role: o.value,
          "aria-live": o.value === "alert" ? "assertive" : "polite"
        }, [
          U(q, {
            name: n.value,
            size: 18,
            class: "shrink-0",
            "aria-hidden": "true"
          }, null, 8, ["name"]),
          u("div", Ra, [
            N(w.$slots, "default")
          ]),
          e.dismissible ? (l(), _(et, {
            key: 0,
            size: "sm",
            variant: "ghost",
            icon: "X",
            "aria-label": e.closeLabel,
            class: "!h-7 !w-7 !shrink-0 !p-0",
            onClick: L
          }, null, 8, ["aria-label"])) : k("", !0)
        ], 10, Pa))
      ]),
      _: 3
    }));
  }
}), Ha = { class: "flex flex-col gap-1 w-full relative" }, Wa = ["for"], Oa = {
  key: 0,
  class: "font-bold"
}, ja = ["id", "placeholder", "disabled", "readonly", "required", "rows", "autocomplete", "value"], Fa = ["id", "type", "placeholder", "disabled", "readonly", "required", "autocomplete", "value"], Ka = {
  key: 0,
  class: "font-bold"
}, Na = {
  key: 1,
  class: "mt-1 text-[11px] text-red-500 font-medium flex items-center gap-1"
}, Ua = /* @__PURE__ */ le({
  inheritAttrs: !1,
  __name: "BaseInput",
  props: {
    modelValue: { default: "" },
    type: { default: "text" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: [Boolean, String], default: !1 },
    required: { type: Boolean, default: !1 },
    id: {},
    label: { default: "" },
    size: { default: "md" },
    variant: { default: "default" },
    rows: { default: 3 },
    hideZero: { type: Boolean },
    inputClass: {},
    textAlign: { default: "left" },
    prefix: {},
    suffix: {},
    color: { default: "primary" },
    autocomplete: {},
    autoSave: {}
  },
  emits: ["update:modelValue", "blur", "focus", "click", "keyup", "enter"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = P(null);
    function c(b) {
      const p = b.target;
      n("update:modelValue", p.value), a.autoSave?.();
    }
    function d(b) {
      b.key === "Enter" && n("enter", b), n("keyup", b);
    }
    r({
      focus: () => o.value?.focus(),
      blur: () => o.value?.blur(),
      select: () => o.value?.select(),
      ref: o
    });
    const i = C(() => a.error === !0 || typeof a.error == "string" && a.error.trim() !== ""), h = C(() => typeof a.error == "string" ? a.error : ""), x = C(() => ({
      primary: "focus:border-primary focus:ring-primary/20",
      teal: "focus:border-teal-500 focus:ring-teal-500/20",
      indigo: "focus:border-indigo-500 focus:ring-indigo-500/20",
      orange: "focus:border-orange-500 focus:ring-orange-500/20",
      red: "focus:border-red-500 focus:ring-red-500/20"
    })[a.color]), y = C(() => ({
      primary: "focus:border-primary dark:focus:border-primary",
      teal: "focus:border-teal-500 dark:focus:border-teal-400",
      indigo: "focus:border-indigo-500 dark:focus:border-indigo-400",
      orange: "focus:border-orange-500 dark:focus:border-orange-400",
      red: "focus:border-red-500 dark:focus:border-red-400"
    })[a.color]), S = C(() => {
      const b = "font-medium placeholder:text-gray-400 dark:placeholder:text-gray-600 outline-none w-full transition-all";
      if (i.value)
        return `${b} bg-gray-50 dark:bg-red-900/10 border border-red-300 dark:border-red-800 focus:ring-2 focus:ring-red-100 dark:focus:ring-red-900/30 focus:border-red-500 text-red-900 dark:text-red-400 placeholder:text-red-300 dark:placeholder:text-red-500/50`;
      switch (a.variant) {
        case "filled":
          return `${b} bg-surface-muted border border-transparent focus:bg-surface ${x.value} text-ui`;
        case "outlined":
          return `${b} bg-transparent border-2 border-ui-strong ${x.value} text-ui`;
        case "plain":
          return `${b} bg-transparent border-0 focus:ring-0 text-ui-muted p-0`;
        case "underlined":
          return `${b} bg-transparent border-0 border-b border-transparent ${y.value} focus:ring-0 text-gray-800 dark:text-dark-text rounded-none px-0`;
        case "underlined-gray":
          return `${b} bg-transparent border-0 border-b border-ui ${y.value} focus:ring-0 text-ui rounded-none px-0`;
        default:
          return `${b} bg-surface border border-ui ${x.value} text-ui-muted shadow-sm`;
      }
    }), m = C(() => a.hideZero && (a.modelValue === 0 || a.modelValue === "0") ? "" : a.modelValue), v = C(() => {
      const b = a.variant === "underlined" || a.variant === "underlined-gray";
      return a.size === "xs" ? a.type === "textarea" ? "px-2 py-1 text-[10px] rounded" : `${b ? "px-0" : "px-2"} h-6 text-[10px] rounded` : a.size === "sm" ? a.type === "textarea" ? "px-2.5 py-1.5 text-xs rounded-lg" : `${b ? "px-0" : "px-2.5"} h-7.5 text-xs rounded-lg` : a.size === "lg" ? `${b ? "px-0" : "px-5"} py-3 text-base rounded-xl` : `${b ? "px-0" : "px-4"} py-2 text-sm rounded-lg`;
    }), f = C(() => a.textAlign === "center" ? "text-center" : a.textAlign === "right" ? "text-right" : "text-left");
    return (b, p) => (l(), s("div", Ha, [
      e.label ? (l(), s("label", {
        key: 0,
        for: e.id,
        class: "block text-[11px] font-bold text-gray-500 dark:text-dark-text-dim uppercase tracking-tight"
      }, I(e.label), 9, Wa)) : k("", !0),
      u("div", {
        class: E(["relative flex", e.type === "textarea" ? "items-start" : "items-center"])
      }, [
        b.$slots.start || e.prefix ? (l(), s("div", {
          key: 0,
          class: E(["absolute left-2.5 text-gray-400 flex items-center", [e.size === "xs" ? "text-[9px]" : "text-xs", e.type === "textarea" ? "mt-2.5" : ""]])
        }, [
          N(b.$slots, "start", {}, void 0, !0),
          e.prefix ? (l(), s("span", Oa, I(e.prefix), 1)) : k("", !0)
        ], 2)) : k("", !0),
        e.type === "textarea" ? (l(), s("textarea", He({
          key: 1,
          ref_key: "inputRef",
          ref: o,
          id: e.id,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          required: e.required,
          rows: e.rows,
          autocomplete: e.autocomplete,
          class: ["disabled:bg-gray-50 dark:disabled:bg-dark-100 dark:disabled:text-dark-text-dim disabled:cursor-not-allowed disabled:opacity-60 resize-none", [S.value, v.value, f.value, b.$slots.start || e.prefix ? e.size === "xs" || e.size === "sm" ? "pl-7" : "pl-10" : "", b.$slots.end || e.suffix ? e.size === "xs" || e.size === "sm" ? "pr-7" : "pr-10" : "", e.inputClass]],
          value: m.value
        }, b.$attrs, {
          onInput: c,
          onBlur: p[0] || (p[0] = (L) => n("blur", L)),
          onFocus: p[1] || (p[1] = (L) => n("focus", L)),
          onClick: p[2] || (p[2] = (L) => n("click", L)),
          onKeyup: d
        }), null, 16, ja)) : (l(), s("input", He({
          key: 2,
          ref_key: "inputRef",
          ref: o,
          id: e.id,
          type: e.type,
          placeholder: e.placeholder,
          disabled: e.disabled,
          readonly: e.readonly,
          required: e.required,
          autocomplete: e.autocomplete,
          class: ["disabled:bg-gray-50 dark:disabled:bg-dark-100 dark:disabled:text-dark-text-dim disabled:cursor-not-allowed disabled:opacity-60", [S.value, v.value, f.value, b.$slots.start || e.prefix ? e.size === "xs" || e.size === "sm" ? "pl-8" : "pl-10" : "", b.$slots.end || e.suffix ? e.size === "xs" || e.size === "sm" ? "pr-8" : "pr-10" : "", e.inputClass]],
          value: m.value
        }, b.$attrs, {
          onInput: c,
          onBlur: p[3] || (p[3] = (L) => n("blur", L)),
          onFocus: p[4] || (p[4] = (L) => n("focus", L)),
          onClick: p[5] || (p[5] = (L) => n("click", L)),
          onKeyup: d
        }), null, 16, Fa)),
        b.$slots.end || e.suffix ? (l(), s("div", {
          key: 3,
          class: E(["absolute right-3 text-gray-400 flex items-center", e.size === "xs" ? "text-[9px]" : "text-xs"])
        }, [
          e.suffix ? (l(), s("span", Ka, I(e.suffix), 1)) : k("", !0),
          N(b.$slots, "end", {}, void 0, !0)
        ], 2)) : k("", !0)
      ], 2),
      h.value ? (l(), s("p", Na, [
        U(q, {
          name: "AlertCircle",
          size: 11
        }),
        we(" " + I(h.value), 1)
      ])) : k("", !0)
    ]));
  }
}), Fe = /* @__PURE__ */ fe(Ua, [["__scopeId", "data-v-acc20f0a"]]), Xa = /* @__PURE__ */ le({
  inheritAttrs: !1,
  __name: "BasePopover",
  props: {
    visible: { type: Boolean },
    triggerRef: {},
    width: { default: "w-56" },
    placement: { default: "bottom" },
    offset: { default: 8 },
    teleport: { type: Boolean, default: !0 },
    className: { default: "" },
    padding: { default: "py-2" },
    closeOnClickOutside: { type: Boolean, default: !0 },
    closeOnScroll: { type: Boolean, default: !1 },
    flip: { type: Boolean, default: !0 },
    matchTriggerWidth: { type: Boolean, default: !1 },
    minWidthPx: {},
    constrainHeight: { type: Boolean, default: !1 },
    positioning: { default: "anchor" }
  },
  emits: ["update:visible", "update:resolvedPlacement", "close", "popover-mouseenter", "popover-mouseleave"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = P(null), o = P({}), c = P(t.placement);
    let d = null;
    function i(v) {
      return v === "bottom" ? "top" : v === "bottom-start" ? "top-start" : v === "bottom-end" ? "top-end" : v === "top" ? "bottom" : v === "top-start" ? "bottom-start" : v === "top-end" ? "bottom-end" : v;
    }
    function h(v, f, b, p) {
      const L = f.left + f.width / 2, w = f.top + f.height / 2;
      switch (v) {
        case "bottom":
          return { top: f.bottom + t.offset, left: L - b / 2 };
        case "bottom-start":
          return { top: f.bottom + t.offset, left: f.left };
        case "bottom-end":
          return { top: f.bottom + t.offset, left: f.right - b };
        case "top":
          return { top: f.top - p - t.offset, left: L - b / 2 };
        case "top-start":
          return { top: f.top - p - t.offset, left: f.left };
        case "top-end":
          return { top: f.top - p - t.offset, left: f.right - b };
        case "right":
          return { top: w - p / 2, left: f.right + t.offset };
        case "right-start":
          return { top: f.top, left: f.right + t.offset };
        case "right-end":
          return { top: f.bottom - p, left: f.right + t.offset };
        case "left":
          return { top: w - p / 2, left: f.left - b - t.offset };
        case "left-start":
          return { top: f.top, left: f.left - b - t.offset };
        case "left-end":
          return { top: f.bottom - p, left: f.left - b - t.offset };
      }
    }
    function x() {
      if (!t.triggerRef || !t.visible) return;
      const v = t.triggerRef.getBoundingClientRect(), f = t.matchTriggerWidth ? v.width : 0, b = Math.max(n.value?.offsetWidth || 224, f), p = n.value?.offsetHeight || 0, L = 8, w = window.innerWidth, M = window.innerHeight;
      let F = t.placement;
      if (t.flip) {
        if (F.startsWith("bottom")) {
          const j = M - v.bottom - t.offset - L, J = v.top - t.offset - L;
          p > j && J > j && (F = i(F));
        } else if (F.startsWith("top")) {
          const j = v.top - t.offset - L, J = M - v.bottom - t.offset - L;
          p > j && J > j && (F = i(F));
        }
      }
      c.value = F, a("update:resolvedPlacement", F);
      const V = h(F, v, b, p);
      let B;
      t.constrainHeight && (F.startsWith("top") ? B = v.top - t.offset - L : F.startsWith("bottom") ? B = M - v.bottom - t.offset - L : B = M - L * 2, B = Math.max(B, 80));
      const O = t.matchTriggerWidth ? f : t.minWidthPx ?? 0;
      if (t.positioning === "center") {
        o.value = {
          position: "fixed",
          top: "50%",
          left: "50%",
          zIndex: "9999",
          ...O > 0 ? { minWidth: `${O}px` } : {},
          ...B !== void 0 ? { maxHeight: `${B}px` } : {}
        };
        return;
      }
      o.value = {
        position: "fixed",
        top: `${Math.max(L, Math.min(V.top, M - p - L))}px`,
        left: `${Math.max(L, Math.min(V.left, w - b - L))}px`,
        zIndex: "9999",
        ...O > 0 ? { minWidth: `${O}px` } : {},
        ...B !== void 0 ? { maxHeight: `${B}px` } : {}
      };
    }
    function y(v) {
      if (!t.visible) return;
      const f = v.target, b = !!f && !!t.triggerRef?.contains(f), p = !!f && !!n.value?.contains(f);
      !b && !p && (a("update:visible", !1), a("close"));
    }
    function S() {
      const v = document.activeElement;
      v instanceof HTMLIFrameElement && (t.triggerRef?.contains(v) || n.value?.contains(v) || (a("update:visible", !1), a("close")));
    }
    function m(v) {
      if (t.visible && !(n.value && v.composedPath().includes(n.value))) {
        if (t.closeOnScroll) {
          a("update:visible", !1), a("close");
          return;
        }
        x();
      }
    }
    return ce(() => t.visible, async (v) => {
      v ? (await pe(), x(), t.closeOnClickOutside && window.addEventListener("pointerdown", y, !0), t.closeOnClickOutside && window.addEventListener("blur", S), window.addEventListener("resize", x), window.addEventListener("scroll", m, !0), n.value && (d = new ResizeObserver(x), d.observe(n.value))) : (window.removeEventListener("pointerdown", y, !0), window.removeEventListener("blur", S), window.removeEventListener("resize", x), window.removeEventListener("scroll", m, !0), d?.disconnect(), d = null);
    }), Ie(() => {
      window.removeEventListener("pointerdown", y, !0), window.removeEventListener("blur", S), window.removeEventListener("resize", x), window.removeEventListener("scroll", m, !0), d?.disconnect();
    }), (v, f) => (l(), _(De, {
      to: "body",
      disabled: !e.teleport
    }, [
      U(ke, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": `transform scale-95 opacity-0 ${c.value.startsWith("top") ? "translate-y-2" : "-translate-y-2"}`,
        "enter-to-class": "transform scale-100 opacity-100 translate-y-0",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "transform scale-100 opacity-100 translate-y-0",
        "leave-to-class": `transform scale-95 opacity-0 ${c.value.startsWith("top") ? "translate-y-2" : "-translate-y-2"}`
      }, {
        default: se(() => [
          e.visible ? (l(), s("div", {
            key: 0,
            ref_key: "popoverRef",
            ref: n,
            style: re(e.teleport ? o.value : {}),
            class: E(["base-popover-surface rounded-xl shadow-2xl border z-50 overflow-hidden", [e.width, e.className, e.padding, e.teleport ? "fixed" : "absolute mt-2", e.constrainHeight ? "flex flex-col" : ""]]),
            onMouseenter: f[0] || (f[0] = (b) => a("popover-mouseenter")),
            onMouseleave: f[1] || (f[1] = (b) => a("popover-mouseleave"))
          }, [
            N(v.$slots, "default", {}, void 0, !0)
          ], 38)) : k("", !0)
        ]),
        _: 3
      }, 8, ["enter-from-class", "leave-to-class"])
    ], 8, ["disabled"]));
  }
}), Rt = /* @__PURE__ */ fe(Xa, [["__scopeId", "data-v-816f7050"]]), qa = /* @__PURE__ */ le({
  inheritAttrs: !1,
  __name: "BasePopoverButton",
  props: {
    visible: { type: Boolean },
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    icon: {},
    label: {},
    loadingLabel: { default: "Loading" },
    block: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    align: { default: "center" },
    display: { default: "inline-flex" },
    showChevron: { type: Boolean, default: !0 },
    chevronIcon: { default: "ChevronDown" },
    chevronSize: { default: 15 },
    chevronRotateOn: { default: "open" },
    hasPopup: {},
    placement: { default: "bottom" },
    offset: { default: 8 },
    teleport: { type: Boolean, default: !0 },
    popoverWidth: { default: "w-56" },
    popoverClassName: { default: "" },
    popoverPadding: { default: "py-2" },
    closeOnClickOutside: { type: Boolean, default: !0 },
    closeOnScroll: { type: Boolean, default: !1 },
    flip: { type: Boolean, default: !0 },
    matchTriggerWidth: { type: Boolean, default: !1 },
    minWidthPx: {},
    constrainHeight: { type: Boolean, default: !1 }
  },
  emits: ["update:visible", "click", "open", "close"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = P(null), c = C(() => {
      const m = o.value?.$el;
      return m instanceof HTMLElement ? m : null;
    }), d = P(a.placement), i = C(() => a.visible ? d.value : a.placement), h = C(() => ({
      "rotate-180": i.value.startsWith("top") ? a.chevronRotateOn === "open" ? !a.visible : a.visible : a.chevronRotateOn === "open" ? a.visible : !a.visible
    }));
    function x(m) {
      m !== a.visible && (n("update:visible", m), n(m ? "open" : "close"));
    }
    function y(m) {
      n("click", m), x(!a.visible);
    }
    function S() {
      x(!1);
    }
    return r({ close: S, triggerRef: c }), (m, v) => (l(), s(te, null, [
      U(et, He({
        ref_key: "triggerComponent",
        ref: o
      }, m.$attrs, {
        variant: e.variant,
        size: e.size,
        type: e.type,
        disabled: e.disabled,
        loading: e.loading,
        icon: e.icon,
        label: e.label,
        "loading-label": e.loadingLabel,
        block: e.block,
        rounded: e.rounded,
        align: e.align,
        display: e.display,
        "aria-haspopup": e.hasPopup,
        "aria-expanded": e.visible,
        onClick: y
      }), It({
        end: se(() => [
          N(m.$slots, "end"),
          e.showChevron ? (l(), _(q, {
            key: 0,
            name: e.chevronIcon,
            size: e.chevronSize,
            class: E(["ml-auto transition-transform duration-200", h.value]),
            decorative: ""
          }, null, 8, ["name", "size", "class"])) : k("", !0)
        ]),
        _: 2
      }, [
        m.$slots.default ? {
          name: "default",
          fn: se(() => [
            N(m.$slots, "default")
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["variant", "size", "type", "disabled", "loading", "icon", "label", "loading-label", "block", "rounded", "align", "display", "aria-haspopup", "aria-expanded"]),
      U(Rt, {
        visible: e.visible,
        "onUpdate:visible": x,
        "onUpdate:resolvedPlacement": v[0] || (v[0] = (f) => d.value = f),
        "trigger-ref": c.value,
        placement: e.placement,
        offset: e.offset,
        teleport: e.teleport,
        width: e.popoverWidth,
        "class-name": e.popoverClassName,
        padding: e.popoverPadding,
        "close-on-click-outside": e.closeOnClickOutside,
        "close-on-scroll": e.closeOnScroll,
        flip: e.flip,
        "match-trigger-width": e.matchTriggerWidth,
        "min-width-px": e.minWidthPx,
        "constrain-height": e.constrainHeight
      }, {
        default: se(() => [
          N(m.$slots, "popover")
        ]),
        _: 3
      }, 8, ["visible", "trigger-ref", "placement", "offset", "teleport", "width", "class-name", "padding", "close-on-click-outside", "close-on-scroll", "flip", "match-trigger-width", "min-width-px", "constrain-height"])
    ], 64));
  }
}), Ht = P(typeof window < "u" ? window.innerWidth : 1024);
typeof window < "u" && window.addEventListener("resize", () => {
  Ht.value = window.innerWidth;
}, { passive: !0 });
function Wt(e = 640) {
  return C(() => Ht.value < e);
}
const Je = /* @__PURE__ */ new Set();
let mt = null;
function Ya(e) {
  typeof document > "u" || Je.has(e) || (Je.size === 0 && (mt = document.body.style.overflow), Je.add(e), document.body.style.overflow = "hidden");
}
function Ga(e) {
  typeof document > "u" || !Je.delete(e) || Je.size === 0 && (document.body.style.overflow = mt ?? "", mt = null);
}
const Za = ["for"], Ja = ["id", "disabled", "aria-expanded", "aria-label", "aria-invalid", "aria-controls", "aria-activedescendant", "aria-describedby"], Qa = {
  key: 0,
  class: "px-3 py-2 border-b border-gray-100 dark:border-dark-200"
}, _a = ["placeholder"], el = ["id", "aria-multiselectable"], tl = ["data-selected", "aria-selected"], al = { class: "truncate" }, ll = {
  key: 0,
  class: "base-select-radio-dot"
}, rl = {
  key: 1,
  class: "px-4 py-3 text-sm text-gray-500 text-center"
}, nl = {
  key: 0,
  class: "base-select-group-label px-3 pt-3 pb-1 text-[11px] font-black uppercase tracking-widest text-gray-500 dark:text-gray-400",
  role: "presentation",
  "aria-hidden": "true"
}, sl = ["data-selected", "id", "aria-selected", "onClick"], ol = { class: "flex items-center gap-2 min-w-0" }, il = { class: "truncate" }, ul = {
  key: 0,
  class: "base-select-radio-dot"
}, dl = {
  key: 2,
  class: "px-4 py-8 text-center text-xs text-gray-400 dark:text-gray-500 italic font-medium"
}, cl = ["id"], fl = /* @__PURE__ */ le({
  __name: "BaseSelect",
  props: {
    modelValue: {},
    options: {},
    label: {},
    placeholder: {},
    disabled: { type: Boolean },
    error: { type: [Boolean, String] },
    id: {},
    ariaLabel: {},
    size: { default: "md" },
    variant: { default: "default" },
    dropdownClass: {},
    showFocusRing: { type: Boolean, default: !0 },
    multiple: { type: Boolean, default: !1 },
    hideChevron: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Search..." },
    emptySearchText: { default: "No matching options" },
    emptyOptionsText: { default: "No options" },
    scrollSelectedIntoView: { type: Boolean, default: !0 },
    autoSave: {},
    dropdownPlacement: { default: "bottom-start" }
  },
  emits: ["update:modelValue", "change", "focus", "blur"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = P(!1), c = qt(), d = C(() => a.id ?? `${c}-trigger`), i = C(() => `${d.value}-listbox`), h = P(-1), x = P(null), y = P(""), S = P(null), m = P(null), v = Wt(), f = /* @__PURE__ */ Symbol("BaseSelectMobileScrollLock"), b = C(() => {
      if (a.multiple && Array.isArray(a.modelValue)) {
        const Y = a.modelValue;
        return a.options.filter((Q) => Y.includes(Q.value));
      }
      const X = a.options.find((Y) => Y.value === a.modelValue);
      return X ? [X] : [];
    }), p = C(() => {
      if (!a.searchable || !y.value) return a.options;
      const X = y.value.toLowerCase();
      return a.options.filter((Y) => Y.label.toLowerCase().includes(X) || String(Y.value).toLowerCase().includes(X));
    }), L = C(() => a.multiple ? b.value.map((X) => X.label).join(", ") : b.value[0]?.label ?? "");
    function w() {
      a.disabled || (o.value = !o.value, o.value && n("focus"));
    }
    function M() {
      o.value = !1;
    }
    function F() {
      a.disabled || (o.value = !0, n("focus"));
    }
    function V(X) {
      return `${i.value}-option-${X}`;
    }
    function B() {
      const X = p.value.findIndex((Y) => $(Y));
      h.value = X >= 0 ? X : -1;
    }
    function O() {
      h.value < 0 || document.getElementById(V(h.value))?.scrollIntoView({ block: "nearest" });
    }
    function j(X) {
      if (!a.disabled)
        if (X.key === "ArrowDown" || X.key === "ArrowUp") {
          if (X.preventDefault(), !o.value) {
            F(), pe(() => {
              const be = p.value.length;
              h.value = be ? X.key === "ArrowDown" ? 0 : be - 1 : -1;
            });
            return;
          }
          const Y = p.value.length;
          if (!Y) return;
          const Q = X.key === "ArrowDown" ? 1 : -1;
          h.value = h.value < 0 ? Q > 0 ? 0 : Y - 1 : (h.value + Q + Y) % Y, pe(O);
        } else if ((X.key === "Enter" || X.key === " ") && o.value) {
          X.preventDefault();
          const Y = p.value[h.value];
          Y && J(Y);
        } else X.key === "Escape" && o.value && (X.preventDefault(), M());
    }
    r({
      close: M,
      open: F,
      toggle: w
    }), ce(o, (X) => {
      if (!X) {
        n("blur");
        return;
      }
      a.searchable && (y.value = "", pe(() => S.value?.focus())), B(), a.scrollSelectedIntoView && pe(() => {
        m.value?.querySelector('[data-selected="true"]')?.scrollIntoView({ block: "nearest" });
      });
    }), ce(p, () => {
      o.value && B();
    });
    function J(X) {
      h.value = p.value.findIndex((Q) => Q.value === X.value);
      let Y;
      if (a.multiple) {
        const Q = Array.isArray(a.modelValue) ? [...a.modelValue] : [], be = Q.indexOf(X.value);
        be > -1 ? Q.splice(be, 1) : Q.push(X.value), Y = Q;
      } else
        Y = X.value, o.value = !1;
      n("update:modelValue", Y), n("change", Y), a.autoSave?.();
    }
    function $(X) {
      return a.multiple && Array.isArray(a.modelValue) ? a.modelValue.includes(X.value) : a.modelValue === X.value;
    }
    const A = C(() => ({ label: a.placeholder ?? "", value: "" })), z = C(() => a.error === !0 || typeof a.error == "string" && a.error.trim() !== ""), K = C(() => typeof a.error == "string" ? a.error : ""), de = C(() => [
      "base-select-dropdown",
      v.value ? "base-select-mobile-modal" : "",
      a.dropdownClass
    ].filter(Boolean).join(" "));
    function ue(X, Y) {
      typeof document > "u" || (X && Y ? Ya(f) : Ga(f));
    }
    ce([o, v], ([X, Y]) => {
      ue(X, Y);
    }), Ie(() => {
      ue(!1, !1);
    });
    const ie = C(() => {
      const X = "font-medium outline-none w-full cursor-pointer transition-all duration-200 flex items-center justify-between text-left";
      if (z.value)
        return `${X} bg-gray-50 dark:bg-red-900/10 border border-red-300 dark:border-red-800 ring-2 ring-red-100 dark:ring-red-900/30 text-red-900 dark:text-red-400 rounded-lg`;
      switch (a.variant) {
        case "filled":
          return `${X} bg-surface-muted border border-transparent focus:bg-surface focus:border-primary focus:ring-2 focus:ring-primary/20 text-ui rounded-lg`;
        case "outlined":
          return `${X} bg-transparent border-2 border-ui-strong focus:border-primary focus:ring-2 focus:ring-primary/20 text-ui rounded-lg`;
        case "plain":
          return `${X} bg-transparent border-0 focus:ring-0 text-ui-muted p-0 h-full w-auto min-w-0 flex-shrink-0`;
        default:
          return `${X} bg-surface border border-ui focus:border-primary focus:ring-2 focus:ring-primary/20 text-ui-muted shadow-sm rounded-lg`;
      }
    }), he = C(() => a.size === "sm" ? a.variant === "plain" ? "text-xs" : "h-8 px-3 text-xs" : a.size === "lg" ? "h-12 px-5 text-base rounded-xl" : a.variant === "plain" ? "text-sm" : "h-10 px-4 text-sm");
    return (X, Y) => (l(), s("div", {
      class: E(["w-full", { "flex flex-col gap-1.5": e.label }])
    }, [
      e.label ? (l(), s("label", {
        key: 0,
        for: d.value,
        class: "block text-[11px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-widest px-0.5"
      }, I(e.label), 9, Za)) : k("", !0),
      u("div", {
        ref_key: "triggerRef",
        ref: x,
        class: "relative group h-full"
      }, [
        u("button", {
          id: d.value,
          type: "button",
          disabled: e.disabled,
          "aria-haspopup": "listbox",
          "aria-expanded": o.value,
          "aria-label": e.ariaLabel || e.label,
          "aria-invalid": z.value || void 0,
          "aria-controls": i.value,
          "aria-activedescendant": o.value && h.value >= 0 ? V(h.value) : void 0,
          "aria-describedby": z.value ? `${d.value}-error` : void 0,
          class: E(["disabled:bg-surface-muted disabled:text-ui-dim disabled:cursor-not-allowed disabled:opacity-60", ["group flex items-center justify-between transition-all duration-200 overflow-hidden min-w-0", ie.value, he.value, o.value && e.showFocusRing ? "ring-2 ring-primary/20 border-primary" : ""]]),
          onClick: w,
          onKeydown: j
        }, [
          N(X.$slots, "selected", { selectedOptions: b.value }, () => [
            u("span", {
              class: E(["min-w-0 truncate grow", { "text-gray-400 dark:text-gray-500": !L.value }])
            }, I(L.value || e.placeholder), 3)
          ], !0),
          e.hideChevron ? k("", !0) : (l(), _(q, {
            key: 0,
            name: "ChevronDown",
            size: 16,
            class: E(["ml-2 shrink-0 transition-transform duration-200", { "rotate-180": o.value }])
          }, null, 8, ["class"]))
        ], 42, Ja),
        (l(), _(De, { to: "body" }, [
          U(ke, {
            "enter-active-class": "transition-opacity duration-200",
            "enter-from-class": "opacity-0",
            "enter-to-class": "opacity-100",
            "leave-active-class": "transition-opacity duration-150",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: se(() => [
              o.value && Z(v) ? (l(), s("div", {
                key: 0,
                class: "base-select-mobile-backdrop",
                "aria-hidden": "true",
                onClick: M
              })) : k("", !0)
            ]),
            _: 1
          })
        ])),
        U(Rt, {
          visible: o.value,
          "onUpdate:visible": Y[4] || (Y[4] = (Q) => o.value = Q),
          "trigger-ref": x.value,
          placement: e.dropdownPlacement,
          flip: !0,
          positioning: Z(v) ? "center" : "anchor",
          "match-trigger-width": e.variant !== "plain" && !Z(v),
          "min-width-px": e.variant === "plain" && !Z(v) ? 120 : void 0,
          width: Z(v) ? "" : "w-56",
          padding: Z(v) ? "" : "py-1.5",
          "class-name": de.value
        }, {
          default: se(() => [
            e.searchable ? (l(), s("div", Qa, [
              ht(u("input", {
                ref_key: "searchInputRef",
                ref: S,
                "onUpdate:modelValue": Y[0] || (Y[0] = (Q) => y.value = Q),
                type: "text",
                placeholder: e.searchPlaceholder,
                class: "w-full bg-gray-50 dark:bg-dark-50 border border-gray-200 dark:border-dark-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary/50 dark:text-dark-text",
                onClick: Y[1] || (Y[1] = me(() => {
                }, ["stop"])),
                onKeydown: Y[2] || (Y[2] = me(() => {
                }, ["stop"]))
              }, null, 40, _a), [
                [Dt, y.value]
              ])
            ])) : k("", !0),
            u("div", {
              id: i.value,
              ref_key: "optionsScrollRef",
              ref: m,
              class: "base-select-options overflow-y-auto custom-scrollbar max-h-60",
              role: "listbox",
              "aria-multiselectable": e.multiple || void 0
            }, [
              e.placeholder && !e.multiple ? (l(), s("div", {
                key: 0,
                "data-selected": $(A.value) ? "true" : void 0,
                class: E(["base-select-option base-select-placeholder-option px-4 py-2 text-xs font-bold uppercase tracking-tight cursor-pointer hover:bg-gray-50 dark:hover:bg-dark-50/50 transition-colors", [$(A.value) ? "font-bold" : "text-gray-400 dark:text-dark-text-dim"]]),
                role: "option",
                "aria-selected": $(A.value),
                onClick: Y[3] || (Y[3] = (Q) => J(A.value))
              }, [
                u("span", al, I(e.placeholder), 1),
                Z(v) && !e.multiple ? (l(), s("span", {
                  key: 0,
                  class: E(["base-select-radio", { "base-select-radio-selected": $(A.value) }]),
                  "aria-hidden": "true"
                }, [
                  $(A.value) ? (l(), s("span", ll)) : k("", !0)
                ], 2)) : $(A.value) ? (l(), _(q, {
                  key: 1,
                  name: "Check",
                  size: 16,
                  class: "base-select-option-check text-primary shrink-0 ml-2"
                })) : k("", !0)
              ], 10, tl)) : k("", !0),
              p.value.length === 0 ? (l(), s("div", rl, I(e.emptySearchText), 1)) : k("", !0),
              (l(!0), s(te, null, oe(p.value, (Q) => (l(), s("div", {
                key: Q.value,
                class: "contents"
              }, [
                Q.group && p.value[p.value.indexOf(Q) - 1]?.group !== Q.group ? (l(), s("div", nl, I(Q.group), 1)) : k("", !0),
                u("div", {
                  "data-selected": $(Q) ? "true" : void 0,
                  id: V(p.value.indexOf(Q)),
                  class: E(["base-select-option px-3 py-2.5 text-sm font-medium transition-all duration-200 cursor-pointer flex items-center justify-between gap-4 flex-nowrap", [$(Q) ? "font-bold" : "", h.value === p.value.indexOf(Q) ? "ring-1 ring-inset ring-primary/40" : ""]]),
                  role: "option",
                  "aria-selected": $(Q),
                  onClick: (be) => J(Q)
                }, [
                  u("div", ol, [
                    N(X.$slots, "option", {
                      option: Q,
                      isSelected: $(Q)
                    }, () => [
                      Q.icon ? (l(), _(q, {
                        key: 0,
                        name: Q.icon,
                        size: 14
                      }, null, 8, ["name"])) : k("", !0),
                      u("span", il, I(Q.label), 1)
                    ], !0)
                  ]),
                  Z(v) && !e.multiple ? (l(), s("span", {
                    key: 0,
                    class: E(["base-select-radio", { "base-select-radio-selected": $(Q) }]),
                    "aria-hidden": "true"
                  }, [
                    $(Q) ? (l(), s("span", ul)) : k("", !0)
                  ], 2)) : $(Q) ? (l(), _(q, {
                    key: 1,
                    name: "Check",
                    size: 16,
                    class: "base-select-option-check text-primary shrink-0 ml-2"
                  })) : k("", !0)
                ], 10, sl)
              ]))), 128)),
              e.options.length === 0 ? (l(), s("div", dl, I(e.emptyOptionsText), 1)) : k("", !0)
            ], 8, el)
          ]),
          _: 3
        }, 8, ["visible", "trigger-ref", "placement", "positioning", "match-trigger-width", "min-width-px", "width", "padding", "class-name"])
      ], 512),
      z.value && K.value ? (l(), s("p", {
        key: 1,
        id: z.value ? `${d.value}-error` : void 0,
        class: "mt-1 text-[11px] text-red-500 font-medium flex items-center gap-1 px-1"
      }, [
        U(q, {
          name: "AlertCircle",
          size: 11
        }),
        we(" " + I(K.value), 1)
      ], 8, cl)) : k("", !0)
    ], 2));
  }
}), vt = /* @__PURE__ */ fe(fl, [["__scopeId", "data-v-cf62f1c0"]]), ml = { key: 0 }, Xo = /* @__PURE__ */ le({
  __name: "BaseTag",
  props: {
    label: {},
    severity: { default: "secondary" },
    icon: {},
    rounded: { type: Boolean, default: !1 },
    variant: { default: "subtle" },
    size: { default: "md" },
    class: {}
  },
  setup(e) {
    const r = e, t = C(() => {
      const o = r.variant === "outline", c = r.variant === "filled";
      switch (r.severity) {
        case "success":
          return c ? "bg-success text-surface-inverse border-success" : o ? "bg-transparent text-success border-success" : "bg-success/10 text-success border-success/30";
        case "info":
          return c ? "bg-info text-surface-inverse border-info" : o ? "bg-transparent text-info border-info" : "bg-info/10 text-info border-info/30";
        case "warning":
          return c ? "bg-warning text-surface-inverse border-warning" : o ? "bg-transparent text-warning border-warning" : "bg-warning/10 text-warning border-warning/30";
        case "danger":
          return c ? "bg-danger text-surface-inverse border-danger" : o ? "bg-transparent text-danger border-danger" : "bg-danger/10 text-danger border-danger/30";
        case "primary":
          return c ? "bg-primary text-surface-inverse border-primary" : o ? "bg-transparent text-primary border-primary" : "bg-primary/10 dark:bg-primary/20 text-primary border-primary/20 dark:border-primary/30";
        default:
          return c ? "bg-surface-inverse text-surface border-surface-inverse" : o ? "bg-transparent text-ui-muted border-ui-strong" : "bg-surface-muted text-ui-muted border-ui";
      }
    }), a = C(() => r.size === "sm" ? "px-2 py-0.5 text-[0.65rem] gap-1" : r.size === "lg" ? "px-4 py-1.5 text-base gap-2" : "px-2.5 py-1 text-xs gap-1.5"), n = C(() => r.size === "sm" ? 12 : r.size === "lg" ? 18 : 14);
    return (o, c) => (l(), s("div", {
      class: E(["inline-flex items-center font-medium border transition-colors duration-200", [t.value, a.value, e.rounded ? "rounded-full" : "rounded-md", r.class]])
    }, [
      e.icon ? (l(), _(q, {
        key: 0,
        name: e.icon,
        size: n.value
      }, null, 8, ["name", "size"])) : k("", !0),
      N(o.$slots, "default", {}, () => [
        e.label ? (l(), s("span", ml, I(e.label), 1)) : k("", !0)
      ])
    ], 2));
  }
});
let Ke = null;
function vl(e) {
  Ke && Ke !== e && Ke(), Ke = e;
}
function wt(e) {
  Ke === e && (Ke = null);
}
const bl = { class: "cursor-help text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-400 transition-colors" }, gl = /* @__PURE__ */ le({
  __name: "BaseTooltip",
  props: {
    text: {},
    widthClass: {},
    placement: { default: "top" },
    theme: { default: "dark" },
    fontSize: { default: "xs" },
    paddingClass: { default: "px-4 py-3" },
    maxWidth: { default: "320px" },
    interactive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const r = e, t = P(!1), a = P(!1);
    let n = null;
    const o = P(null), c = P(null), d = P({ top: "0px", left: "0px" }), i = P({ left: "50%" }), h = P(r.placement);
    function x() {
      n && (clearTimeout(n), n = null);
    }
    function y() {
      x(), a.value = !1, t.value = !1, wt(y);
    }
    function S() {
      vl(y);
    }
    const m = C(
      () => r.theme === "dark" ? "border-white/10 bg-dark-200 text-dark-text" : "border-gray-100 bg-white text-gray-700"
    ), v = C(() => h.value === "top" ? r.theme === "dark" ? "top-full border-t-dark-200" : "top-full border-t-white" : r.theme === "dark" ? "bottom-full border-b-dark-200" : "bottom-full border-b-white");
    function f() {
      if (!o.value || !c.value) return;
      const B = o.value.getBoundingClientRect(), O = document.documentElement.clientWidth || window.innerWidth, j = document.documentElement.clientHeight || window.innerHeight, J = c.value.offsetWidth, $ = c.value.offsetHeight, A = 24, z = 16, K = B.left + B.width / 2 - J / 2, de = Math.min(Math.max(A, K), O - A - J);
      let ue = r.placement, ie = 0;
      r.placement === "top" ? B.top < $ + z + 10 ? (ue = "bottom", ie = B.bottom + z) : ie = B.top - z : j - B.bottom < $ + z + 10 ? (ue = "top", ie = B.top - z) : ie = B.bottom + z, h.value = ue, d.value = { left: `${de}px`, top: `${ie}px` }, i.value = { left: `${B.left + B.width / 2 - de}px` };
    }
    async function b() {
      a.value || (x(), S(), t.value = !0, await pe(), f(), setTimeout(f, 50));
    }
    function p() {
      a.value || (r.interactive ? n = setTimeout(() => {
        y();
      }, 150) : y());
    }
    async function L(B) {
      B.stopPropagation(), S(), a.value = !a.value, t.value = a.value, a.value || y(), t.value && (await pe(), f(), setTimeout(f, 50));
    }
    function w() {
      a.value && y();
    }
    let M = null;
    const F = () => {
      t.value && f();
    }, V = () => {
      t.value && f();
    };
    return yt(() => {
      window.addEventListener("scroll", F, !0), window.addEventListener("resize", V), M = new ResizeObserver(() => {
        t.value && f();
      }), document.addEventListener("click", w);
    }), Ie(() => {
      wt(y), window.removeEventListener("scroll", F, !0), window.removeEventListener("resize", V), M?.disconnect(), document.removeEventListener("click", w);
    }), ce(c, (B) => {
      B && M ? M.observe(B) : M?.disconnect();
    }), (B, O) => (l(), s("div", {
      ref_key: "iconRef",
      ref: o,
      class: "relative inline-block w-max",
      onMouseenter: b,
      onMouseleave: p,
      onClick: L
    }, [
      N(B.$slots, "trigger", {}, () => [
        u("div", bl, [
          U(q, {
            name: "HelpCircle",
            size: 16
          })
        ])
      ], !0),
      (l(), _(De, { to: "body" }, [
        U(ke, { name: "tooltip-fade" }, {
          default: se(() => [
            t.value ? (l(), s("div", {
              key: 0,
              ref_key: "tooltipRef",
              ref: c,
              class: E(["fixed rounded-xl border shadow-2xl z-10000 pointer-events-auto whitespace-pre-wrap wrap-break-word text-left leading-relaxed min-w-30", [m.value, e.paddingClass, e.fontSize === "sm" ? "text-sm" : e.fontSize === "base" ? "text-base" : "text-xs", e.widthClass || "w-max", h.value === "top" ? "-translate-y-full" : ""]]),
              style: re({
                ...d.value,
                maxWidth: e.maxWidth
              }),
              onMouseenter: b,
              onMouseleave: p
            }, [
              N(B.$slots, "default", {
                hide: () => t.value = !1
              }, () => [
                we(I(e.text), 1)
              ], !0),
              u("div", {
                class: E(["absolute -translate-x-1/2 border-4 border-transparent", v.value]),
                style: re(i.value)
              }, null, 6)
            ], 38)) : k("", !0)
          ]),
          _: 3
        })
      ]))
    ], 544));
  }
}), qo = /* @__PURE__ */ fe(gl, [["__scopeId", "data-v-bde2cca5"]]);
let bt = 0, Qe = null;
function hl() {
  Qe && (clearTimeout(Qe), Qe = null);
}
function Ot(e) {
  const r = Math.max(0, e);
  bt = Date.now() + r, hl(), Qe = setTimeout(() => {
    bt = 0, Qe = null;
  }, r);
}
function jt() {
  return bt > Date.now();
}
const yl = /* @__PURE__ */ le({
  __name: "BaseHoverLabel",
  props: {
    text: {},
    triggerClass: {},
    delay: { default: 450 },
    recentWindow: { default: 1500 },
    placement: { default: "bottom" },
    maxWidth: { default: "240px" }
  },
  setup(e) {
    const r = e, t = P(null), a = P(null), n = P(!1), o = P(!1), c = P({ top: "0px", left: "0px" });
    let d = null;
    function i() {
      d && (clearTimeout(d), d = null);
    }
    function h() {
      if (!t.value || !a.value || !n.value) return;
      const m = t.value.getBoundingClientRect(), v = a.value.getBoundingClientRect(), f = 6, b = 8, p = document.documentElement.clientWidth || window.innerWidth, L = document.documentElement.clientHeight || window.innerHeight, w = Math.max(b, p - v.width - b), M = Math.max(b, L - v.height - b), F = Math.min(
        Math.max(b, m.left + m.width / 2 - v.width / 2),
        w
      ), V = Math.min(Math.max(b, m.top + m.height / 2 - v.height / 2), M), B = m.bottom + f, O = m.top - v.height - f, j = B + v.height <= L - b, J = O >= b, $ = () => j ? B : J ? O : V, A = m.right + f, z = m.left - v.width - f, K = A + v.width <= p - b, de = z >= b;
      let ue = F, ie = $();
      r.placement === "right" ? K ? (ue = A, ie = V) : de && (ue = z, ie = V) : r.placement === "left" ? de ? (ue = z, ie = V) : K && (ue = A, ie = V) : r.placement === "top" && J ? ie = O : (r.placement === "bottom" && j || r.placement === "top" && j) && (ie = B), c.value = {
        top: `${Math.max(b, Math.min(ie, M))}px`,
        left: `${Math.max(b, Math.min(ue, w))}px`
      };
    }
    async function x() {
      if (i(), !!r.text) {
        if (jt()) {
          n.value = !0, o.value = !0, await pe(), h();
          return;
        }
        d = setTimeout(async () => {
          n.value = !0, o.value = !0, await pe(), h();
        }, Math.max(0, r.delay));
      }
    }
    function y() {
      i(), n.value = !1, o.value && (o.value = !1, Ot(r.recentWindow));
    }
    function S() {
      n.value && h();
    }
    return ce(n, (m) => {
      m ? (window.addEventListener("scroll", S, !0), window.addEventListener("resize", S)) : (window.removeEventListener("scroll", S, !0), window.removeEventListener("resize", S));
    }), Ie(() => {
      i(), window.removeEventListener("scroll", S, !0), window.removeEventListener("resize", S);
    }), (m, v) => (l(), s(te, null, [
      u("span", {
        ref_key: "triggerRef",
        ref: t,
        class: E(["inline-flex", r.triggerClass]),
        onMouseenter: x,
        onMouseleave: y,
        onClick: y
      }, [
        N(m.$slots, "trigger", {}, void 0, !0)
      ], 34),
      (l(), _(De, { to: "body" }, [
        U(ke, { name: "base-hover-label-fade" }, {
          default: se(() => [
            n.value && r.text ? (l(), s("span", {
              key: 0,
              ref_key: "labelRef",
              ref: a,
              role: "tooltip",
              class: "pointer-events-none fixed z-10000 w-max rounded-md border px-2 py-1 text-left text-xs font-semibold leading-4 shadow-lg whitespace-normal break-words",
              style: re({ ...c.value, backgroundColor: "var(--color-tooltip-surface)", borderColor: "var(--color-tooltip-border)", color: "var(--color-tooltip-text)", width: "max-content", maxWidth: `min(${r.maxWidth}, calc(100vw - 16px))` })
            }, I(r.text), 5)) : k("", !0)
          ]),
          _: 1
        })
      ]))
    ], 64));
  }
}), Yo = /* @__PURE__ */ fe(yl, [["__scopeId", "data-v-c0139823"]]), rt = {
  delay: 450,
  recentWindow: 1500,
  placement: "bottom",
  maxWidth: "240px"
};
function Ft(e) {
  const r = typeof e == "string" ? { text: e } : e ?? {};
  return {
    text: r.text,
    delay: r.delay ?? rt.delay,
    recentWindow: r.recentWindow ?? rt.recentWindow,
    placement: r.placement ?? rt.placement,
    maxWidth: r.maxWidth ?? rt.maxWidth
  };
}
function Kt(e) {
  e.showTimer && (clearTimeout(e.showTimer), e.showTimer = null);
}
function pt(e, r) {
  if (!r.label || !r.visible) return;
  const t = e.getBoundingClientRect(), a = r.label.getBoundingClientRect(), n = 6, o = 8, c = document.documentElement.clientWidth || window.innerWidth, d = document.documentElement.clientHeight || window.innerHeight, i = Math.max(o, c - a.width - o), h = Math.max(o, d - a.height - o), x = Math.min(
    Math.max(o, t.left + t.width / 2 - a.width / 2),
    i
  ), y = Math.min(Math.max(o, t.top + t.height / 2 - a.height / 2), h), S = t.bottom + n, m = t.top - a.height - n, v = S + a.height <= d - o, f = m >= o, b = () => v ? S : f ? m : y, p = t.right + n, L = t.left - a.width - n, w = p + a.width <= c - o, M = L >= o;
  let F = x, V = b();
  r.options.placement === "right" ? w ? (F = p, V = y) : M && (F = L, V = y) : r.options.placement === "left" ? M ? (F = L, V = y) : w && (F = p, V = y) : r.options.placement === "top" && f ? V = m : (r.options.placement === "bottom" && v || r.options.placement === "top" && v) && (V = S), r.label.style.top = `${Math.max(o, Math.min(V, h))}px`, r.label.style.left = `${Math.max(o, Math.min(F, i))}px`;
}
function _e(e, r) {
  if (Kt(r), r.visible = !1, r.label) {
    const t = r.label;
    t.style.opacity = "0", t.style.transform = "translateY(-2px)", window.setTimeout(() => {
      !r.visible && r.label === t && (t.remove(), r.label = null);
    }, 120);
  }
  r.hasShown && (r.hasShown = !1, Ot(r.options.recentWindow)), window.removeEventListener("scroll", r.refreshPosition, !0), window.removeEventListener("resize", r.refreshPosition);
}
function kt(e, r) {
  if (Kt(r), !r.options.text) return;
  const t = () => {
    if (!r.options.text || r.visible) return;
    r.label && (r.label.remove(), r.label = null);
    const a = document.createElement("span");
    a.dataset.baseHoverLabel = "true", a.setAttribute("role", "tooltip"), a.className = "pointer-events-none fixed z-[10000] w-max rounded-md border px-2 py-1 text-left text-xs font-semibold leading-4 shadow-lg whitespace-normal break-words", a.style.backgroundColor = "var(--color-tooltip-surface)", a.style.borderColor = "var(--color-tooltip-border)", a.style.color = "var(--color-tooltip-text)", a.style.boxShadow = "0 10px 24px var(--color-shadow, rgb(15 23 42 / 18%))", a.style.width = "max-content", a.style.maxWidth = `min(${r.options.maxWidth}, calc(100vw - 16px))`, a.style.opacity = "0", a.style.transform = "translateY(-2px)", a.style.transition = "opacity 120ms ease, transform 120ms ease", a.textContent = r.options.text, document.body.appendChild(a), r.label = a, r.visible = !0, r.hasShown = !0, pt(e, r), requestAnimationFrame(() => {
      r.label === a && r.visible && (a.style.opacity = "1", a.style.transform = "translateY(0)");
    }), window.addEventListener("scroll", r.refreshPosition, !0), window.addEventListener("resize", r.refreshPosition);
  };
  if (jt()) {
    t();
    return;
  }
  r.showTimer = window.setTimeout(t, Math.max(0, r.options.delay));
}
function pl(e, r, t) {
  r.options = Ft(t), r.options.text || _e(e, r), r.label && (r.label.textContent = r.options.text ?? "", r.label.style.maxWidth = `min(${r.options.maxWidth}, calc(100vw - 16px))`, pt(e, r));
}
function xl(e, r) {
  const t = {
    options: Ft(r),
    label: null,
    showTimer: null,
    hasShown: !1,
    visible: !1,
    onMouseEnter: () => kt(e, t),
    onMouseLeave: () => _e(e, t),
    onFocusIn: () => kt(e, t),
    onFocusOut: (a) => {
      a.relatedTarget instanceof Node && e.contains(a.relatedTarget) || _e(e, t);
    },
    onClick: () => _e(e, t),
    refreshPosition: () => pt(e, t)
  };
  return e.addEventListener("mouseenter", t.onMouseEnter), e.addEventListener("mouseleave", t.onMouseLeave), e.addEventListener("focusin", t.onFocusIn), e.addEventListener("focusout", t.onFocusOut), e.addEventListener("click", t.onClick), t;
}
function wl(e, r) {
  _e(e, r), e.removeEventListener("mouseenter", r.onMouseEnter), e.removeEventListener("mouseleave", r.onMouseLeave), e.removeEventListener("focusin", r.onFocusIn), e.removeEventListener("focusout", r.onFocusOut), e.removeEventListener("click", r.onClick);
}
const $t = {
  mounted(e, r) {
    e.__baseHoverLabel = xl(e, r.value);
  },
  updated(e, r) {
    const t = e.__baseHoverLabel;
    t && pl(e, t, r.value);
  },
  unmounted(e) {
    const r = e.__baseHoverLabel;
    r && wl(e, r), delete e.__baseHoverLabel;
  }
}, kl = { class: "w-full" }, $l = {
  key: 0,
  class: "flex justify-between mb-1"
}, Go = /* @__PURE__ */ le({
  __name: "BaseProgressBar",
  props: {
    value: { default: 0 },
    showValue: { type: Boolean, default: !0 },
    variant: { default: "primary" },
    size: { default: "md" },
    height: {}
  },
  setup(e) {
    const r = e, t = C(() => {
      if (r.height) return r.height;
      switch (r.size) {
        case "sm":
          return "h-1.5";
        case "lg":
          return "h-4";
        default:
          return "h-2.5";
      }
    }), a = C(() => {
      switch (r.variant) {
        case "success":
          return "bg-green-500";
        case "warning":
          return "bg-yellow-500";
        case "danger":
          return "bg-red-600";
        default:
          return "bg-primary";
      }
    }), n = C(() => Math.min(Math.max(r.value, 0), 100));
    return (o, c) => (l(), s("div", kl, [
      e.showValue ? (l(), s("div", $l, [
        u("span", {
          class: E(["text-xs font-medium", {
            "text-primary": e.variant === "primary",
            "text-green-500": e.variant === "success",
            "text-yellow-500": e.variant === "warning",
            "text-red-600": e.variant === "danger"
          }])
        }, I(n.value) + "% ", 3)
      ])) : k("", !0),
      u("div", {
        class: E(["w-full bg-gray-200 rounded-full dark:bg-dark-200 overflow-hidden", [e.height && !e.height.startsWith("h-") ? "" : t.value]]),
        style: re(e.height && !e.height.startsWith("h-") ? { height: e.height } : {})
      }, [
        u("div", {
          class: E(["rounded-full transition-all duration-500 ease-out", [a.value, t.value]]),
          style: re({ width: `${n.value}%`, ...e.height && !e.height.startsWith("h-") ? { height: e.height } : {} })
        }, null, 6)
      ], 6)
    ]));
  }
});
function Cl({
  scrollElement: e,
  refresh: r,
  enabled: t = !0,
  threshold: a = 64,
  maxDistance: n = 140,
  loadingDistance: o = 56,
  visibleDistance: c = 16,
  topTolerance: d = 0.5,
  interactiveSelector: i = 'button, a, input, textarea, select, [contenteditable="true"]',
  onError: h
}) {
  const x = P(0), y = P(!1), S = P(!1), m = C(() => x.value >= a), v = C(() => S.value || x.value >= c), f = C(() => Math.min(x.value / a, 1));
  let b = null, p = null;
  function L() {
    b = null, y.value = !1, S.value || (x.value = 0);
  }
  function w(B) {
    const O = e.value;
    if (S.value || !Ue(t) || !O || O.scrollTop > d || B.touches.length !== 1 || B.target instanceof Element && B.target.closest(i)) return;
    const j = B.touches[0];
    b = { x: j.clientX, y: j.clientY };
  }
  function M(B) {
    const O = e.value;
    if (!b || !O || B.touches.length !== 1) return;
    if (!Ue(t) || O.scrollTop > d) {
      L();
      return;
    }
    const j = B.touches[0], J = j.clientX - b.x, $ = j.clientY - b.y;
    if ($ <= 0 || Math.abs(J) > Math.abs($)) {
      L();
      return;
    }
    B.preventDefault(), y.value = !0, x.value = Math.min($, n);
  }
  async function F() {
    if (!b) return;
    const B = m.value;
    if (b = null, y.value = !1, !B) {
      x.value = 0;
      return;
    }
    S.value = !0, x.value = o;
    try {
      await r();
    } catch (O) {
      h?.(O);
    } finally {
      S.value = !1, x.value = 0;
    }
  }
  function V(B) {
    p?.(), p = null, B && (B.addEventListener("touchstart", w, { passive: !0 }), B.addEventListener("touchmove", M, { passive: !1 }), B.addEventListener("touchend", F, { passive: !0 }), B.addEventListener("touchcancel", L, { passive: !0 }), p = () => {
      B.removeEventListener("touchstart", w), B.removeEventListener("touchmove", M), B.removeEventListener("touchend", F), B.removeEventListener("touchcancel", L);
    });
  }
  return ce(e, V, { flush: "post", immediate: !0 }), ce(() => Ue(t), (B) => {
    B || L();
  }), Ie(() => p?.()), {
    pullDistance: x,
    pullDragging: y,
    pullProgress: f,
    pullReady: m,
    pullRefreshing: S,
    pullVisible: v,
    resetGesture: L
  };
}
const Ll = ["aria-label", "aria-busy", "data-refreshing"], Sl = /* @__PURE__ */ le({
  __name: "BasePullToRefresh",
  props: {
    refresh: {},
    enabled: { type: Boolean, default: !0 },
    threshold: { default: 64 },
    maxDistance: { default: 140 },
    loadingDistance: { default: 56 },
    visibleDistance: { default: 16 },
    topTolerance: { default: 0.5 },
    interactiveSelector: { default: 'button, a, input, textarea, select, [contenteditable="true"]' },
    theme: { default: "auto" },
    indicatorLabel: { default: "Refresh" }
  },
  emits: ["refreshStart", "refreshEnd", "refreshError"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = P(null), c = C(() => a.enabled);
    async function d() {
      n("refreshStart");
      try {
        await a.refresh();
      } catch (b) {
        throw n("refreshError", b), b;
      } finally {
        n("refreshEnd");
      }
    }
    const {
      pullDistance: i,
      pullDragging: h,
      pullProgress: x,
      pullReady: y,
      pullRefreshing: S,
      pullVisible: m
    } = Cl({
      scrollElement: o,
      refresh: d,
      enabled: c,
      threshold: a.threshold,
      maxDistance: a.maxDistance,
      loadingDistance: a.loadingDistance,
      visibleDistance: a.visibleDistance,
      topTolerance: a.topTolerance,
      interactiveSelector: a.interactiveSelector
    }), v = C(() => ({ height: `${i.value}px` })), f = C(() => S.value ? void 0 : { transform: `rotate(${i.value * 4.5}deg)` });
    return r({
      scrollElement: o,
      pullDistance: i,
      pullDragging: h,
      pullProgress: x,
      pullReady: y,
      pullRefreshing: S,
      pullVisible: m
    }), (b, p) => (l(), s("div", {
      ref_key: "scrollElement",
      ref: o,
      class: E(["base-pull-to-refresh", [`base-pull-to-refresh--${e.theme}`, { "base-pull-to-refresh--dragging": Z(h) }]]),
      "data-pull-to-refresh-part": "scroll"
    }, [
      u("div", {
        class: "base-pull-to-refresh__gap",
        style: re(v.value),
        "data-pull-to-refresh-part": "gap"
      }, [
        Z(m) ? N(b.$slots, "indicator", {
          key: 0,
          distance: Z(i),
          progress: Z(x),
          ready: Z(y),
          refreshing: Z(S)
        }, () => [
          u("div", {
            class: E(["base-pull-to-refresh__indicator", { "base-pull-to-refresh__indicator--ready": Z(y) || Z(S) }]),
            "aria-label": e.indicatorLabel,
            "aria-busy": Z(S),
            "data-refreshing": Z(S) ? "true" : "false",
            "data-pull-to-refresh-part": "indicator",
            role: "status"
          }, [
            U(Z(Vt), {
              class: E(["base-pull-to-refresh__icon", { "base-pull-to-refresh__icon--refreshing": Z(S) }]),
              style: re(f.value),
              "data-pull-to-refresh-part": "icon"
            }, null, 8, ["class", "style"])
          ], 10, Ll)
        ], !0) : k("", !0)
      ], 4),
      N(b.$slots, "default", {
        distance: Z(i),
        dragging: Z(h),
        progress: Z(x),
        ready: Z(y),
        refreshing: Z(S)
      }, void 0, !0)
    ], 2));
  }
}), Zo = /* @__PURE__ */ fe(Sl, [["__scopeId", "data-v-8a58d4fc"]]);
function zl({
  gestureElement: e,
  refresh: r,
  enabled: t = !0,
  threshold: a = 64,
  maxDistance: n = 140,
  loadingDistance: o = 56,
  visibleDistance: c = 16,
  interactiveSelector: d = 'button, a, input, textarea, select, [contenteditable="true"]',
  onError: i
}) {
  const h = P(0), x = P(!1), y = P(!1), S = C(() => h.value >= a), m = C(() => y.value || h.value >= c), v = C(() => Math.min(h.value / a, 1));
  let f = null, b = null;
  function p() {
    f = null, x.value = !1, y.value || (h.value = 0);
  }
  function L(V) {
    const B = e.value;
    if (y.value || !Ue(t) || !B || V.touches.length !== 1 || V.target instanceof Element && V.target.closest(d)) return;
    const O = V.touches[0];
    f = { x: O.clientX, y: O.clientY };
  }
  function w(V) {
    const B = e.value;
    if (!f || !B || V.touches.length !== 1) return;
    if (!Ue(t)) {
      p();
      return;
    }
    const O = V.touches[0], j = O.clientX - f.x, J = O.clientY - f.y;
    if (J <= 0 || Math.abs(j) > Math.abs(J)) {
      p();
      return;
    }
    V.preventDefault(), x.value = !0, h.value = Math.min(J, n);
  }
  async function M() {
    if (!f) return;
    const V = S.value;
    if (f = null, x.value = !1, !V) {
      h.value = 0;
      return;
    }
    y.value = !0, h.value = o;
    try {
      await r();
    } catch (B) {
      i?.(B);
    } finally {
      y.value = !1, h.value = 0;
    }
  }
  function F(V) {
    b?.(), b = null, V && (V.addEventListener("touchstart", L, { passive: !0 }), V.addEventListener("touchmove", w, { passive: !1 }), V.addEventListener("touchend", M, { passive: !0 }), V.addEventListener("touchcancel", p, { passive: !0 }), b = () => {
      V.removeEventListener("touchstart", L), V.removeEventListener("touchmove", w), V.removeEventListener("touchend", M), V.removeEventListener("touchcancel", p);
    });
  }
  return ce(e, F, { flush: "post", immediate: !0 }), ce(() => Ue(t), (V) => {
    V || p();
  }), Ie(() => b?.()), {
    pullDistance: h,
    pullDragging: x,
    pullProgress: v,
    pullReady: S,
    pullRefreshing: y,
    pullVisible: m,
    resetGesture: p
  };
}
const Bl = ["aria-label", "aria-busy", "data-refreshing"], Tl = /* @__PURE__ */ le({
  __name: "BasePullToRefreshTrigger",
  props: {
    refresh: {},
    enabled: { type: Boolean, default: !0 },
    threshold: { default: 64 },
    maxDistance: { default: 140 },
    loadingDistance: { default: 56 },
    visibleDistance: { default: 16 },
    interactiveSelector: { default: 'button, a, input, textarea, select, [contenteditable="true"]' },
    theme: { default: "auto" },
    indicatorLabel: { default: "Refresh" }
  },
  emits: ["refreshStart", "refreshEnd", "refreshError"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = P(null);
    async function c() {
      n("refreshStart");
      try {
        await a.refresh();
      } catch (f) {
        throw n("refreshError", f), f;
      } finally {
        n("refreshEnd");
      }
    }
    const {
      pullDistance: d,
      pullDragging: i,
      pullProgress: h,
      pullReady: x,
      pullRefreshing: y,
      pullVisible: S
    } = zl({
      gestureElement: o,
      refresh: c,
      enabled: () => a.enabled,
      threshold: a.threshold,
      maxDistance: a.maxDistance,
      loadingDistance: a.loadingDistance,
      visibleDistance: a.visibleDistance,
      interactiveSelector: a.interactiveSelector
    }), m = C(() => ({
      transform: `translate(-50%, calc(-100% + ${d.value}px))`
    })), v = C(() => y.value ? void 0 : { transform: `rotate(${d.value * 4.5}deg)` });
    return r({
      gestureElement: o,
      pullDistance: d,
      pullDragging: i,
      pullProgress: h,
      pullReady: x,
      pullRefreshing: y,
      pullVisible: S
    }), (f, b) => (l(), s("div", {
      ref_key: "gestureElement",
      ref: o,
      class: E(["base-pull-to-refresh-trigger", [`base-pull-to-refresh-trigger--${e.theme}`, { "base-pull-to-refresh-trigger--dragging": Z(i) }]]),
      "data-pull-to-refresh-part": "trigger"
    }, [
      Z(S) ? (l(), s("div", {
        key: 0,
        class: E(["base-pull-to-refresh-trigger__indicator", { "base-pull-to-refresh-trigger__indicator--ready": Z(x) || Z(y) }]),
        style: re(m.value),
        "aria-label": e.indicatorLabel,
        "aria-busy": Z(y),
        "data-refreshing": Z(y) ? "true" : "false",
        "data-pull-to-refresh-part": "indicator",
        role: "status"
      }, [
        N(f.$slots, "indicator", {
          distance: Z(d),
          progress: Z(h),
          ready: Z(x),
          refreshing: Z(y)
        }, () => [
          U(Z(Vt), {
            class: E(["base-pull-to-refresh-trigger__icon", { "base-pull-to-refresh-trigger__icon--refreshing": Z(y) }]),
            style: re(v.value),
            "data-pull-to-refresh-part": "icon"
          }, null, 8, ["class", "style"])
        ], !0)
      ], 14, Bl)) : k("", !0),
      N(f.$slots, "default", {
        distance: Z(d),
        dragging: Z(i),
        progress: Z(h),
        ready: Z(x),
        refreshing: Z(y)
      }, void 0, !0)
    ], 2));
  }
}), Jo = /* @__PURE__ */ fe(Tl, [["__scopeId", "data-v-61214d6f"]]), Ml = { class: "flex items-center gap-3" }, El = ["id", "disabled"], Il = ["for"], Qo = /* @__PURE__ */ le({
  __name: "BaseSwitch",
  props: {
    modelValue: { type: Boolean, default: !1 },
    label: {},
    disabled: { type: Boolean, default: !1 },
    id: { default: () => `switch-${Math.random().toString(36).slice(2, 11)}` }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: r }) {
    const t = e, a = r;
    function n() {
      t.disabled || a("update:modelValue", !t.modelValue);
    }
    return (o, c) => (l(), s("div", Ml, [
      u("button", {
        type: "button",
        id: e.id,
        disabled: e.disabled,
        class: E([
          "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 dark:focus:ring-offset-dark-50",
          e.modelValue ? "bg-primary" : "bg-gray-200 dark:bg-dark-200",
          e.disabled ? "cursor-not-allowed opacity-50" : ""
        ]),
        onClick: n
      }, [
        u("span", {
          "aria-hidden": "true",
          class: E([
            "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
            e.modelValue ? "translate-x-5" : "translate-x-0"
          ])
        }, null, 2)
      ], 10, El),
      e.label ? (l(), s("label", {
        key: 0,
        for: e.id,
        class: "text-sm font-medium text-gray-700 dark:text-dark-text-muted cursor-pointer",
        onClick: n
      }, I(e.label), 9, Il)) : k("", !0)
    ]));
  }
}), Dl = {
  class: "flex",
  "aria-label": "Breadcrumb"
}, Vl = { class: "inline-flex items-center space-x-1 md:space-x-3" }, Al = { class: "flex items-center" }, Pl = ["disabled", "onClick"], _o = /* @__PURE__ */ le({
  __name: "BaseBreadcrumb",
  props: {
    items: {}
  },
  emits: ["click"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = (o, c) => {
      c < t.items.length - 1 && a("click", o, c);
    };
    return (o, c) => (l(), s("nav", Dl, [
      u("ol", Vl, [
        (l(!0), s(te, null, oe(e.items, (d, i) => (l(), s("li", {
          key: i,
          class: "inline-flex items-center"
        }, [
          u("div", Al, [
            i > 0 ? (l(), _(q, {
              key: 0,
              name: "chevron-right",
              size: 14,
              class: "mx-1 text-gray-400 dark:text-gray-500"
            })) : k("", !0),
            u("button", {
              type: "button",
              class: E([
                "inline-flex items-center text-sm font-medium transition-colors duration-200",
                i === e.items.length - 1 ? "text-gray-700 dark:text-gray-200 cursor-default" : "text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary-light"
              ]),
              disabled: i === e.items.length - 1,
              onClick: (h) => n(d, i)
            }, [
              d.icon ? (l(), _(q, {
                key: 0,
                name: d.icon,
                size: 16,
                class: "mr-2"
              }, null, 8, ["name"])) : k("", !0),
              we(" " + I(d.label), 1)
            ], 10, Pl)
          ])
        ]))), 128))
      ])
    ]));
  }
}), Rl = ["aria-label", "aria-busy"], Hl = {
  key: 0,
  class: "base-pagination-total items-center gap-1.5 text-[11px] text-ui-muted font-medium whitespace-nowrap px-3 py-1.5 bg-surface-muted rounded-lg border border-ui"
}, Wl = { class: "text-ui font-bold px-1 bg-surface border border-ui rounded min-w-5 text-center" }, Ol = {
  key: 1,
  class: "base-pagination-dense-total flex items-center gap-1 text-[10px] text-ui-dim font-mono px-2 py-1 bg-surface-muted rounded-lg border border-ui"
}, jl = { class: "font-bold text-ui-muted" }, Fl = { class: "flex items-center gap-1.5" }, Kl = ["disabled", "title", "aria-label", "aria-busy"], Nl = ["disabled", "title", "aria-label", "aria-busy"], Ul = { class: "flex items-center gap-1 mx-1" }, Xl = ["aria-current", "aria-busy", "aria-label", "disabled", "onClick"], ql = {
  key: 1,
  class: "base-pagination-page-ellipsis min-w-8 h-8 items-center justify-center text-ui-dim font-medium",
  "aria-hidden": "true"
}, Yl = ["disabled", "title", "aria-label", "aria-busy"], Gl = ["disabled", "title", "aria-label", "aria-busy"], Zl = {
  key: 2,
  class: "base-pagination-page-size items-center gap-2"
}, Jl = { class: "text-[10px] uppercase text-ui-dim font-bold tracking-wider whitespace-nowrap" }, Ql = { class: "flex min-w-0 items-center gap-1.5" }, _l = { class: "truncate" }, er = /* @__PURE__ */ le({
  __name: "BasePagination",
  props: {
    modelValue: {},
    total: {},
    pageSize: {},
    pageSizes: { default: () => [10, 20, 50, 100] },
    dense: { type: Boolean, default: !1 },
    compact: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: "Loading" },
    totalLabel: { default: "Total" },
    recordsLabel: { default: "records" },
    perPageLabel: { default: "Per page" },
    rowsLabel: { default: "rows" },
    pageLabel: { default: "Page" },
    paginationLabel: { default: "Pagination" },
    showTotal: { type: Boolean, default: !0 },
    showPageSize: { type: Boolean, default: !0 },
    firstPageLabel: { default: "First page" },
    previousPageLabel: { default: "Previous page" },
    nextPageLabel: { default: "Next page" },
    lastPageLabel: { default: "Last page" }
  },
  emits: ["update:modelValue", "update:pageSize", "change"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = C(() => Math.ceil(t.total / t.pageSize) || 1), o = P(null), c = (v) => {
      const f = o.value;
      return !!(t.loading && f && f.kind === v.kind && f.value === v.value);
    }, d = (v) => c({ kind: "page", value: v }), i = (v) => c({ kind: "control", value: v }), h = () => c({ kind: "pageSize", value: t.pageSize });
    ce(() => t.loading, (v) => {
      v || (o.value = null);
    });
    const x = (v, f = { kind: "page", value: v }) => {
      v < 1 || v > n.value || v === t.modelValue || (o.value = f, a("update:modelValue", v), a("change", { page: v, pageSize: t.pageSize, reason: "page" }));
    }, y = (v) => {
      if (Array.isArray(v)) return;
      const f = typeof v == "number" ? v : parseInt(v, 10);
      !Number.isFinite(f) || f <= 0 || f === t.pageSize || (o.value = { kind: "pageSize", value: f }, a("update:pageSize", f), a("update:modelValue", 1), a("change", { page: 1, pageSize: f, reason: "pageSize" }));
    }, S = C(() => t.pageSizes.map((v) => ({
      label: `${v} ${t.rowsLabel}`,
      value: v
    }))), m = C(() => {
      const v = n.value, f = t.modelValue;
      if (v <= 7)
        return Array.from({ length: v }, (L, w) => w + 1);
      const p = [];
      if (f <= 4) {
        for (let L = 1; L <= 5; L++) p.push(L);
        p.push("..."), p.push(v);
      } else if (f >= v - 3) {
        p.push(1), p.push("...");
        for (let L = v - 4; L <= v; L++) p.push(L);
      } else
        p.push(1), p.push("..."), p.push(f - 1), p.push(f), p.push(f + 1), p.push("..."), p.push(v);
      return p;
    });
    return (v, f) => (l(), s("nav", {
      class: E(["base-pagination flex items-center px-0 sm:px-1", [e.compact ? "justify-center gap-2" : "justify-between gap-4", e.dense ? "h-10" : "py-3"]]),
      "aria-label": e.paginationLabel,
      "aria-busy": e.loading || void 0
    }, [
      !e.compact && e.showTotal ? (l(), s("div", Hl, [
        U(q, {
          name: "Database",
          size: 10,
          class: "text-ui-dim"
        }),
        u("span", null, I(e.totalLabel), 1),
        u("span", Wl, I(e.total), 1),
        u("span", null, I(e.recordsLabel), 1)
      ])) : k("", !0),
      e.dense && !e.compact ? (l(), s("div", Ol, [
        u("span", jl, I(e.total), 1)
      ])) : k("", !0),
      u("div", Fl, [
        e.compact ? k("", !0) : (l(), s("button", {
          key: 0,
          class: "base-pagination-edge p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue <= 1 || i("first"),
          title: e.firstPageLabel,
          "aria-label": e.firstPageLabel,
          "aria-busy": i("first") || void 0,
          onClick: f[0] || (f[0] = (b) => x(1, { kind: "control", value: "first" }))
        }, [
          U(q, {
            name: i("first") ? "Loader2" : "ChevronsLeft",
            size: 14,
            class: E(i("first") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, Kl)),
        u("button", {
          class: "p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue <= 1 || i("previous"),
          title: e.previousPageLabel,
          "aria-label": e.previousPageLabel,
          "aria-busy": i("previous") || void 0,
          onClick: f[1] || (f[1] = (b) => x(e.modelValue - 1, { kind: "control", value: "previous" }))
        }, [
          U(q, {
            name: i("previous") ? "Loader2" : "ChevronLeft",
            size: 14,
            class: E(i("previous") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, Nl),
        u("div", Ul, [
          (l(!0), s(te, null, oe(m.value, (b, p) => (l(), s(te, { key: p }, [
            typeof b == "number" ? (l(), s("button", {
              key: 0,
              class: E(["min-w-8 h-8 rounded-lg text-[10px] font-bold transition-all border flex items-center justify-center active:scale-95", [
                e.modelValue === b ? e.compact ? "bg-primary/15 text-primary border-primary/50 shadow-sm shadow-primary/10 ring-1 ring-primary/20" : "bg-primary/15 text-primary border-primary/50 shadow-sm shadow-primary/10" : "bg-surface text-ui-muted border-ui hover:border-ui-strong hover:text-ui shadow-xs",
                Math.abs(b - e.modelValue) > 1 && b !== 1 && b !== n.value ? "base-pagination-page-hidden" : ""
              ]]),
              "aria-current": e.modelValue === b ? "page" : void 0,
              "aria-busy": d(b) || void 0,
              "aria-label": `${e.pageLabel} ${b}`,
              disabled: d(b),
              onClick: (L) => x(b)
            }, [
              d(b) ? (l(), _(q, {
                key: 0,
                name: "Loader2",
                size: 13,
                class: "animate-spin"
              })) : (l(), s(te, { key: 1 }, [
                we(I(b), 1)
              ], 64))
            ], 10, Xl)) : (l(), s("span", ql, " ... "))
          ], 64))), 128))
        ]),
        u("button", {
          class: "p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue >= n.value || i("next"),
          title: e.nextPageLabel,
          "aria-label": e.nextPageLabel,
          "aria-busy": i("next") || void 0,
          onClick: f[2] || (f[2] = (b) => x(e.modelValue + 1, { kind: "control", value: "next" }))
        }, [
          U(q, {
            name: i("next") ? "Loader2" : "ChevronRight",
            size: 14,
            class: E(i("next") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, Yl),
        e.compact ? k("", !0) : (l(), s("button", {
          key: 1,
          class: "base-pagination-edge p-1.5 rounded-lg border border-ui bg-surface text-ui-muted hover:border-ui-strong hover:text-ui disabled:opacity-30 disabled:bg-surface-muted transition-all active:scale-95 shadow-sm",
          disabled: e.modelValue >= n.value || i("last"),
          title: e.lastPageLabel,
          "aria-label": e.lastPageLabel,
          "aria-busy": i("last") || void 0,
          onClick: f[3] || (f[3] = (b) => x(n.value, { kind: "control", value: "last" }))
        }, [
          U(q, {
            name: i("last") ? "Loader2" : "ChevronsRight",
            size: 14,
            class: E(i("last") ? "animate-spin" : "")
          }, null, 8, ["name", "class"])
        ], 8, Gl))
      ]),
      !e.compact && e.showPageSize ? (l(), s("div", Zl, [
        u("span", Jl, I(e.perPageLabel), 1),
        U(vt, {
          class: "!w-[108px] shrink-0",
          "model-value": e.pageSize,
          options: S.value,
          "aria-label": e.perPageLabel,
          "hide-chevron": h(),
          size: "sm",
          "onUpdate:modelValue": y
        }, {
          selected: se(({ selectedOptions: b }) => [
            u("span", Ql, [
              h() ? (l(), _(q, {
                key: 0,
                name: "Loader2",
                size: 12,
                class: "shrink-0 animate-spin text-primary"
              })) : k("", !0),
              u("span", _l, I(b[0]?.label), 1)
            ])
          ]),
          _: 1
        }, 8, ["model-value", "options", "aria-label", "hide-chevron"])
      ])) : k("", !0)
    ], 10, Rl));
  }
}), ei = /* @__PURE__ */ fe(er, [["__scopeId", "data-v-dd7b486c"]]), tr = { class: "w-full" }, ar = ["disabled", "aria-label", "aria-busy"], lr = {
  key: 0,
  class: "mt-2"
}, rr = { class: "flex items-center justify-between mb-1" }, nr = { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, sr = { class: "h-1.5 w-full bg-gray-100 dark:bg-dark-100 rounded-full overflow-hidden" }, or = {
  key: 1,
  class: "mt-2"
}, ir = { class: "text-xs text-gray-500 dark:text-gray-400 pl-4 list-disc space-y-1" }, ti = /* @__PURE__ */ le({
  __name: "BasePasswordInput",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    placeholder: { default: "Enter password" },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    error: { type: [String, Boolean], default: !1 },
    required: { type: Boolean, default: !1 },
    id: {},
    showStrength: { type: Boolean, default: !1 },
    showRules: { type: Boolean, default: !1 },
    toggleMask: { type: Boolean, default: !0 },
    visible: { type: Boolean, default: !1 },
    externalVisibility: { type: Boolean, default: !1 },
    visibilityLoading: { type: Boolean, default: !1 },
    size: { default: "md" },
    variant: { default: "default" },
    strengthLabel: { default: "Password strength:" },
    weakLabel: { default: "Weak" },
    mediumLabel: { default: "Medium" },
    strongLabel: { default: "Strong" },
    minLengthRuleLabel: { default: "At least 8 characters" },
    uppercaseRuleLabel: { default: "At least 1 uppercase letter" },
    lowercaseRuleLabel: { default: "At least 1 lowercase letter" },
    numberRuleLabel: { default: "At least 1 number" }
  },
  emits: ["update:modelValue", "blur", "toggle-visibility"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = P(!1), o = C(() => t.externalVisibility ? t.visible : n.value), c = () => {
      if (!(t.disabled || t.readonly || t.visibilityLoading)) {
        if (t.externalVisibility) {
          a("toggle-visibility", !t.visible);
          return;
        }
        n.value = !n.value;
      }
    }, d = C(() => {
      const x = t.modelValue || "";
      if (!x) return 0;
      let y = 0;
      return x.length >= 8 && (y += 1), /[A-Z]/.test(x) && (y += 1), /[a-z]/.test(x) && (y += 1), /[0-9]/.test(x) && (y += 1), /[^A-Za-z0-9]/.test(x) && (y += 1), y;
    }), i = C(() => t.modelValue ? d.value <= 1 ? t.weakLabel : d.value <= 3 ? t.mediumLabel : t.strongLabel : ""), h = C(() => t.modelValue ? d.value <= 1 ? "bg-red-500" : d.value <= 3 ? "bg-yellow-500" : "bg-green-500" : "bg-gray-200");
    return (x, y) => (l(), s("div", tr, [
      U(Fe, He(x.$attrs, {
        id: e.id,
        "model-value": e.modelValue,
        type: o.value ? "text" : "password",
        placeholder: e.placeholder,
        disabled: e.disabled,
        readonly: e.readonly,
        error: e.error,
        required: e.required,
        size: e.size,
        variant: e.variant,
        label: e.label,
        "onUpdate:modelValue": y[0] || (y[0] = (S) => a("update:modelValue", S)),
        onBlur: y[1] || (y[1] = (S) => a("blur", S))
      }), It({ _: 2 }, [
        e.toggleMask ? {
          name: "end",
          fn: se(() => [
            u("button", {
              type: "button",
              class: "focus:outline-none text-gray-400 dark:text-gray-500 hover:text-primary transition-all p-1.5 rounded-lg hover:bg-primary/5 dark:hover:bg-primary/20 active:bg-primary/10 dark:active:bg-primary/30",
              disabled: e.disabled || e.readonly || e.visibilityLoading,
              "aria-label": o.value ? "Hide password" : "Show password",
              "aria-busy": e.visibilityLoading,
              onClick: c
            }, [
              e.visibilityLoading ? (l(), _(Z(Ca), {
                key: 0,
                class: "w-4.5 h-4.5 animate-spin"
              })) : (l(), _(gt(o.value ? Z(La) : Z(Sa)), {
                key: 1,
                class: "w-4.5 h-4.5"
              }))
            ], 8, ar)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["id", "model-value", "type", "placeholder", "disabled", "readonly", "error", "required", "size", "variant", "label"]),
      e.showStrength && e.modelValue ? (l(), s("div", lr, [
        u("div", rr, [
          u("span", nr, I(e.strengthLabel), 1),
          u("span", {
            class: E(["text-xs font-bold", {
              "text-red-500 dark:text-red-400": d.value <= 1,
              "text-yellow-500 dark:text-yellow-400": d.value > 1 && d.value <= 3,
              "text-green-500 dark:text-green-400": d.value > 3
            }])
          }, I(i.value), 3)
        ]),
        u("div", sr, [
          u("div", {
            class: E(["h-full transition-all duration-300 ease-out rounded-full", h.value]),
            style: re({ width: `${d.value / 5 * 100}%` })
          }, null, 6)
        ])
      ])) : k("", !0),
      e.showRules ? (l(), s("div", or, [
        N(x.$slots, "rules", {}, () => [
          u("ul", ir, [
            u("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": e.modelValue.length >= 8 })
            }, I(e.minLengthRuleLabel), 3),
            u("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": /[A-Z]/.test(e.modelValue) })
            }, I(e.uppercaseRuleLabel), 3),
            u("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": /[a-z]/.test(e.modelValue) })
            }, I(e.lowercaseRuleLabel), 3),
            u("li", {
              class: E({ "text-green-600 dark:text-green-400 font-medium": /[0-9]/.test(e.modelValue) })
            }, I(e.numberRuleLabel), 3)
          ])
        ])
      ])) : k("", !0)
    ]));
  }
}), ur = ["onClick"], dr = { class: "font-medium" }, cr = /* @__PURE__ */ le({
  __name: "BaseSplitButton",
  props: {
    label: {},
    menuItems: { default: () => [] },
    menuLabel: { default: "More actions" },
    size: { default: "md" },
    variant: { default: "primary" },
    disabled: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 },
    menuPlacement: { default: "bottom-start" },
    menuOffset: { default: 8 },
    menuWidth: { default: "w-48" },
    menuClassName: { default: "custom-scrollbar" },
    menuPadding: { default: "py-1" }
  },
  emits: ["click"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = P(!1), o = (d) => {
      t.disabled || a("click", d);
    }, c = (d) => {
      t.disabled || (d.command(), n.value = !1);
    };
    return (d, i) => (l(), s("div", {
      class: E(["relative items-stretch split-action-button-container", e.block ? "flex w-full" : "inline-flex"])
    }, [
      U(et, {
        label: e.label,
        size: e.size,
        variant: e.variant,
        disabled: e.disabled,
        block: e.block,
        class: E(["z-10 min-w-0", [
          { "rounded-r-none": e.menuItems.length > 0 },
          e.block ? "flex-1" : ""
        ]]),
        onClick: o
      }, null, 8, ["label", "size", "variant", "disabled", "block", "class"]),
      e.menuItems.length > 0 ? (l(), _(qa, {
        key: 0,
        visible: n.value,
        "onUpdate:visible": i[0] || (i[0] = (h) => n.value = h),
        size: e.size,
        variant: e.variant,
        disabled: e.disabled,
        "aria-label": e.menuLabel,
        "has-popup": "menu",
        "chevron-size": e.size === "sm" ? 8 : 10,
        placement: e.menuPlacement,
        offset: e.menuOffset,
        "popover-width": e.menuWidth,
        "popover-padding": e.menuPadding,
        "popover-class-name": e.menuClassName,
        class: "shrink-0 rounded-l-none border-l border-white/20 -ml-px min-w-8 px-2"
      }, {
        popover: se(() => [
          u("div", null, [
            (l(!0), s(te, null, oe(e.menuItems, (h, x) => (l(), s("button", {
              key: x,
              class: "flex w-full items-center gap-2.5 px-4 py-2.5 text-left text-xs text-gray-700 transition-colors hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-dark-200",
              type: "button",
              onClick: (y) => c(h)
            }, [
              h.icon ? (l(), _(q, {
                key: 0,
                name: h.icon,
                class: "text-gray-400 dark:text-gray-500",
                size: 12
              }, null, 8, ["name"])) : k("", !0),
              u("span", dr, I(h.label), 1)
            ], 8, ur))), 128))
          ])
        ]),
        _: 1
      }, 8, ["visible", "size", "variant", "disabled", "aria-label", "chevron-size", "placement", "offset", "popover-width", "popover-padding", "popover-class-name"])) : k("", !0)
    ], 2));
  }
}), ai = /* @__PURE__ */ fe(cr, [["__scopeId", "data-v-c1fa8d54"]]), fr = { class: "flex flex-col w-full" }, mr = ["disabled", "onClick"], vr = { key: 0 }, br = {
  key: 1,
  class: "flex-1 min-h-0 flex flex-col w-full relative"
}, gr = {
  key: 0,
  class: "flex-1 min-h-0 flex flex-col"
}, hr = /* @__PURE__ */ le({
  __name: "BaseTabs",
  props: {
    modelValue: {},
    tabs: { default: () => [] },
    variant: { default: "default" },
    transitionMode: { default: "none" },
    tabListClass: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = dt(t, "modelValue");
    lt("activeTab", n), lt("updateTab", (i) => {
      n.value !== i && (a("change", i, n.value), a("update:modelValue", i));
    }), lt("variant", dt(t, "variant")), lt("transitionMode", dt(t, "transitionMode"));
    const o = C(() => t.tabs.filter((i) => i.visible !== !1)), c = C(() => t.transitionMode === "none" ? "" : t.transitionMode === "slide" ? "tab-slide" : "tab-fade"), d = (i) => {
      n.value !== i && (a("change", i, n.value), a("update:modelValue", i));
    };
    return (i, h) => (l(), s("div", fr, [
      e.tabs.length > 0 ? (l(), s("div", {
        key: 0,
        class: E(["flex border-b border-gray-200 dark:border-dark-200 bg-gray-50/50 dark:bg-dark-50/50 rounded-t-lg overflow-hidden shrink-0 overflow-x-auto", e.tabListClass])
      }, [
        U(qe, {
          name: "tabs-list",
          tag: "div",
          class: "flex w-full"
        }, {
          default: se(() => [
            (l(!0), s(te, null, oe(o.value, (x) => (l(), s("button", {
              key: x.id,
              type: "button",
              disabled: x.disabled,
              class: E(["px-6 py-3 text-sm font-semibold transition-all cursor-pointer border-b-2 flex items-center gap-2 whitespace-nowrap", [
                n.value === x.id ? "text-primary border-primary" : "text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-dark-200",
                x.disabled ? "opacity-50 cursor-not-allowed hover:bg-transparent hover:text-gray-500 dark:hover:text-gray-600" : ""
              ]]),
              onClick: (y) => d(x.id)
            }, [
              N(i.$slots, `tab-${x.id}`, {}, () => [
                x.emoji ? (l(), s("span", vr, I(x.emoji), 1)) : k("", !0),
                x.icon ? (l(), _(q, {
                  key: 1,
                  name: x.icon,
                  size: 16
                }, null, 8, ["name"])) : k("", !0),
                u("span", null, I(x.label), 1)
              ], !0)
            ], 10, mr))), 128))
          ]),
          _: 3
        })
      ], 2)) : k("", !0),
      e.tabs.length > 0 ? (l(), s("div", br, [
        U(ke, {
          name: c.value,
          mode: "out-in"
        }, {
          default: se(() => [
            (l(), s("div", {
              key: n.value,
              class: "flex-1 min-h-0 flex flex-col w-full"
            }, [
              (l(!0), s(te, null, oe(o.value, (x) => (l(), s(te, {
                key: x.id
              }, [
                n.value === x.id ? (l(), s("div", gr, [
                  N(i.$slots, x.id, {}, void 0, !0)
                ])) : k("", !0)
              ], 64))), 128))
            ]))
          ]),
          _: 3
        }, 8, ["name"])
      ])) : N(i.$slots, "default", { key: 2 }, void 0, !0)
    ]));
  }
}), li = /* @__PURE__ */ fe(hr, [["__scopeId", "data-v-63b42ec4"]]), yr = ["disabled"], pr = { key: 0 }, ri = /* @__PURE__ */ le({
  __name: "BaseTab",
  props: {
    value: {},
    icon: {},
    emoji: {},
    disabled: { type: Boolean }
  },
  setup(e) {
    const r = e, t = Re("activeTab"), a = Re("updateTab"), n = C(() => t?.value === r.value), o = () => {
      !r.disabled && a && a(r.value);
    };
    return (c, d) => (l(), s("button", {
      type: "button",
      disabled: e.disabled,
      class: E(["px-6 py-3 text-sm font-semibold transition-all cursor-pointer border-b-2 flex items-center gap-2 whitespace-nowrap", [
        n.value ? "text-primary border-primary" : "text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-dark-200",
        e.disabled ? "opacity-50 cursor-not-allowed hover:bg-transparent hover:text-gray-500 dark:hover:text-gray-600" : ""
      ]]),
      onClick: o
    }, [
      e.emoji ? (l(), s("span", pr, I(e.emoji), 1)) : k("", !0),
      e.icon ? (l(), _(q, {
        key: 1,
        name: e.icon,
        size: 16
      }, null, 8, ["name"])) : k("", !0),
      N(c.$slots, "default", {}, () => [
        u("span", null, [
          N(c.$slots, "label")
        ])
      ])
    ], 10, yr));
  }
}), ni = /* @__PURE__ */ le({
  __name: "BaseTabList",
  setup(e) {
    const r = Re("variant");
    return (t, a) => (l(), s("div", {
      class: E(["flex border-b border-gray-200 dark:border-dark-200 bg-gray-50/50 dark:bg-dark-50/50 rounded-t-lg overflow-hidden shrink-0 overflow-x-auto", { "gap-1 p-1": Z(r) === "compact" }])
    }, [
      N(t.$slots, "default")
    ], 2));
  }
}), xr = { class: "w-full relative" }, wr = /* @__PURE__ */ le({
  __name: "BaseTabPanels",
  setup(e) {
    const r = Re("activeTab"), t = Re("transitionMode"), a = C(() => t?.value === "none" ? "" : t?.value === "slide" ? "tab-slide" : "tab-fade");
    return (n, o) => (l(), s("div", xr, [
      U(ke, {
        name: a.value,
        mode: "out-in"
      }, {
        default: se(() => [
          (l(), s("div", {
            key: Z(r),
            class: "w-full"
          }, [
            N(n.$slots, "default", {}, void 0, !0)
          ]))
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), si = /* @__PURE__ */ fe(wr, [["__scopeId", "data-v-24cf149f"]]), oi = /* @__PURE__ */ le({
  __name: "BaseTabPanel",
  props: {
    value: {}
  },
  setup(e) {
    const r = Re("activeTab");
    return (t, a) => ht((l(), s("div", null, [
      N(t.$slots, "default")
    ], 512)), [
      [Yt, Z(r) === e.value]
    ]);
  }
}), kr = {
  key: 0,
  class: "my-1 border-t border-gray-100 dark:border-white/8"
}, $r = ["disabled", "onClick"], ii = /* @__PURE__ */ le({
  __name: "BaseContextMenu",
  props: {
    menu: {},
    teleportTo: { default: "#app" }
  },
  emits: ["close"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = P(null);
    ce(() => t.menu, async (d) => {
      if (!d) return;
      await pe();
      const i = n.value;
      if (!i) return;
      const { innerWidth: h, innerHeight: x } = window, { offsetWidth: y, offsetHeight: S } = i;
      d.x + y > h && (i.style.left = `${h - y - 8}px`), d.y + S > x && (i.style.top = `${x - S - 8}px`);
    });
    function o(d) {
      d.disabled || (d.action(), a("close"));
    }
    function c(d) {
      d.target.closest("[data-context-menu]") || a("close");
    }
    return ce(() => t.menu, (d) => {
      d ? window.addEventListener("mousedown", c, !0) : window.removeEventListener("mousedown", c, !0);
    }, { immediate: !0 }), it(() => window.removeEventListener("mousedown", c, !0)), (d, i) => (l(), _(De, { to: e.teleportTo }, [
      e.menu ? (l(), s("div", {
        key: 0,
        ref_key: "menuRef",
        ref: n,
        "data-context-menu": "",
        class: "fixed z-[9999] min-w-[160px] py-1 rounded-lg shadow-xl border border-gray-200 dark:border-white/10 bg-white dark:bg-dark-100 text-sm",
        style: re({ left: `${e.menu.x}px`, top: `${e.menu.y}px` })
      }, [
        (l(!0), s(te, null, oe(e.menu.items, (h, x) => (l(), s(te, { key: x }, [
          h.label === "---" ? (l(), s("div", kr)) : (l(), s("button", {
            key: 1,
            class: E(["w-full flex items-center gap-2.5 px-3 py-1.5 transition-colors text-left", [
              h.disabled ? "text-gray-300 dark:text-gray-600 cursor-not-allowed" : h.danger ? "text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10" : "text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-dark-200"
            ]]),
            disabled: h.disabled,
            onClick: (y) => o(h)
          }, [
            h.icon ? (l(), _(q, {
              key: 0,
              name: h.icon,
              size: 13,
              class: "shrink-0 opacity-70"
            }, null, 8, ["name"])) : k("", !0),
            u("span", null, I(h.label), 1)
          ], 10, $r))
        ], 64))), 128))
      ], 4)) : k("", !0)
    ], 8, ["to"]));
  }
}), Cr = { class: "relative w-full" }, Lr = { class: "flex items-center relative" }, Sr = {
  key: 0,
  class: "px-3 py-4 text-center"
}, zr = { class: "text-[10px] text-ui-muted mt-1" }, Br = {
  key: 0,
  class: "base-autocomplete-group-label px-3 pt-3 pb-1 text-[11px] font-black uppercase tracking-widest text-ui-muted",
  role: "presentation",
  "aria-hidden": "true"
}, Tr = ["onMousedown"], Mr = { class: "truncate flex-1 text-ui-muted" }, Er = {
  key: 1,
  class: "px-3 py-6 text-center text-ui-muted"
}, Ir = { class: "text-[10px] mb-1" }, Dr = {
  key: 2,
  class: "border-t border-ui px-3 py-2.5 text-center text-ui-muted",
  role: "status"
}, Vr = { class: "text-[10px]" }, Ar = {
  key: 3,
  class: "border-t border-ui px-3 py-2 text-center text-[10px] text-ui-muted",
  role: "status"
}, ui = /* @__PURE__ */ le({
  __name: "BaseAutocomplete",
  props: {
    modelValue: {},
    options: {},
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    itemKey: { default: "id" },
    displayKey: { default: "name" },
    searchKeys: { default: () => ["name"] },
    size: { default: "md" },
    variant: { default: "default" },
    loading: { type: Boolean, default: !1 },
    label: { default: "" },
    error: { type: [String, Boolean] },
    loadingLabel: { default: "Searching..." },
    loadingMore: { type: Boolean, default: !1 },
    loadingMoreLabel: { default: "Loading more..." },
    hasMore: { type: Boolean, default: void 0 },
    endLabel: { default: "End of list" },
    emptyLabel: { default: "No options available" },
    noMatchesLabel: { default: "No matching items" },
    teleportTo: { default: "body" }
  },
  emits: ["update:modelValue", "select", "toggle", "reach-end"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = P(!1), o = P(!1), c = P({}), d = P(null), i = P(!1), h = P(""), x = C(() => d.value?.$el?.querySelector("input")), y = C(() => {
      if (o.value || !h.value.trim())
        return t.options;
      const V = h.value.toLowerCase();
      return t.options.filter((B) => t.searchKeys.some((O) => {
        const j = S(B, O);
        return j && String(j).toLowerCase().includes(V);
      }));
    });
    function S(V, B) {
      return V ? V[B] : void 0;
    }
    const m = (V) => {
      const B = V ? String(V) : "";
      a("update:modelValue", B), h.value = B, o.value = !1, n.value = !0, w();
    }, v = () => {
      i.value = !0, o.value = !0, h.value = "", n.value = !0, a("toggle", !0), w(), setTimeout(() => {
        x.value?.select();
      }, 0);
    }, f = () => {
      n.value || (o.value = !0, h.value = "", n.value = !0, a("toggle", !0), w()), setTimeout(() => {
        x.value?.select();
      }, 0);
    }, b = () => {
      setTimeout(() => {
        n.value = !1;
      }, 200);
    }, p = (V) => {
      a("update:modelValue", String(S(V, t.displayKey) ?? "")), a("select", V), n.value = !1, o.value = !1;
    }, L = (V) => {
      if (t.loadingMore || t.hasMore !== !0) return;
      const B = V.currentTarget;
      B && B.scrollHeight - B.scrollTop - B.clientHeight <= 24 && a("reach-end");
    };
    function w() {
      const V = x.value || d.value?.$el;
      if (!V) return;
      const B = V.getBoundingClientRect();
      c.value = {
        position: "fixed",
        top: `${B.bottom}px`,
        left: `${B.left}px`,
        width: `${B.width}px`
      };
    }
    const M = (V) => {
      t.disabled || (V && (V.preventDefault(), V.stopPropagation()), n.value = !n.value, a("toggle", n.value), n.value && (o.value = !0, w(), setTimeout(() => {
        x.value?.focus(), x.value?.select();
      }, 50)));
    };
    ce(n, (V) => {
      V ? (window.addEventListener("resize", w), window.addEventListener("scroll", w, !0)) : (window.removeEventListener("resize", w), window.removeEventListener("scroll", w, !0));
    }), it(() => {
      window.removeEventListener("resize", w), window.removeEventListener("scroll", w, !0);
    });
    const F = (V) => {
      const B = S(V, t.displayKey);
      return !B || !t.modelValue ? !1 : String(B).trim().toLowerCase() === String(t.modelValue).trim().toLowerCase();
    };
    return (V, B) => (l(), s("div", Cr, [
      u("div", Lr, [
        U(Fe, {
          ref_key: "baseInputRef",
          ref: d,
          "model-value": e.modelValue,
          placeholder: e.placeholder,
          disabled: e.disabled,
          size: e.size,
          variant: e.variant,
          "input-class": e.size === "sm" ? "h-8" : void 0,
          label: e.label,
          error: e.error,
          autocomplete: "off",
          "onUpdate:modelValue": m,
          onFocus: v,
          onClick: f,
          onBlur: b
        }, {
          end: se(() => [
            e.disabled ? k("", !0) : (l(), s("button", {
              key: 0,
              type: "button",
              class: "text-ui-muted hover:text-primary transition-all cursor-pointer focus:outline-none p-1 -mr-1",
              tabindex: "-1",
              onMousedown: me(M, ["stop"])
            }, [
              u("div", {
                class: E(["transition-transform duration-200", { "rotate-180": n.value }])
              }, [
                U(q, {
                  name: "ChevronDown",
                  size: e.size === "sm" ? 16 : 18
                }, null, 8, ["size"])
              ], 2)
            ], 32))
          ]),
          _: 1
        }, 8, ["model-value", "placeholder", "disabled", "size", "variant", "input-class", "label", "error"])
      ]),
      (l(), _(De, { to: e.teleportTo }, [
        n.value ? (l(), s("div", {
          key: 0,
          class: "fixed z-9999 mt-1 bg-surface border border-ui text-ui shadow-xl max-h-60 overflow-y-auto min-w-30 custom-scrollbar",
          style: re(c.value),
          onScroll: L
        }, [
          e.loading && e.options.length === 0 ? (l(), s("div", Sr, [
            U(q, {
              name: "Loader2",
              class: "animate-spin text-primary",
              size: 14
            }),
            u("div", zr, I(e.loadingLabel), 1)
          ])) : (l(), s(te, { key: 1 }, [
            y.value.length > 0 ? (l(!0), s(te, { key: 0 }, oe(y.value, (O) => (l(), s(te, {
              key: String(S(O, e.itemKey))
            }, [
              S(O, "group") && S(y.value[y.value.indexOf(O) - 1], "group") !== S(O, "group") ? (l(), s("div", Br, I(S(O, "group")), 1)) : k("", !0),
              u("div", {
                class: E(["px-3 py-2 text-xs cursor-pointer transition-colors hover:bg-primary/15 hover:text-primary-light flex items-center justify-between gap-2", { "bg-primary/15 text-primary-light font-bold": F(O) }]),
                onMousedown: me((j) => p(O), ["prevent"])
              }, [
                u("div", Mr, [
                  N(V.$slots, "default", { item: O }, () => [
                    we(I(S(O, e.displayKey)), 1)
                  ])
                ]),
                F(O) ? (l(), _(q, {
                  key: 0,
                  name: "Check",
                  class: "text-primary",
                  size: 10
                })) : k("", !0)
              ], 42, Tr)
            ], 64))), 128)) : (l(), s("div", Er, [
              u("div", Ir, I(e.options.length === 0 ? e.emptyLabel : e.noMatchesLabel), 1)
            ])),
            e.loadingMore ? (l(), s("div", Dr, [
              U(q, {
                name: "Loader2",
                class: "mr-1 inline-block animate-spin text-primary",
                size: 13
              }),
              u("span", Vr, I(e.loadingMoreLabel), 1)
            ])) : e.hasMore === !1 && e.options.length > 0 ? (l(), s("div", Ar, I(e.endLabel), 1)) : k("", !0)
          ], 64))
        ], 36)) : k("", !0)
      ], 8, ["to"]))
    ]));
  }
}), Pr = { class: "flex items-center gap-3 rounded-lg bg-gray-800 px-4 py-3 select-none" }, Rr = ["disabled"], Hr = {
  key: 0,
  viewBox: "0 0 24 24",
  class: "ml-0.5 h-4 w-4",
  fill: "currentColor"
}, Wr = {
  key: 1,
  viewBox: "0 0 24 24",
  class: "h-4 w-4",
  fill: "currentColor"
}, Or = { class: "w-10 flex-shrink-0 text-right text-xs text-gray-400 tabular-nums" }, jr = { class: "w-10 flex-shrink-0 text-xs text-gray-400 tabular-nums" }, di = /* @__PURE__ */ le({
  __name: "BaseAudioPlayer",
  props: {
    autoplay: { type: Boolean }
  },
  emits: ["ended", "error"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = P(!1), c = P(0), d = P(0), i = P(0);
    let h = null, x = null, y = null, S = 0, m = 0, v = 0;
    function f() {
      return h || (h = new AudioContext()), h;
    }
    function b($) {
      const A = f(), z = $.reduce((he, X) => he + X.length, 0), K = $[0], de = K.sampleRate, ue = K.numberOfChannels, ie = A.createBuffer(ue, z, de);
      for (let he = 0; he < ue; he++) {
        const X = ie.getChannelData(he);
        let Y = 0;
        for (const Q of $)
          X.set(Q.getChannelData(he), Y), Y += Q.length;
      }
      return ie;
    }
    async function p($) {
      const A = f();
      try {
        const z = await A.decodeAudioData($.slice(0));
        y = b(y ? [y, z] : [z]), d.value = y.duration, a.autoplay && !o.value && w();
      } catch (z) {
        n("error", z instanceof Error ? z : new Error(String(z)));
      }
    }
    async function L($) {
      const A = f();
      try {
        const K = await (await fetch($)).arrayBuffer();
        y = await A.decodeAudioData(K), d.value = y.duration, a.autoplay && w();
      } catch (z) {
        n("error", z instanceof Error ? z : new Error(String(z)));
      }
    }
    function w() {
      if (!y || o.value) return;
      const $ = f();
      $.state === "suspended" && $.resume(), x = $.createBufferSource(), x.buffer = y, x.connect($.destination), x.onended = () => {
        o.value && (o.value = !1, c.value = 100, i.value = d.value, cancelAnimationFrame(v), n("ended"));
      };
      const A = m;
      x.start(0, A), S = $.currentTime - A, o.value = !0, B();
    }
    function M() {
      !o.value || !x || !h || (m = h.currentTime - S, x.onended = null, x.stop(), x = null, o.value = !1, cancelAnimationFrame(v));
    }
    function F() {
      o.value ? M() : w();
    }
    function V($) {
      if (!y) return;
      const z = $.currentTarget.getBoundingClientRect(), K = Math.max(0, Math.min(1, ($.clientX - z.left) / z.width)), de = o.value;
      de && M(), m = K * d.value, i.value = m, c.value = K * 100, de && w();
    }
    function B() {
      if (!o.value || !h) return;
      const $ = h.currentTime - S;
      i.value = Math.min($, d.value), c.value = d.value > 0 ? i.value / d.value * 100 : 0, v = requestAnimationFrame(B);
    }
    function O() {
      M(), y = null, c.value = 0, d.value = 0, i.value = 0, m = 0, S = 0;
    }
    function j($) {
      const A = Math.floor($ / 60), z = Math.floor($ % 60);
      return `${A}:${z.toString().padStart(2, "0")}`;
    }
    const J = C(() => !!y);
    return it(() => {
      if (cancelAnimationFrame(v), x) {
        x.onended = null;
        try {
          x.stop();
        } catch {
        }
      }
      h && h.close();
    }), r({
      appendChunk: p,
      loadAudio: L,
      play: w,
      pause: M,
      reset: O
    }), ($, A) => (l(), s("div", Pr, [
      u("button", {
        disabled: !J.value,
        class: E(["flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full transition-colors", J.value ? "bg-blue-600 text-white hover:bg-blue-500" : "cursor-not-allowed bg-gray-700 text-gray-500"]),
        onClick: F
      }, [
        o.value ? (l(), s("svg", Wr, [...A[1] || (A[1] = [
          u("rect", {
            x: "6",
            y: "4",
            width: "4",
            height: "16"
          }, null, -1),
          u("rect", {
            x: "14",
            y: "4",
            width: "4",
            height: "16"
          }, null, -1)
        ])])) : (l(), s("svg", Hr, [...A[0] || (A[0] = [
          u("polygon", { points: "6,4 20,12 6,20" }, null, -1)
        ])]))
      ], 10, Rr),
      u("span", Or, I(j(i.value)), 1),
      u("div", {
        class: "relative h-2 flex-1 cursor-pointer overflow-hidden rounded-full bg-gray-700",
        onClick: V
      }, [
        u("div", {
          class: "h-full rounded-full bg-blue-500 transition-[width] duration-100",
          style: re({ width: `${c.value}%` })
        }, null, 4)
      ]),
      u("span", jr, I(j(d.value)), 1)
    ]));
  }
}), Me = [];
let Ne = typeof window < "u" && "CloseWatcher" in window;
function ci() {
  Ne = !1, Nt();
}
let ot = 0, Ct = !1;
function Nt() {
  Ct || Ne || (Ct = !0, window.addEventListener("popstate", () => {
    if (ot > 0) {
      ot--;
      return;
    }
    Me.at(-1)?.();
  }));
}
function fi() {
  return Me;
}
function Fr() {
  Nt();
  const e = P(!1), r = [];
  let t;
  function a() {
    if (r.length > 0) {
      r.pop()();
      return;
    }
    const i = Me.lastIndexOf(a);
    i !== -1 && Me.splice(i, 1), e.value = !1, t?.();
  }
  function n(i) {
    e.value || (t = i, Me.push(a), Ne || history.pushState({ mobileEntry: !0 }, ""), e.value = !0);
  }
  function o() {
    if (!e.value) return;
    const i = 1 + r.length;
    r.length = 0;
    const h = Me.lastIndexOf(a);
    h !== -1 && Me.splice(h, 1), e.value = !1, Ne || (ot++, history.go(-i));
  }
  function c(i) {
    e.value && (r.push(i), Ne || history.pushState({ mobileStep: !0 }, ""));
  }
  function d() {
    r.length !== 0 && (r.pop(), Ne || (ot++, history.back()));
  }
  return Ie(() => {
    if (e.value) {
      const i = Me.lastIndexOf(a);
      i !== -1 && Me.splice(i, 1), e.value = !1;
    }
  }), { push: n, consume: o, pushBackStep: c, popBackStep: d, pushed: e };
}
const Kr = ["aria-label"], Nr = { class: "p-1.5 rounded-full hover:bg-primary/10 flex items-center justify-center text-ui-muted hover:text-ui" }, Ur = { class: "flex-1 min-w-0 mr-4" }, Xr = {
  key: 0,
  class: "text-base md:text-lg font-bold text-ui truncate"
}, qr = { class: "flex items-center gap-1 shrink-0" }, Yr = {
  key: 0,
  class: "flex items-center"
}, Gr = {
  key: 0,
  class: "w-px h-6 bg-ui-border mx-1.5 sm:mx-2.5"
}, Zr = ["title"], Jr = { class: "p-1.5 rounded-full hover:bg-primary/10 flex items-center justify-center text-ui-muted hover:text-ui" }, Qr = { class: "p-1.5 rounded-full hover:bg-primary/10 flex items-center justify-center text-ui-muted hover:text-ui" }, _r = { class: "flex items-center justify-end gap-2 w-full" }, en = "body", tn = 100, je = 300, nt = 200, an = /* @__PURE__ */ le({
  inheritAttrs: !1,
  __name: "BaseDialog",
  props: {
    visible: { type: Boolean, default: !1 },
    header: {},
    dialogLabel: { default: "" },
    width: { default: "auto" },
    maxWidth: { default: "md" },
    modal: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    dismissableMask: { type: Boolean, default: !1 },
    blockScroll: { type: Boolean, default: !0 },
    contentClass: { default: "" },
    bodyClass: { default: "" },
    blurBackground: { type: Boolean, default: !1 },
    draggable: { type: Boolean, default: !0 },
    zIndex: { default: 2e3 },
    fullScreen: { type: Boolean, default: !1 },
    maximizable: { type: Boolean, default: !1 },
    mobileStyle: { default: "modal" },
    customBack: { type: Boolean, default: !1 },
    height: {},
    minHeight: {},
    resizable: { type: Boolean, default: !1 },
    resizeStorageKey: {},
    hideHeaderMobile: { type: Boolean },
    bodyOverflow: { default: "auto" },
    keyboardAware: { type: Boolean, default: !1 }
  },
  emits: ["update:visible", "update:fullScreen", "show", "after-show", "hide", "close", "maximize", "back", "viewport-resize", "after-hide"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t, o = C(() => {
      const H = {
        sm: "max-w-sm w-full",
        md: "max-w-md w-full",
        lg: "max-w-lg w-full",
        xl: "max-w-xl w-full",
        "2xl": "max-w-2xl w-full",
        "3xl": "max-w-3xl w-full",
        "4xl": "max-w-4xl w-full",
        "5xl": "max-w-5xl w-full",
        "6xl": "max-w-6xl w-full",
        "7xl": "max-w-7xl w-full",
        "8xl": "max-w-8xl w-full",
        full: "max-w-full w-full",
        none: ""
      };
      return H[a.maxWidth] || H.md;
    }), c = C(() => a.mobileStyle === "sheet"), d = C(() => `w-full h-full max-w-full sm:w-full sm:h-auto sm:max-h-[90%] ${{
      sm: "sm:max-w-sm",
      md: "sm:max-w-md",
      lg: "sm:max-w-lg",
      xl: "sm:max-w-xl",
      "2xl": "sm:max-w-2xl",
      "3xl": "sm:max-w-3xl",
      "4xl": "sm:max-w-4xl",
      "5xl": "sm:max-w-5xl",
      "6xl": "sm:max-w-6xl",
      "7xl": "sm:max-w-7xl",
      "8xl": "sm:max-w-8xl",
      full: "sm:max-w-full",
      none: ""
    }[a.maxWidth] || "sm:max-w-md"}`), i = Wt(), h = C(() => c.value && i.value), x = P(null);
    let y = null, S = 0;
    yt(() => {
      if (a.keyboardAware && window.visualViewport) {
        S = window.visualViewport.height;
        let H = !1;
        y = () => {
          const G = window.visualViewport.height, ee = S - G;
          ee > tn && !H ? (H = !0, x.value = G, n("viewport-resize", G)) : ee < 50 && H && (H = !1, x.value = null, n("viewport-resize", S));
        }, window.visualViewport.addEventListener("resize", y);
      }
    });
    const m = P({ x: 0, y: 0 }), v = P(!1), f = P({ x: 0, y: 0 }), b = C(() => {
      const H = {};
      if ((m.value.x !== 0 || m.value.y !== 0) && (H["--dialog-tx"] = `${m.value.x}px`, H["--dialog-ty"] = `${m.value.y}px`), !a.fullScreen)
        if (O.value ? (H.width = `${O.value}px`, H.maxWidth = `${O.value}px`) : a.width && a.width !== "auto" && (H.width = a.width, H.maxWidth = a.width), a.keyboardAware && x.value) {
          const ee = i.value ? x.value : Math.min(x.value - 48, 700);
          H.height = `${ee}px`, H.maxHeight = `${ee}px`;
        } else j.value && (H.height = `${j.value}px`, H.maxHeight = `${j.value}px`);
      return H;
    }), p = C(() => {
      const H = {};
      return !a.fullScreen && !h.value && !j.value && (a.height && (H.height = a.height), a.minHeight && (H.minHeight = a.minHeight)), H;
    }), L = (H) => {
      a.draggable && (H.target.closest("button, a, input, textarea") || (v.value = !0, f.value = { x: H.clientX - m.value.x, y: H.clientY - m.value.y }, document.addEventListener("mousemove", w), document.addEventListener("mouseup", M)));
    }, w = (H) => {
      if (v.value) {
        if (H.buttons === 0) {
          M();
          return;
        }
        m.value = { x: H.clientX - f.value.x, y: H.clientY - f.value.y };
      }
    }, M = () => {
      v.value = !1, document.removeEventListener("mousemove", w), document.removeEventListener("mouseup", M);
    }, F = () => {
      m.value = { x: 0, y: 0 };
    };
    function V() {
      if (!a.resizeStorageKey) return null;
      try {
        const H = localStorage.getItem(a.resizeStorageKey);
        if (H) {
          const { w: G, h: ee } = JSON.parse(H);
          if (typeof G == "number" && typeof ee == "number") return { w: G, h: ee };
        }
      } catch {
      }
      return null;
    }
    const B = V(), O = P(B?.w ?? null), j = P(B?.h ?? null), J = P(!1), $ = P("se"), A = P({ mouseX: 0, mouseY: 0, width: 0, height: 0, tx: 0, ty: 0 });
    function z() {
      if (!(!a.resizeStorageKey || !O.value || !j.value))
        try {
          localStorage.setItem(a.resizeStorageKey, JSON.stringify({ w: O.value, h: j.value }));
        } catch {
        }
    }
    function K(H, G) {
      if (!a.resizable) return;
      H.preventDefault(), H.stopPropagation();
      const ee = Y.value;
      if (!ee) return;
      const ne = ee.getBoundingClientRect();
      J.value = !0, $.value = G, A.value = { mouseX: H.clientX, mouseY: H.clientY, width: ne.width, height: ne.height, tx: m.value.x, ty: m.value.y }, document.addEventListener("mousemove", de), document.addEventListener("mouseup", ue);
    }
    function de(H) {
      if (!J.value) return;
      if (H.buttons === 0) {
        ue();
        return;
      }
      const { mouseX: G, mouseY: ee, width: ne, height: xe, tx: ye, ty: ze } = A.value, Be = H.clientX - G, We = H.clientY - ee, Ve = window.innerWidth - 48, T = window.innerHeight - 48, D = $.value;
      if (D === "s") {
        const R = Math.min(T, Math.max(nt, xe + We));
        j.value = R, m.value = { x: ye, y: ze + (R - xe) / 2 };
        return;
      }
      if (D === "n") {
        const R = Math.min(T, Math.max(nt, xe - We));
        j.value = R, m.value = { x: ye, y: ze - (R - xe) / 2 };
        return;
      }
      if (D === "e") {
        const R = Math.min(Ve, Math.max(je, ne + Be));
        O.value = R, m.value = { x: ye + (R - ne) / 2, y: ze };
        return;
      }
      if (D === "w") {
        const R = Math.min(Ve, Math.max(je, ne - Be));
        O.value = R, m.value = { x: ye - (R - ne) / 2, y: ze };
        return;
      }
      if (D === "se" || D === "sw") {
        const R = Math.min(T, Math.max(nt, xe + We));
        j.value = R;
        const ae = D === "se" ? Math.min(Ve, Math.max(je, ne + Be)) : Math.min(Ve, Math.max(je, ne - Be));
        O.value = ae, m.value = { x: D === "se" ? ye + (ae - ne) / 2 : ye - (ae - ne) / 2, y: ze + (R - xe) / 2 };
        return;
      }
      const g = Math.min(T, Math.max(nt, xe - We));
      j.value = g;
      const W = D === "ne" ? Math.min(Ve, Math.max(je, ne + Be)) : Math.min(Ve, Math.max(je, ne - Be));
      O.value = W, m.value = { x: D === "ne" ? ye + (W - ne) / 2 : ye - (W - ne) / 2, y: ze - (g - xe) / 2 };
    }
    function ue() {
      J.value = !1, z(), document.removeEventListener("mousemove", de), document.removeEventListener("mouseup", ue);
    }
    const ie = () => {
      n("after-show");
    }, he = () => {
      F(), n("after-hide");
    }, X = () => {
      n("update:visible", !1), n("close");
    }, Y = P(null), Q = () => {
      const H = Y.value, G = !a.fullScreen;
      if (!H) {
        n("update:fullScreen", G), n("maximize", G);
        return;
      }
      const ee = H.getBoundingClientRect();
      n("update:fullScreen", G), n("maximize", G), pe(() => {
        const ne = H.getBoundingClientRect(), xe = ee.width / ne.width, ye = ee.height / ne.height, ze = ee.left + ee.width / 2 - (ne.left + ne.width / 2), Be = ee.top + ee.height / 2 - (ne.top + ne.height / 2);
        H.animate([
          { transform: `translate(${ze}px, ${Be}px) scale(${xe}, ${ye})`, borderRadius: G ? "12px" : "0px" },
          { transform: "translate(0, 0) scale(1, 1)", borderRadius: G ? "0px" : "12px" }
        ], { duration: 350, easing: "cubic-bezier(0.4, 0, 0.2, 1)" });
      });
    }, be = () => {
      a.dismissableMask && a.closable && X();
    };
    let Ye = null;
    function at() {
      return Array.from(Y.value?.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      ) ?? []).filter((H) => H.getClientRects().length > 0);
    }
    function ut() {
      const [H] = at();
      H?.focus();
    }
    const ge = (H) => {
      if (!a.visible) return;
      if (a.closeOnEscape && H.key === "Escape") {
        H.preventDefault(), X();
        return;
      }
      if (H.key !== "Tab") return;
      const G = at();
      if (!G.length) return;
      const ee = G[0], ne = G[G.length - 1];
      H.shiftKey && document.activeElement === ee ? (H.preventDefault(), ne.focus()) : !H.shiftKey && document.activeElement === ne && (H.preventDefault(), ee.focus());
    }, { push: Ce, consume: Te, pushBackStep: Le, popBackStep: Se } = Fr();
    return r({ pushBackStep: Le, popBackStep: Se, wrapperRef: Y }), ce(() => a.visible, (H) => {
      H ? (Ye = document.activeElement instanceof HTMLElement ? document.activeElement : null, n("show"), a.blockScroll && (document.body.style.overflow = "hidden"), window.addEventListener("keydown", ge), pe(ut), (c.value || a.fullScreen) && window.innerWidth < 640 && Ce(X)) : (n("hide"), a.blockScroll && (document.body.style.overflow = ""), window.removeEventListener("keydown", ge), Ye?.focus(), Ye = null, Te());
    }, { immediate: !0 }), Ie(() => {
      a.blockScroll && (document.body.style.overflow = ""), window.removeEventListener("keydown", ge), document.removeEventListener("mousemove", w), document.removeEventListener("mouseup", M), document.removeEventListener("mousemove", de), document.removeEventListener("mouseup", ue), y && window.visualViewport?.removeEventListener("resize", y);
    }), (H, G) => (l(), _(De, { to: en }, [
      U(ke, {
        name: h.value ? "dialog-slide" : "dialog",
        appear: "",
        onAfterEnter: ie,
        onAfterLeave: he
      }, {
        default: se(() => [
          e.visible ? (l(), s("div", {
            key: 0,
            class: E(["fixed inset-0 flex justify-center", {
              "pointer-events-none": !e.modal,
              "p-4 sm:p-6": !e.fullScreen && !c.value,
              "sm:p-6": c.value && !e.fullScreen,
              "select-none": J.value,
              "items-start": e.keyboardAware && !!x.value && h.value,
              "items-center": !(e.keyboardAware && x.value && h.value)
            }]),
            style: re({ zIndex: e.zIndex }),
            onMousedown: G[10] || (G[10] = me(() => {
            }, ["stop"]))
          }, [
            e.modal ? (l(), s("div", {
              key: 0,
              class: E(["fixed inset-0 bg-black/40 transition-opacity dialog-backdrop", { "backdrop-blur-[2px]": e.blurBackground }]),
              onClick: be
            }, null, 2)) : k("", !0),
            u("div", {
              ref_key: "wrapperRef",
              ref: Y,
              class: E(["relative z-10 dialog-scale-wrapper flex flex-col pointer-events-auto origin-center", [e.fullScreen ? "w-full h-full max-w-full" : c.value ? d.value : `${o.value} max-h-[90%]`]]),
              style: re(b.value)
            }, [
              u("div", {
                class: E(["base-dialog-panel relative shadow-2xl w-full h-full flex flex-col overflow-hidden border bg-surface text-ui border-ui", [e.contentClass, e.fullScreen ? "max-h-full rounded-none" : c.value ? "max-h-full rounded-none sm:rounded-xl" : "rounded-xl"]]),
                style: re(p.value),
                role: "dialog",
                "aria-modal": "true",
                "aria-label": e.dialogLabel || e.header || void 0
              }, [
                H.$slots.header || e.header || e.closable ? (l(), s("div", {
                  key: 0,
                  class: E(["base-dialog-header border-b border-ui flex items-center min-h-12 md:min-h-14 shrink-0 transition-all duration-500", [
                    e.fullScreen ? "px-4 py-2" : h.value ? "px-3 py-3" : "px-6 py-3",
                    { "cursor-move select-none": e.draggable },
                    { "max-sm:hidden": e.hideHeaderMobile }
                  ]]),
                  onMousedown: L,
                  onDblclick: G[1] || (G[1] = (ee) => {
                    e.maximizable && !h.value && !ee.target.closest("button, a, input") && Q();
                  })
                }, [
                  e.closable && h.value ? (l(), s("button", {
                    key: 0,
                    type: "button",
                    title: "返回",
                    "aria-label": "返回",
                    "data-testid": "base-dialog-mobile-back",
                    onClick: G[0] || (G[0] = (ee) => e.customBack ? n("back") : X()),
                    class: "flex items-center justify-center mr-2 shrink-0 transition-colors"
                  }, [
                    u("div", Nr, [
                      U(q, {
                        name: "ArrowLeft",
                        size: 18
                      })
                    ])
                  ])) : k("", !0),
                  u("div", Ur, [
                    N(H.$slots, "header", {}, () => [
                      e.header ? (l(), s("h3", Xr, I(e.header), 1)) : k("", !0)
                    ], !0)
                  ]),
                  u("div", qr, [
                    H.$slots.actions ? (l(), s("div", Yr, [
                      N(H.$slots, "actions", {}, void 0, !0),
                      h.value ? k("", !0) : (l(), s("div", Gr))
                    ])) : k("", !0),
                    e.maximizable && e.closable && !h.value ? (l(), s("button", {
                      key: 1,
                      onClick: Q,
                      class: "flex items-center justify-center transition-colors group/max",
                      title: e.fullScreen ? "還原視窗" : "全螢幕顯示"
                    }, [
                      u("div", Jr, [
                        U(q, {
                          name: e.fullScreen ? "minimize-2" : "maximize-2",
                          size: 14
                        }, null, 8, ["name"])
                      ])
                    ], 8, Zr)) : k("", !0),
                    e.closable && !h.value ? (l(), s("button", {
                      key: 2,
                      onClick: X,
                      class: "flex items-center justify-center transition-colors group/close",
                      title: "關閉對話框"
                    }, [
                      u("div", Qr, [
                        U(q, {
                          name: "X",
                          size: 14
                        })
                      ])
                    ])) : k("", !0)
                  ])
                ], 34)) : k("", !0),
                H.$slots["body-top"] ? (l(), s("div", {
                  key: 1,
                  class: E(["base-dialog-body-top shrink-0 border-b border-ui", e.fullScreen ? "px-3 py-2 md:px-6" : "px-6 py-4"])
                }, [
                  N(H.$slots, "body-top", {}, void 0, !0)
                ], 2)) : k("", !0),
                u("div", {
                  class: E(["base-dialog-body flex-1", [e.bodyClass, e.bodyOverflow === "hidden" ? "overflow-hidden" : "overflow-y-auto custom-scrollbar", e.fullScreen ? "px-3 py-2 md:px-6 md:py-4" : "px-6 py-4"]])
                }, [
                  N(H.$slots, "default", {}, void 0, !0)
                ], 2),
                H.$slots.footer ? (l(), s("div", {
                  key: 2,
                  class: E(["border-t border-ui bg-surface-muted rounded-b-xl shrink-0", e.fullScreen ? "px-4 py-3" : "px-6 py-4"])
                }, [
                  u("div", _r, [
                    N(H.$slots, "footer", {}, void 0, !0)
                  ])
                ], 2)) : k("", !0)
              ], 14, Kr),
              e.resizable && !e.fullScreen && !h.value ? (l(), s(te, { key: 0 }, [
                u("div", {
                  class: "absolute right-0 top-0 w-2 h-full cursor-ew-resize z-20",
                  onMousedown: G[2] || (G[2] = me((ee) => K(ee, "e"), ["stop"]))
                }, null, 32),
                u("div", {
                  class: "absolute left-0 top-0 w-2 h-full cursor-ew-resize z-20",
                  onMousedown: G[3] || (G[3] = me((ee) => K(ee, "w"), ["stop"]))
                }, null, 32),
                u("div", {
                  class: "absolute top-0 left-0 h-2 w-full cursor-ns-resize z-20",
                  onMousedown: G[4] || (G[4] = me((ee) => K(ee, "n"), ["stop"]))
                }, null, 32),
                u("div", {
                  class: "absolute bottom-0 left-0 h-2 w-full cursor-ns-resize z-20",
                  onMousedown: G[5] || (G[5] = me((ee) => K(ee, "s"), ["stop"]))
                }, null, 32),
                u("div", {
                  class: "absolute top-0 right-0 w-5 h-5 cursor-nesw-resize z-30",
                  onMousedown: G[6] || (G[6] = me((ee) => K(ee, "ne"), ["stop"]))
                }, null, 32),
                u("div", {
                  class: "absolute top-0 left-0 w-5 h-5 cursor-nwse-resize z-30",
                  onMousedown: G[7] || (G[7] = me((ee) => K(ee, "nw"), ["stop"]))
                }, null, 32),
                u("div", {
                  class: "absolute bottom-0 right-0 w-5 h-5 cursor-nwse-resize z-30 group/rs",
                  onMousedown: G[8] || (G[8] = me((ee) => K(ee, "se"), ["stop"]))
                }, [...G[11] || (G[11] = [
                  u("svg", {
                    class: "absolute bottom-0.5 right-0.5 w-2.5 h-2.5 text-ui-dim opacity-0 group-hover/rs:opacity-100 transition-opacity",
                    viewBox: "0 0 10 10"
                  }, [
                    u("path", {
                      d: "M9 1L1 9M9 5L5 9",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)
                ])], 32),
                u("div", {
                  class: "absolute bottom-0 left-0 w-5 h-5 cursor-nesw-resize z-30 group/rs",
                  onMousedown: G[9] || (G[9] = me((ee) => K(ee, "sw"), ["stop"]))
                }, [...G[12] || (G[12] = [
                  u("svg", {
                    class: "absolute bottom-0.5 left-0.5 w-2.5 h-2.5 text-ui-dim opacity-0 group-hover/rs:opacity-100 transition-opacity",
                    viewBox: "0 0 10 10"
                  }, [
                    u("path", {
                      d: "M1 1L9 9M1 5L5 9",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ], -1)
                ])], 32)
              ], 64)) : k("", !0)
            ], 6)
          ], 38)) : k("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), ln = /* @__PURE__ */ fe(an, [["__scopeId", "data-v-c3b94749"]]), rn = {
  key: 0,
  class: "flex flex-shrink-0 justify-center pt-3"
}, nn = {
  key: 1,
  class: "flex flex-shrink-0 items-center justify-between gap-3 px-4 py-3"
}, sn = { class: "min-w-0" }, on = "body", Lt = "Close drawer", un = /* @__PURE__ */ le({
  inheritAttrs: !1,
  __name: "BaseDrawer",
  props: {
    visible: { type: Boolean, default: !1 },
    title: {},
    subtitle: {},
    position: { default: "bottom" },
    theme: { default: "light" },
    modal: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    dismissableMask: { type: Boolean, default: !0 },
    zIndex: { default: 2200 },
    maxHeight: { default: "72vh" },
    width: { default: "24rem" },
    showHandle: { type: Boolean, default: !0 },
    panelClass: { default: "" },
    bodyClass: { default: "" }
  },
  emits: ["update:visible", "close", "after-hide"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = C(() => t.position === "left" ? "base-drawer-left" : t.position === "right" ? "base-drawer-right" : "base-drawer-bottom"), o = C(() => t.position === "right" ? "right-0 top-0 h-full rounded-l-2xl" : t.position === "left" ? "left-0 top-0 h-full rounded-r-2xl" : "inset-x-0 bottom-0 rounded-t-3xl"), c = C(() => t.position === "bottom" ? "w-full" : "max-w-[92vw]"), d = C(() => t.position === "bottom" ? { maxHeight: t.maxHeight } : { width: t.width }), i = C(() => t.theme === "dark" ? "border-white/10 bg-[#0b1320] text-white shadow-black/50" : "border-slate-200 bg-white text-slate-950 shadow-slate-900/20"), h = C(() => t.theme === "dark" ? "bg-black/45" : "bg-slate-950/35"), x = C(() => t.theme === "dark" ? "bg-white/20" : "bg-slate-300"), y = C(() => t.theme === "dark" ? "text-white" : "text-slate-950"), S = C(() => t.theme === "dark" ? "text-slate-400" : "text-slate-500"), m = C(() => t.theme === "dark" ? "bg-white/8 text-slate-200 hover:bg-white/12" : "bg-slate-100 text-slate-700 hover:bg-slate-200"), v = C(() => t.theme === "dark" ? "border-white/10" : "border-slate-200");
    function f() {
      a("update:visible", !1), a("close");
    }
    function b() {
      a("after-hide");
    }
    function p() {
      t.dismissableMask && f();
    }
    function L(w) {
      w.key === "Escape" && t.closeOnEscape && t.visible && f();
    }
    return ce(() => t.visible, (w) => {
      document.body.style.overflow = w ? "hidden" : "";
    }), yt(() => document.addEventListener("keydown", L)), Ie(() => {
      document.removeEventListener("keydown", L), document.body.style.overflow = "";
    }), (w, M) => (l(), _(De, { to: on }, [
      U(ke, {
        name: n.value,
        appear: "",
        onAfterLeave: b
      }, {
        default: se(() => [
          e.visible ? (l(), s("div", {
            key: 0,
            class: "fixed inset-0",
            style: re({ zIndex: e.zIndex })
          }, [
            e.modal ? (l(), s("button", {
              key: 0,
              type: "button",
              class: E(["absolute inset-0 transition-colors", h.value]),
              "aria-label": Lt,
              onClick: p
            }, null, 2)) : k("", !0),
            u("section", {
              class: E(["absolute flex flex-col overflow-hidden border shadow-2xl", [o.value, c.value, e.panelClass, i.value]]),
              style: re(d.value),
              role: "dialog",
              "aria-modal": "true"
            }, [
              e.showHandle && e.position === "bottom" ? (l(), s("div", rn, [
                u("span", {
                  class: E(["h-1.5 w-11 rounded-full", x.value])
                }, null, 2)
              ])) : k("", !0),
              w.$slots.header || e.title || e.closable ? (l(), s("header", nn, [
                u("div", sn, [
                  N(w.$slots, "header", {}, () => [
                    e.title ? (l(), s("p", {
                      key: 0,
                      class: E(["truncate text-sm font-semibold", y.value])
                    }, I(e.title), 3)) : k("", !0),
                    e.subtitle ? (l(), s("p", {
                      key: 1,
                      class: E(["mt-0.5 truncate text-xs", S.value])
                    }, I(e.subtitle), 3)) : k("", !0)
                  ], !0)
                ]),
                e.closable ? (l(), s("button", {
                  key: 0,
                  type: "button",
                  class: E(["flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full transition-colors", m.value]),
                  "aria-label": Lt,
                  onClick: f
                }, [
                  U(q, {
                    name: "X",
                    size: 16
                  })
                ], 2)) : k("", !0)
              ])) : k("", !0),
              u("div", {
                class: E(["base-drawer-body custom-scrollbar min-h-0 flex-1 overflow-y-auto px-4 pb-4", e.bodyClass])
              }, [
                N(w.$slots, "default", {}, void 0, !0)
              ], 2),
              w.$slots.footer ? (l(), s("footer", {
                key: 2,
                class: E(["flex flex-shrink-0 items-center justify-end gap-2 border-t px-4 py-3", v.value])
              }, [
                N(w.$slots, "footer", {}, void 0, !0)
              ], 2)) : k("", !0)
            ], 6)
          ], 4)) : k("", !0)
        ]),
        _: 3
      }, 8, ["name"])
    ]));
  }
}), mi = /* @__PURE__ */ fe(un, [["__scopeId", "data-v-daaade83"]]), dn = { class: "overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-xs custom-scrollbar dark:border-dark-200 dark:bg-dark-50" }, cn = { class: "w-full min-w-250 border-collapse text-left" }, fn = { class: "border-b border-gray-200 bg-gray-50 dark:border-dark-200 dark:bg-dark-100" }, mn = {
  key: 0,
  class: "w-24 px-3 py-2.5 text-center text-[11px] font-bold uppercase tracking-wider text-gray-700 dark:text-gray-300"
}, vn = { class: "divide-y divide-gray-200 dark:divide-gray-700" }, bn = {
  key: 3,
  class: "text-gray-900 dark:text-gray-200"
}, gn = {
  key: 0,
  class: "border-r border-gray-200 px-3 py-2 text-center text-xs last:border-r-0 dark:border-dark-200"
}, hn = { class: "flex items-center justify-center gap-2" }, yn = ["title", "aria-label"], pn = ["title", "aria-label"], xn = ["title", "aria-label", "onClick"], wn = ["title", "aria-label", "onClick"], kn = {
  key: 0,
  class: "bg-primary/5 transition-colors hover:bg-primary/10 dark:bg-primary/10 dark:hover:bg-primary/15"
}, $n = {
  key: 3,
  class: "text-gray-400 italic dark:text-gray-500"
}, Cn = { class: "border-r border-gray-200 px-3 py-2 text-center text-xs last:border-r-0 dark:border-dark-200" }, Ln = ["title", "aria-label"], Sn = {
  key: 1,
  class: "border-t-2 border-gray-200 bg-gray-50/80 font-bold dark:border-dark-200 dark:bg-dark-100/80"
}, zn = ["colspan"], Bn = { class: "flex w-full items-center justify-between" }, Tn = { class: "text-left text-gray-700 dark:text-gray-300" }, Mn = { class: "text-right text-gray-700 dark:text-gray-300" }, En = { class: "px-3 py-3 text-right text-sm whitespace-nowrap text-primary" }, vi = /* @__PURE__ */ le({
  __name: "BaseEditableTable",
  props: {
    data: {},
    columns: {},
    editingIndex: {},
    editingRow: {},
    newItem: {},
    totalLabel: {},
    totalValue: {},
    readonly: { type: Boolean, default: !1 },
    actionsLabel: { default: "Actions" },
    saveLabel: { default: "Save" },
    cancelLabel: { default: "Cancel" },
    editLabel: { default: "Edit" },
    deleteLabel: { default: "Delete" },
    addLabel: { default: "Add" },
    autoLabel: { default: "Auto" }
  },
  emits: ["start-edit", "save-edit", "cancel-edit", "remove-row", "add-item"],
  setup(e, { emit: r }) {
    const t = r, a = (n) => n === "center" ? "text-center" : n === "right" ? "text-right" : "text-left";
    return (n, o) => (l(), s("div", dn, [
      u("table", cn, [
        u("thead", null, [
          u("tr", fn, [
            (l(!0), s(te, null, oe(e.columns, (c) => (l(), s("th", {
              key: c.key,
              style: re({ width: c.width }),
              class: E(["border-r border-gray-200 px-3 py-2.5 text-[11px] font-bold uppercase tracking-wider whitespace-pre-line text-gray-700 last:border-r-0 dark:border-dark-200 dark:text-gray-300", a(c.align)])
            }, I(c.label), 7))), 128)),
            e.readonly ? k("", !0) : (l(), s("th", mn, I(e.actionsLabel), 1))
          ])
        ]),
        u("tbody", vn, [
          (l(!0), s(te, null, oe(e.data, (c, d) => (l(), s("tr", {
            key: d,
            class: E([d % 2 === 1 ? "bg-gray-50/50 dark:bg-dark-100/30" : "bg-white dark:bg-dark-50/40", "transition-colors hover:bg-primary/5 dark:hover:bg-primary/10"])
          }, [
            (l(!0), s(te, null, oe(e.columns, (i) => (l(), s("td", {
              key: i.key,
              class: E(["border-r border-gray-200 px-3 py-2 text-xs last:border-r-0 dark:border-dark-200", a(i.align)])
            }, [
              e.editingIndex === d && e.editingRow ? N(n.$slots, `edit-${i.key}`, {
                key: 0,
                row: e.editingRow,
                index: d
              }, () => [
                i.type === "text" ? (l(), _(Fe, {
                  key: 0,
                  modelValue: e.editingRow[i.key],
                  "onUpdate:modelValue": (h) => e.editingRow[i.key] = h,
                  placeholder: i.placeholder,
                  size: "sm"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : i.type === "number" ? (l(), _(Fe, {
                  key: 1,
                  modelValue: e.editingRow[i.key],
                  "onUpdate:modelValue": (h) => e.editingRow[i.key] = h,
                  modelModifiers: { number: !0 },
                  type: "number",
                  step: "any",
                  placeholder: i.placeholder,
                  size: "sm",
                  class: E({ "text-right": i.align === "right" })
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class"])) : i.type === "select" ? (l(), _(vt, {
                  key: 2,
                  modelValue: e.editingRow[i.key],
                  "onUpdate:modelValue": (h) => e.editingRow[i.key] = h,
                  options: i.options || [],
                  size: "sm"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])) : (l(), s("span", bn, I(c[i.key]), 1))
              ]) : N(n.$slots, `cell-${i.key}`, {
                key: 1,
                row: c,
                index: d
              }, () => [
                u("span", {
                  class: E(i.type === "readonly" ? "text-gray-500 dark:text-gray-400" : "text-gray-900 dark:text-gray-200")
                }, I(c[i.key]), 3)
              ])
            ], 2))), 128)),
            e.readonly ? k("", !0) : (l(), s("td", gn, [
              u("div", hn, [
                e.editingIndex === d ? (l(), s(te, { key: 0 }, [
                  u("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-green-600 transition-colors hover:bg-green-50 dark:text-green-400 dark:hover:bg-green-900/20",
                    title: e.saveLabel,
                    "aria-label": e.saveLabel,
                    onClick: o[0] || (o[0] = (i) => t("save-edit"))
                  }, [
                    U(q, {
                      name: "Save",
                      size: 14
                    })
                  ], 8, yn),
                  u("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-gray-400 transition-colors hover:bg-gray-100 dark:text-gray-500 dark:hover:bg-dark-200",
                    title: e.cancelLabel,
                    "aria-label": e.cancelLabel,
                    onClick: o[1] || (o[1] = (i) => t("cancel-edit"))
                  }, [
                    U(q, {
                      name: "X",
                      size: 14
                    })
                  ], 8, pn)
                ], 64)) : (l(), s(te, { key: 1 }, [
                  u("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-primary transition-colors hover:bg-primary/5 dark:hover:bg-primary/10",
                    title: e.editLabel,
                    "aria-label": e.editLabel,
                    onClick: (i) => t("start-edit", d)
                  }, [
                    U(q, {
                      name: "Pencil",
                      size: 14
                    })
                  ], 8, xn),
                  u("button", {
                    type: "button",
                    class: "rounded-full p-1.5 text-red-600 transition-colors hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-900/20",
                    title: e.deleteLabel,
                    "aria-label": e.deleteLabel,
                    onClick: (i) => t("remove-row", d)
                  }, [
                    U(q, {
                      name: "Trash2",
                      size: 14
                    })
                  ], 8, wn)
                ], 64))
              ])
            ]))
          ], 2))), 128)),
          e.readonly ? k("", !0) : (l(), s("tr", kn, [
            (l(!0), s(te, null, oe(e.columns, (c) => (l(), s("td", {
              key: c.key,
              class: E(["border-r border-gray-200 px-3 py-2 text-xs last:border-r-0 dark:border-dark-200", a(c.align)])
            }, [
              N(n.$slots, `new-${c.key}`, { row: e.newItem }, () => [
                c.type === "text" ? (l(), _(Fe, {
                  key: 0,
                  modelValue: e.newItem[c.key],
                  "onUpdate:modelValue": (d) => e.newItem[c.key] = d,
                  placeholder: c.placeholder,
                  size: "sm",
                  onKeyup: o[2] || (o[2] = xt((d) => t("add-item"), ["enter"]))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])) : c.type === "number" ? (l(), _(Fe, {
                  key: 1,
                  modelValue: e.newItem[c.key],
                  "onUpdate:modelValue": (d) => e.newItem[c.key] = d,
                  modelModifiers: { number: !0 },
                  type: "number",
                  step: "any",
                  placeholder: c.placeholder,
                  size: "sm",
                  class: E({ "text-right": c.align === "right" }),
                  onKeyup: o[3] || (o[3] = xt((d) => t("add-item"), ["enter"]))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class"])) : c.type === "select" ? (l(), _(vt, {
                  key: 2,
                  modelValue: e.newItem[c.key],
                  "onUpdate:modelValue": (d) => e.newItem[c.key] = d,
                  options: c.options || [],
                  size: "sm"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])) : (l(), s("span", $n, I(e.autoLabel), 1))
              ])
            ], 2))), 128)),
            u("td", Cn, [
              u("button", {
                type: "button",
                class: "mx-auto flex items-center justify-center rounded-full p-1.5 text-primary transition-colors hover:bg-primary/5 dark:hover:bg-primary/10",
                title: e.addLabel,
                "aria-label": e.addLabel,
                onClick: o[4] || (o[4] = (c) => t("add-item"))
              }, [
                U(q, {
                  name: "Plus",
                  size: 16
                })
              ], 8, Ln)
            ])
          ])),
          e.totalLabel ? (l(), s("tr", Sn, [
            u("td", {
              colspan: e.readonly ? e.columns.length - 1 : e.columns.length,
              class: "px-3 py-3 text-sm"
            }, [
              u("div", Bn, [
                u("span", Tn, [
                  N(n.$slots, "footer-left")
                ]),
                u("span", Mn, I(e.totalLabel) + ": ", 1)
              ])
            ], 8, zn),
            u("td", En, I(e.totalValue), 1)
          ])) : k("", !0)
        ])
      ])
    ]));
  }
}), In = ["aria-busy"], Dn = {
  key: 0,
  class: "base-table-header-cell px-4 py-3.5 w-10 text-center sticky top-0 z-10 backdrop-blur-md"
}, Vn = ["checked", "indeterminate"], An = ["onClick"], Pn = {
  key: 0,
  class: "text-[10px] text-primary animate-in fade-in zoom-in duration-300"
}, Rn = ["data-table-row-kind", "data-table-row-key", "onClick"], Hn = ["checked", "onChange"], Wn = {
  key: 0,
  class: "flex items-center gap-2"
}, On = ["colspan"], jn = {
  key: 0,
  class: "base-table-skeleton-table w-full border-collapse text-left text-xs",
  "aria-hidden": "true"
}, Fn = {
  key: 0,
  class: "base-table-cell px-4 py-3 w-10"
}, Kn = {
  key: 1,
  class: "base-table-empty-state flex flex-col items-center justify-center py-12"
}, Nn = { class: "base-table-empty-icon w-16 h-16 rounded-full flex items-center justify-center text-3xl mb-4 border shadow-inner" }, Un = { class: "base-table-empty-title text-sm font-bold mb-1" }, Xn = {
  key: 0,
  class: "base-table-empty-description text-[11px] max-w-xs text-center"
}, qn = ["aria-label"], Yn = { class: "sr-only" }, Gn = /* @__PURE__ */ le({
  __name: "BaseTable",
  props: {
    columns: {},
    data: {},
    sortField: { default: "" },
    sortDirection: { default: "" },
    loading: { type: Boolean, default: !1 },
    emptyMessage: { default: "No data" },
    emptyDescription: {},
    emptyIcon: { default: "Inbox" },
    loadingLabel: { default: "Loading" },
    rowKey: { type: [String, Function], default: "id" },
    rowAttrs: {},
    rowTransition: { default: "slide" },
    expandable: { type: Boolean, default: !1 },
    expandedRows: {},
    highlightIds: {},
    disableTransition: { type: Boolean, default: !1 },
    minHeight: { default: "" },
    fixedLayout: { type: Boolean, default: !1 },
    rowClass: {},
    selectable: { type: Boolean, default: !1 },
    selection: { default: () => /* @__PURE__ */ new Set() },
    selectionKey: { type: [String, Function], default: "id" },
    hoverable: { type: Boolean, default: !0 },
    striped: { type: Boolean, default: !1 },
    emptyText: {},
    headerClass: { default: "" }
  },
  emits: ["sort", "update:expandedRows", "row-click", "update:selection"],
  setup(e, { emit: r }) {
    const t = e, a = C(() => t.emptyMessage), n = C(() => t.emptyDescription || ""), o = P(t.disableTransition);
    ce(
      () => t.disableTransition,
      ($) => {
        $ ? o.value = !0 : setTimeout(() => {
          o.value = !1;
        }, 100);
      },
      { immediate: !0 }
    );
    const c = r, d = P(/* @__PURE__ */ new Set()), i = ($) => (t.expandedRows || d.value).has($), h = ($) => {
      const A = new Set(t.expandedRows || d.value);
      A.has($) ? A.delete($) : A.add($), t.expandedRows ? c("update:expandedRows", A) : d.value = A;
    }, x = ($, A) => {
      t.expandable && h(A), c("row-click", $, A);
    }, y = C(() => t.columns.filter(($) => $.visible !== !1)), S = ($) => {
      c("sort", $);
    }, m = ($) => typeof t.selectionKey == "function" ? t.selectionKey($) : String($[t.selectionKey] ?? ""), v = ($) => t.selection.has(m($)), f = ($) => {
      const A = m($), z = new Set(t.selection);
      z.has(A) ? z.delete(A) : z.add(A), c("update:selection", z);
    }, b = C(() => t.data.length === 0 ? !1 : t.data.every(($) => t.selection.has(m($)))), p = C(() => {
      if (t.data.length === 0) return !1;
      const $ = t.data.filter(
        (A) => t.selection.has(m(A))
      ).length;
      return $ > 0 && $ < t.data.length;
    }), L = () => {
      const $ = new Set(t.selection);
      b.value ? t.data.forEach((A) => $.delete(m(A))) : t.data.forEach((A) => $.add(m(A))), c("update:selection", $);
    }, w = ($, A) => typeof t.rowKey == "function" ? t.rowKey($) : String($[t.rowKey] ?? A), M = ($, A) => {
      const z = String(A).split(".");
      let K = $;
      for (const de of z) {
        if (K == null || typeof K != "object") return null;
        K = K[de];
      }
      return K;
    }, F = ($, A) => {
      const z = M($, A.key);
      return z == null ? "-" : A.formatter ? A.formatter(z, $) : Array.isArray(z) ? z.join(", ") : String(z);
    }, V = ($) => {
      const A = [];
      return $.key === "name" ? A.push("font-medium") : $.key === "id" && A.push("font-mono text-[10px]"), A.join(" ");
    }, B = C(() => o.value || t.rowTransition === "none" ? "" : t.rowTransition === "fade-collapse" ? "base-table-fade-collapse" : "list"), O = ($, A, z) => t.rowAttrs?.($, A, z) || {}, j = ($, A) => {
      if (t.rowTransition !== "fade-collapse" || o.value || typeof window > "u") {
        A();
        return;
      }
      const z = $, K = z.getBoundingClientRect().height;
      z.style.height = `${K}px`, z.style.overflow = "hidden", z.style.pointerEvents = "none", window.requestAnimationFrame(() => {
        z.style.height = "0px", z.style.opacity = "0";
      }), window.setTimeout(A, 200);
    }, J = C(() => {
      const $ = [];
      return t.data.forEach((A, z) => {
        const K = w(A, z);
        $.push({ type: "main", row: A, index: z, key: K }), t.expandable && i(K) && $.push({ type: "expanded", row: A, index: z, key: `${K}-expanded` });
      }), $;
    });
    return ($, A) => (l(), s("div", {
      class: E([
        "base-table-surface overflow-auto custom-scrollbar border rounded-2xl shadow-sm relative transition-all duration-300",
        { "no-transitions": o.value }
      ]),
      "aria-busy": e.loading,
      style: re(e.minHeight ? { minHeight: e.minHeight } : {})
    }, [
      u("table", {
        class: E([
          "w-full border-collapse text-left text-xs",
          { "table-fixed": e.fixedLayout }
        ])
      }, [
        u("thead", null, [
          u("tr", {
            class: E(e.headerClass)
          }, [
            e.selectable ? (l(), s("th", Dn, [
              u("input", {
                type: "checkbox",
                checked: b.value,
                indeterminate: p.value,
                onChange: L,
                class: "rounded border-gray-300 text-primary focus:ring-primary w-4 h-4 cursor-pointer"
              }, null, 40, Vn)
            ])) : k("", !0),
            (l(!0), s(te, null, oe(y.value, (z) => (l(), s("th", {
              key: String(z.key),
              class: E([
                "base-table-header-cell px-4 py-3.5 font-bold transition-all duration-200 group sticky top-0 z-10 backdrop-blur-md",
                z.sortable ? "base-table-header-cell--sortable cursor-pointer" : "",
                z.align === "center" ? "text-center" : z.align === "right" ? "text-right" : "text-left"
              ]),
              style: re(z.width ? { width: z.width } : {}),
              onClick: (K) => z.sortable ? S(z.key) : null
            }, [
              N($.$slots, `header-${String(z.key)}`, { column: z }, () => [
                u("div", {
                  class: E(["flex items-center gap-1.5", z.align === "center" ? "justify-center" : z.align === "right" ? "justify-end" : ""])
                }, [
                  u("span", null, I(z.label), 1),
                  z.sortable && e.sortField === z.key ? (l(), s("span", Pn, I(e.sortDirection === "asc" ? "↑" : "↓"), 1)) : z.sortable ? (l(), _(q, {
                    key: 1,
                    name: "ChevronDown",
                    size: 10,
                    class: "opacity-0 group-hover:opacity-30 transition-opacity"
                  })) : k("", !0)
                ], 2)
              ], !0)
            ], 14, An))), 128))
          ], 2)
        ]),
        U(qe, {
          name: B.value,
          css: !o.value && e.rowTransition !== "none",
          tag: "tbody",
          onLeave: j
        }, {
          default: se(() => [
            (l(!0), s(te, null, oe(J.value, (z) => (l(), s("tr", He({
              key: z.key,
              "data-table-row-kind": z.type,
              "data-table-row-key": z.key
            }, { ref_for: !0 }, O(z.row, z.key, z.type), {
              class: [
                "base-table-row transition-colors duration-200 border-b",
                z.type === "main" ? " hover:bg-primary/5 dark:hover:bg-primary/10 cursor-pointer" + (e.highlightIds?.includes(z.key) ? " animate-highlight" : "") : " whitespace-normal",
                z.type === "main" && e.rowClass ? typeof e.rowClass == "function" ? e.rowClass(z.row) : e.rowClass : ""
              ],
              onClick: (K) => z.type === "main" ? x(z.row, z.key) : null
            }), [
              z.type === "main" ? (l(), s(te, { key: 0 }, [
                e.selectable ? (l(), s("td", {
                  key: 0,
                  class: "base-table-cell px-4 py-3 w-10 text-center",
                  onClick: A[0] || (A[0] = me(() => {
                  }, ["stop"]))
                }, [
                  u("input", {
                    type: "checkbox",
                    checked: v(z.row),
                    onChange: (K) => f(z.row),
                    class: "rounded border-gray-300 text-primary focus:ring-primary w-4 h-4 cursor-pointer"
                  }, null, 40, Hn)
                ])) : k("", !0),
                (l(!0), s(te, null, oe(y.value, (K) => (l(), s("td", {
                  key: String(K.key),
                  class: E([
                    "base-table-cell px-4 py-3 min-w-25",
                    K.key === "id" || K.key === "_id" || String(K.key).toLowerCase().includes("id") ? "whitespace-nowrap" : "",
                    K.align === "center" ? "text-center" : K.align === "right" ? "text-right" : "text-left",
                    V(K)
                  ])
                }, [
                  e.expandable && K === y.value[0] ? (l(), s("div", Wn, [
                    U(q, {
                      name: "ChevronRight",
                      size: 10,
                      class: E(["base-table-expand-icon transition-transform duration-300", { "rotate-90": i(z.key) }])
                    }, null, 8, ["class"]),
                    N($.$slots, `cell-${String(K.key)}`, {
                      row: z.row,
                      column: K,
                      value: M(z.row, K.key)
                    }, () => [
                      we(I(F(z.row, K)), 1)
                    ], !0)
                  ])) : N($.$slots, `cell-${String(K.key)}`, {
                    key: 1,
                    row: z.row,
                    column: K,
                    value: M(z.row, K.key)
                  }, () => [
                    we(I(F(z.row, K)), 1)
                  ], !0)
                ], 2))), 128))
              ], 64)) : (l(), s("td", {
                key: 1,
                colspan: y.value.length + (e.selectable ? 1 : 0),
                class: "base-table-expanded-cell px-4 py-4 border-t"
              }, [
                N($.$slots, "expanded-row", {
                  row: z.row,
                  index: z.index
                }, void 0, !0)
              ], 8, On))
            ], 16, Rn))), 128))
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2),
      e.loading && e.data.length === 0 ? (l(), s("table", jn, [
        u("tbody", null, [
          (l(), s(te, null, oe(5, (z) => u("tr", {
            key: `loading-skeleton-${z}`,
            class: "base-table-row border-b"
          }, [
            e.selectable ? (l(), s("td", Fn, [...A[1] || (A[1] = [
              u("div", { class: "base-table-skeleton-block mx-auto h-4 w-4 rounded" }, null, -1)
            ])])) : k("", !0),
            (l(!0), s(te, null, oe(y.value, (K) => (l(), s("td", {
              key: String(K.key),
              class: "base-table-cell px-4 py-3"
            }, [
              u("div", {
                class: E(["base-table-skeleton-block h-3 rounded", K.align === "right" ? "ml-auto w-2/3" : "w-3/4"])
              }, null, 2)
            ]))), 128))
          ])), 64))
        ])
      ])) : k("", !0),
      e.data.length === 0 && !e.loading ? (l(), s("div", Kn, [
        N($.$slots, "empty", {}, () => [
          u("div", Nn, [
            U(q, { name: e.emptyIcon }, null, 8, ["name"])
          ]),
          u("h3", Un, I(a.value), 1),
          n.value ? (l(), s("p", Xn, I(n.value), 1)) : k("", !0)
        ], !0)
      ])) : k("", !0),
      U(ke, {
        "enter-active-class": "transition-opacity duration-300",
        "leave-active-class": "transition-opacity duration-300",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: se(() => [
          e.loading && e.data.length > 0 ? (l(), s("div", {
            key: 0,
            class: "base-table-loading pointer-events-none absolute inset-x-0 top-0 z-20 h-0.5 overflow-hidden",
            role: "status",
            "aria-label": e.loadingLabel
          }, [
            A[2] || (A[2] = u("div", { class: "base-table-loading-progress h-full w-2/5" }, null, -1)),
            N($.$slots, "loading", {}, () => [
              u("span", Yn, I(e.loadingLabel), 1)
            ], !0)
          ], 8, qn)) : k("", !0)
        ]),
        _: 3
      })
    ], 14, In));
  }
}), bi = /* @__PURE__ */ fe(Gn, [["__scopeId", "data-v-9eb9da19"]]), Zn = ["aria-busy"], Jn = {
  key: 0,
  class: "base-collection-view-empty flex min-h-48 items-center justify-center"
}, Qn = { class: "base-collection-view-empty-content flex flex-col items-center gap-2 text-center" }, _n = { class: "base-collection-view-empty-title text-sm font-bold" }, es = {
  key: 0,
  class: "base-collection-view-empty-description max-w-xs text-xs"
}, ts = {
  key: 0,
  class: "base-collection-view-loading absolute inset-0 z-10 flex items-center justify-center backdrop-blur-[1px]"
}, as = { class: "flex flex-col items-center gap-3" }, ls = { class: "base-collection-view-loading-label text-[11px] font-bold uppercase tracking-widest animate-pulse" }, rs = /* @__PURE__ */ le({
  __name: "BaseCollectionView",
  props: {
    items: {},
    itemKey: { type: [String, Function], default: "id" },
    itemTag: { default: "article" },
    itemClass: { type: [String, Function], default: "" },
    itemAttrs: { type: Function, default: void 0 },
    itemState: {},
    layout: { default: "grid" },
    minItemWidth: { default: "14rem" },
    gap: { default: "1rem" },
    loading: { type: Boolean, default: !1 },
    loadingLabel: { default: "Loading" },
    emptyMessage: { default: "No items" },
    emptyDescription: { default: "" },
    emptyIcon: { default: "Inbox" },
    minHeight: { default: "" },
    transition: { default: "fade-collapse" },
    clickable: { type: Boolean, default: !1 },
    selectable: { type: Boolean, default: !1 },
    selection: { default: () => /* @__PURE__ */ new Set() },
    selectionKey: { type: [String, Function], default: "id" }
  },
  emits: ["item-click", "item-dblclick", "update:selection"],
  setup(e, { emit: r }) {
    const t = e, a = r, n = C(() => t.layout === "grid" ? "grid" : "flex flex-col"), o = C(
      () => t.layout === "grid" ? {
        gridTemplateColumns: `repeat(auto-fill, minmax(${t.minItemWidth}, 1fr))`,
        gap: t.gap
      } : { gap: t.gap }
    ), c = C(() => t.transition === "none" ? "" : t.transition === "fade-collapse" ? "base-collection-fade-collapse" : "base-collection-slide"), d = (p, L) => typeof t.itemKey == "function" ? t.itemKey(p, L) : String(p[t.itemKey] ?? L), i = (p, L) => typeof t.selectionKey == "function" ? t.selectionKey(p, L) : String(p[t.selectionKey] ?? d(p, L)), h = (p, L = 0) => t.selection.has(i(p, L)), x = (p, L) => t.itemState?.(p, L, d(p, L)) || {}, y = (p, L) => t.itemAttrs?.(p, L, d(p, L)) || {}, S = (p, L = 0) => {
      if (!t.selectable || x(p, L).disabled) return;
      const w = new Set(t.selection), M = i(p, L);
      w.has(M) ? w.delete(M) : w.add(M), a("update:selection", w);
    }, m = (p, L) => {
      !t.clickable || x(p, L).disabled || a("item-click", p, d(p, L), L);
    }, v = (p, L, w) => {
      !t.clickable || x(L, w).disabled || p.key !== "Enter" && p.key !== " " || (p.preventDefault(), m(L, w));
    }, f = (p, L) => {
      !t.clickable || x(p, L).disabled || a("item-dblclick", p, d(p, L), L);
    }, b = (p, L) => {
      if (t.transition !== "fade-collapse" || typeof window > "u") {
        L();
        return;
      }
      const w = p;
      w.style.height = `${w.getBoundingClientRect().height}px`, w.style.overflow = "hidden", w.style.pointerEvents = "none", window.requestAnimationFrame(() => {
        w.style.height = "0px", w.style.opacity = "0";
      }), window.setTimeout(L, 200);
    };
    return (p, L) => (l(), s("div", {
      class: "base-collection-view relative",
      style: re(e.minHeight ? { minHeight: e.minHeight } : void 0),
      "aria-busy": e.loading || void 0
    }, [
      e.items.length === 0 && !e.loading ? (l(), s("div", Jn, [
        N(p.$slots, "empty", {}, () => [
          u("div", Qn, [
            U(q, {
              name: e.emptyIcon,
              size: 28
            }, null, 8, ["name"]),
            u("span", _n, I(e.emptyMessage), 1),
            e.emptyDescription ? (l(), s("span", es, I(e.emptyDescription), 1)) : k("", !0)
          ])
        ], !0)
      ])) : e.items.length > 0 ? (l(), _(qe, {
        key: 1,
        name: c.value,
        css: e.transition !== "none",
        tag: "div",
        role: "list",
        class: E(["base-collection-view-items", n.value]),
        style: re(o.value),
        onLeave: b
      }, {
        default: se(() => [
          (l(!0), s(te, null, oe(e.items, (w, M) => (l(), _(gt(e.itemTag), He({
            key: d(w, M),
            class: ["base-collection-view-item", [
              typeof e.itemClass == "function" ? e.itemClass(w, M) : e.itemClass,
              {
                "base-collection-view-item--pending": x(w, M).pending,
                "base-collection-view-item--disabled": x(w, M).disabled
              }
            ]],
            "data-collection-item-key": d(w, M)
          }, { ref_for: !0 }, y(w, M), {
            role: "listitem",
            "aria-selected": e.selectable ? h(w) : void 0,
            "aria-disabled": x(w, M).disabled || void 0,
            tabindex: e.clickable && !x(w, M).disabled ? 0 : void 0,
            onClick: (F) => m(w, M),
            onDblclick: (F) => f(w, M),
            onKeydown: (F) => v(F, w, M)
          }), {
            default: se(() => [
              N(p.$slots, "item", {
                item: w,
                index: M,
                keyValue: d(w, M),
                selected: h(w),
                pending: x(w, M).pending,
                disabled: x(w, M).disabled,
                toggleSelection: () => S(w)
              }, void 0, !0)
            ]),
            _: 2
          }, 1040, ["class", "data-collection-item-key", "aria-selected", "aria-disabled", "tabindex", "onClick", "onDblclick", "onKeydown"]))), 128))
        ]),
        _: 3
      }, 8, ["name", "css", "class", "style"])) : k("", !0),
      U(ke, {
        "enter-active-class": "transition-opacity duration-200",
        "leave-active-class": "transition-opacity duration-200",
        "enter-from-class": "opacity-0",
        "leave-to-class": "opacity-0"
      }, {
        default: se(() => [
          e.loading ? (l(), s("div", ts, [
            N(p.$slots, "loading", {}, () => [
              u("div", as, [
                L[0] || (L[0] = u("div", { class: "base-collection-view-spinner h-8 w-8 animate-spin rounded-full border-2 border-transparent border-t-current" }, null, -1)),
                u("span", ls, I(e.loadingLabel), 1)
              ])
            ], !0)
          ])) : k("", !0)
        ]),
        _: 3
      })
    ], 12, Zn));
  }
}), gi = /* @__PURE__ */ fe(rs, [["__scopeId", "data-v-ae3c38cf"]]), ns = {
  key: 0,
  class: "fixed bottom-8 left-1/2 z-50 -translate-x-1/2"
}, ss = { class: "flex items-center gap-5 rounded-2xl border border-white/10 bg-gray-900/90 px-5 py-2.5 text-white shadow-[0_20px_50px_rgba(0,0,0,0.3)] ring-1 ring-white/5 backdrop-blur-md dark:bg-dark-100/95" }, os = { class: "flex items-center gap-3 border-r border-white/10 pr-5" }, is = { class: "flex h-7 w-7 items-center justify-center rounded-lg bg-primary/20 text-xs font-bold text-primary-400 shadow-inner ring-1 ring-primary/30" }, us = { class: "text-[13px] font-semibold tracking-wide whitespace-nowrap" }, ds = { class: "flex items-center gap-2" }, cs = ["title", "aria-label"], hi = /* @__PURE__ */ le({
  __name: "BatchActionBar",
  props: {
    selectedCount: {},
    selectedLabel: { default: "Selected" },
    clearLabel: { default: "Clear selection" }
  },
  emits: ["clear"],
  setup(e) {
    return (r, t) => (l(), _(ke, {
      "enter-active-class": "transition duration-300 ease-out",
      "enter-from-class": "translate-y-full opacity-0",
      "enter-to-class": "translate-y-0 opacity-100",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "translate-y-0 opacity-100",
      "leave-to-class": "translate-y-full opacity-0"
    }, {
      default: se(() => [
        e.selectedCount > 0 ? (l(), s("div", ns, [
          u("div", ss, [
            u("div", os, [
              u("div", is, I(e.selectedCount), 1),
              u("span", us, I(e.selectedLabel), 1)
            ]),
            u("div", ds, [
              N(r.$slots, "default", { count: e.selectedCount })
            ]),
            u("button", {
              class: "group ml-1 rounded-xl p-1.5 text-white/40 transition-all duration-200 hover:bg-white/10 hover:text-white",
              title: e.clearLabel,
              "aria-label": e.clearLabel,
              onClick: t[0] || (t[0] = (a) => r.$emit("clear"))
            }, [
              U(q, {
                name: "x",
                size: 16,
                class: "transition-transform duration-300 group-hover:rotate-90"
              })
            ], 8, cs)
          ])
        ])) : k("", !0)
      ]),
      _: 3
    }));
  }
}), Ee = P([]);
function yi() {
  function e(t) {
    return new Promise((a) => {
      Ee.value = [...Ee.value, { opts: t, resolve: a }];
    });
  }
  function r() {
    const t = Ee.value[0];
    t && (t.resolve(!1), Ee.value = Ee.value.slice(1));
  }
  return { confirm: e, closeDialog: r };
}
const fs = { class: "flex flex-col items-center text-center p-2 pt-6" }, ms = { class: "confirmation-message text-sm mb-4 max-w-[90%] mx-auto" }, vs = {
  key: 0,
  class: "text-xs text-red-500 font-bold mb-6 italic"
}, bs = {
  key: 0,
  class: "flex flex-col gap-1.5 mb-3"
}, gs = { class: "confirmation-summary-label transition-colors" }, hs = { class: "confirmation-summary-value font-bold font-mono tracking-tight" }, ys = {
  key: 1,
  class: "border-t border-gray-200 dark:border-dark-200 my-2 opacity-50"
}, ps = { class: "flex gap-2 text-left" }, xs = { class: "flex flex-col gap-1.5 w-full" }, ws = {
  key: 0,
  class: "confirmation-detail-text text-xs wrap-break-word whitespace-pre-wrap"
}, ks = {
  key: 1,
  class: "confirmation-detail-text text-xs list-none p-0 m-0 space-y-1.5"
}, $s = { class: "flex items-start gap-1.5 flex-1 leading-relaxed" }, Cs = {
  key: 0,
  class: "confirmation-detail-label font-bold whitespace-nowrap"
}, Ls = { class: "wrap-break-word flex-1" }, Ss = {
  key: 2,
  class: "mt-3 pt-2 border-t border-gray-200/60 dark:border-dark-200/60 flex gap-2 text-left"
}, zs = { class: "confirmation-note text-[10px]" }, Bs = { class: "grid grid-cols-2 gap-3 w-full mt-2" }, Ts = /* @__PURE__ */ le({
  __name: "ConfirmationDialog",
  setup(e) {
    const r = {
      title: "確認",
      message: "確定要執行此操作嗎?",
      confirmLabel: "確認",
      cancelLabel: "取消",
      severity: "info",
      showInfoIcon: !1,
      showBulletPoints: !1,
      scrollable: !0,
      maxHeight: "240px"
    }, t = P(!1), a = P(!1), n = P({ ...r });
    ce(Ee, async (j) => {
      j.length > 0 && !t.value && (await pe(), a.value = !1, n.value = { ...r, ...j[0].opts }, t.value = !0);
    }, { immediate: !0 });
    function o(j) {
      const J = Ee.value[0];
      J && J.resolve(j), Ee.value = Ee.value.slice(1), t.value = !1;
    }
    const c = C(() => {
      if (n.value.icon) return n.value.icon;
      switch (n.value.severity) {
        case "danger":
          return "AlertTriangle";
        case "warning":
          return "AlertCircle";
        case "success":
          return "CheckCircle2";
        default:
          return "Info";
      }
    }), d = C(() => {
      switch (n.value.severity) {
        case "danger":
          return "confirmation-icon--danger";
        case "warning":
          return "confirmation-icon--warning";
        case "success":
          return "confirmation-icon--success";
        default:
          return "confirmation-icon--info";
      }
    }), i = C(() => {
      switch (n.value.severity) {
        case "danger":
          return "bg-red-500";
        case "warning":
          return "bg-orange-500";
        case "success":
          return "bg-green-500";
        default:
          return "bg-blue-500";
      }
    }), h = C(() => {
      switch (n.value.severity) {
        case "danger":
          return "shadow-red-500/20";
        case "warning":
          return "shadow-primary/20";
        case "success":
          return "shadow-green-500/20";
        default:
          return "shadow-primary/20";
      }
    }), x = C(() => n.value.title), y = C(() => n.value.message), S = C(() => n.value.warning), m = C(() => n.value.details), v = C(() => n.value.detailsItems), f = C(() => n.value.summary), b = C(() => n.value.note), p = C(() => n.value.confirmLabel || "確認"), L = C(() => n.value.cancelLabel || "取消"), w = C(() => n.value.severity || "info"), M = C(() => n.value.width || "420px"), F = C(() => n.value.contentClass || ""), V = (j) => {
      const J = j.match(/^([^:：]+[:：])\s*(.*)$/s);
      return J ? { label: J[1], text: J[2] } : { label: "", text: j };
    };
    async function B() {
      if (n.value.onConfirm) {
        a.value = !0;
        try {
          await n.value.onConfirm();
        } finally {
          a.value = !1;
        }
      }
      o(!0);
    }
    function O() {
      n.value.onCancel?.(), o(!1);
    }
    return (j, J) => (l(), _(ln, {
      visible: t.value,
      "onUpdate:visible": J[0] || (J[0] = ($) => t.value = $),
      header: x.value,
      closable: !1,
      width: M.value,
      maxWidth: "sm",
      zIndex: 3e3,
      "content-class": F.value
    }, {
      default: se(() => [
        u("div", fs, [
          u("div", {
            class: E(["confirmation-icon relative flex items-center justify-center w-20 h-20 rounded-full mb-5 transition-transform hover:scale-105 duration-300", d.value])
          }, [
            u("div", {
              class: E(["absolute inset-0 rounded-full animate-ping opacity-20", i.value])
            }, null, 2),
            U(q, {
              name: c.value,
              class: "relative z-10",
              size: 40
            }, null, 8, ["name"])
          ], 2),
          u("p", ms, I(y.value), 1),
          S.value ? (l(), s("p", vs, I(S.value), 1)) : k("", !0),
          m.value || f.value || b.value || v.value && v.value.length > 0 ? (l(), s("div", {
            key: 1,
            class: E(["confirmation-details w-full border rounded-xl p-3 mb-6 text-left animate-in fade-in slide-in-from-top-1", { "overflow-y-auto min-h-0": n.value.scrollable }]),
            style: re(n.value.scrollable ? { maxHeight: n.value.maxHeight || "200px" } : {})
          }, [
            f.value && f.value.length > 0 ? (l(), s("div", bs, [
              (l(!0), s(te, null, oe(f.value, ($, A) => (l(), s("div", {
                key: A,
                class: E(["flex justify-between items-center text-xs group", $.class])
              }, [
                u("span", gs, I($.label), 1),
                u("span", hs, I($.value), 1)
              ], 2))), 128))
            ])) : k("", !0),
            m.value && f.value && f.value.length > 0 ? (l(), s("div", ys)) : k("", !0),
            u("div", ps, [
              n.value.showInfoIcon ? (l(), _(q, {
                key: 0,
                name: "Info",
                class: "text-gray-400 mt-1 shrink-0",
                size: 10
              })) : k("", !0),
              u("div", xs, [
                m.value ? (l(), s("p", ws, I(m.value), 1)) : k("", !0),
                v.value && v.value.length > 0 ? (l(), s("ul", ks, [
                  (l(!0), s(te, null, oe(v.value, ($, A) => (l(), s("li", {
                    key: A,
                    class: "flex gap-2.5 py-0.5 transition-colors"
                  }, [
                    u("div", $s, [
                      V($).label ? (l(), s("span", Cs, I(V($).label), 1)) : k("", !0),
                      u("span", Ls, I(V($).text), 1)
                    ])
                  ]))), 128))
                ])) : k("", !0)
              ])
            ]),
            b.value ? (l(), s("div", Ss, [
              U(q, {
                name: "Lightbulb",
                size: "12",
                class: "text-amber-500 mt-0.5 shrink-0"
              }),
              u("span", zs, I(b.value), 1)
            ])) : k("", !0)
          ], 6)) : k("", !0),
          u("div", Bs, [
            U(et, {
              label: L.value,
              variant: "secondary",
              onClick: O,
              class: "confirmation-cancel w-full font-bold"
            }, null, 8, ["label"]),
            U(et, {
              label: p.value,
              variant: w.value === "danger" ? "danger" : "primary",
              onClick: B,
              loading: a.value,
              disabled: n.value.confirmDisabled,
              class: E(["confirmation-confirm w-full shadow-md font-bold transition-all hover:-translate-y-0.5", [
                h.value,
                w.value === "info" || w.value === "warning" ? "bg-primary! border-primary! hover:bg-primary-hover!" : ""
              ]])
            }, null, 8, ["label", "variant", "loading", "disabled", "class"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header", "width", "content-class"]));
  }
}), pi = /* @__PURE__ */ fe(Ts, [["__scopeId", "data-v-83ded01f"]]), Ms = { key: 0 }, Es = ["title"], Is = {
  key: 0,
  class: "text-gray-500"
}, Ds = {
  key: 1,
  class: "text-blue-400"
}, Vs = {
  key: 2,
  class: "text-orange-400"
}, As = {
  key: 3,
  class: "text-gray-500"
}, Ps = { key: 1 }, Rs = { class: "shrink-0 text-[8px] leading-none text-gray-500 select-none" }, Hs = { class: "text-gray-400" }, Ws = { class: "text-[11px]" }, Os = {
  key: 0,
  class: "text-purple-300"
}, js = {
  key: 1,
  class: "text-gray-500"
}, Fs = {
  key: 2,
  class: "text-gray-600"
}, Ks = {
  key: 0,
  class: "text-gray-500"
}, Ns = { class: "text-gray-400" }, Us = {
  key: 1,
  class: "text-gray-400"
}, Xs = { class: "ml-4" }, qs = {
  key: 0,
  class: "text-purple-400"
}, Ys = {
  key: 1,
  class: "text-gray-600"
}, Gs = {
  key: 2,
  class: "text-gray-600"
}, Zs = { class: "text-gray-400" }, St = 3, zt = 24, xi = /* @__PURE__ */ le({
  __name: "JsonViewer",
  props: {
    data: {},
    depth: { default: 0 },
    expandDepth: { default: -1 },
    stringTruncateThreshold: { default: 80 }
  },
  setup(e) {
    const r = e, t = P(r.expandDepth === -1 || r.depth < r.expandDepth), a = P(!1), n = C(() => r.data === null ? "null" : Array.isArray(r.data) ? "array" : typeof r.data), o = C(() => n.value === "object" || n.value === "array"), c = C(() => n.value === "array" ? r.data.map((f, b) => [String(b), f]) : n.value === "object" ? Object.entries(r.data) : []), d = C(() => c.value.length), i = C(() => n.value === "array" ? ["[", "]"] : ["{", "}"]), h = C(() => c.value.slice(0, St)), x = C(() => d.value > St);
    function y(f) {
      return f === null ? "null" : Array.isArray(f) ? `Array(${f.length})` : typeof f == "object" ? "{...}" : typeof f == "string" ? `'${f.length > zt ? `${f.slice(0, zt)}...` : f}'` : String(f);
    }
    function S(f) {
      return f === null || f !== null && typeof f == "object" ? "other" : typeof f;
    }
    const m = C(() => n.value === "string" && r.data.length > r.stringTruncateThreshold), v = C(() => {
      if (n.value !== "string") return "";
      const f = r.data;
      return !m.value || a.value ? f : f.slice(0, r.stringTruncateThreshold);
    });
    return (f, b) => {
      const p = Gt("JsonViewer", !0);
      return o.value ? (l(), s("span", Ps, [
        u("button", {
          class: "inline-flex items-center gap-1 transition-opacity hover:opacity-70",
          onClick: b[1] || (b[1] = me((L) => t.value = !t.value, ["stop"]))
        }, [
          u("span", Rs, I(t.value ? "▼" : "▶"), 1),
          t.value ? (l(), s("span", Us, I(i.value[0]), 1)) : (l(), s(te, { key: 0 }, [
            u("span", Hs, I(i.value[0]), 1),
            u("span", Ws, [
              (l(!0), s(te, null, oe(h.value, ([L, w], M) => (l(), s(te, { key: L }, [
                n.value === "object" ? (l(), s("span", Os, I(L), 1)) : (l(), s("span", js, I(L), 1)),
                b[2] || (b[2] = u("span", { class: "text-gray-500" }, ": ", -1)),
                u("span", {
                  class: E({
                    "text-emerald-400": S(w) === "string",
                    "text-blue-400": S(w) === "number",
                    "text-orange-400": S(w) === "boolean",
                    "text-gray-500": S(w) === "other"
                  })
                }, I(y(w)), 3),
                M < h.value.length - 1 ? (l(), s("span", Fs, ", ")) : k("", !0)
              ], 64))), 128)),
              x.value ? (l(), s("span", Ks, ", ...")) : k("", !0)
            ]),
            u("span", Ns, I(i.value[1]), 1)
          ], 64))
        ]),
        t.value ? (l(), s(te, { key: 0 }, [
          u("div", Xs, [
            (l(!0), s(te, null, oe(c.value, ([L, w], M) => (l(), s("div", {
              key: L,
              class: "leading-relaxed"
            }, [
              n.value === "object" ? (l(), s("span", qs, '"' + I(L) + '"', 1)) : (l(), s("span", Ys, I(L), 1)),
              b[3] || (b[3] = u("span", { class: "text-gray-500" }, ": ", -1)),
              U(p, {
                data: w,
                depth: e.depth + 1,
                "expand-depth": e.expandDepth
              }, null, 8, ["data", "depth", "expand-depth"]),
              M < c.value.length - 1 ? (l(), s("span", Gs, ",")) : k("", !0)
            ]))), 128))
          ]),
          u("span", Zs, I(i.value[1]), 1)
        ], 64)) : k("", !0)
      ])) : (l(), s("span", Ms, [
        n.value === "string" ? (l(), s("span", {
          key: 0,
          title: m.value && !a.value ? e.data : void 0,
          class: E(["text-emerald-400", m.value && !a.value ? "cursor-pointer hover:opacity-70" : "whitespace-pre-wrap break-words"]),
          onClick: b[0] || (b[0] = me((L) => m.value && (a.value = !a.value), ["stop"]))
        }, [
          we(' "' + I(v.value) + '"', 1),
          m.value && !a.value ? (l(), s("span", Is, "...")) : k("", !0)
        ], 10, Es)) : n.value === "number" ? (l(), s("span", Ds, I(e.data), 1)) : n.value === "boolean" ? (l(), s("span", Vs, I(e.data), 1)) : (l(), s("span", As, "null"))
      ]));
    };
  }
}), Js = {
  key: 0,
  class: "px-2 pt-2 pb-1.5"
}, Qs = { class: "relative" }, _s = ["placeholder"], eo = {
  key: 1,
  class: "px-2 pb-1 flex justify-end"
}, to = {
  key: 2,
  class: "mb-1"
}, ao = { class: "ml-auto font-normal normal-case tracking-normal opacity-60" }, lo = ["data-tree-id", "onTouchstart", "onTouchmove", "onTouchend"], ro = ["draggable", "onClick", "onDragstart", "onDragover", "onDrop"], no = { class: "text-sm truncate flex-1" }, so = {
  key: 1,
  class: "text-[10px] text-gray-400 shrink-0"
}, oo = {
  key: 0,
  class: "hidden group-hover/item:flex shrink-0"
}, io = {
  key: 3,
  class: "px-3 py-6 text-center text-sm text-gray-400 dark:text-gray-500"
}, uo = ["data-tree-id", "onClick", "onDblclick"], co = { class: "py-1.5 text-sm truncate flex-1" }, fo = {
  key: 1,
  class: "text-[10px] text-gray-400 shrink-0"
}, mo = {
  key: 0,
  class: "hidden group-hover/item:flex shrink-0"
}, vo = ["data-tree-id", "draggable", "onClick", "onDragstart", "onDragover", "onDrop"], bo = ["onClick"], go = { class: "text-xs tracking-wide text-gray-700 dark:text-gray-200 flex-1 truncate" }, ho = {
  key: 0,
  class: "text-[10px] text-gray-400 shrink-0"
}, yo = {
  key: 0,
  class: "hidden group-hover:flex shrink-0 items-center gap-0.5 ml-auto pr-1"
}, po = ["data-tree-id", "onTouchstart", "onTouchmove", "onTouchend"], xo = ["draggable", "onClick", "onDblclick", "onDragstart", "onDragover", "onDrop"], wo = { class: "py-1.5 text-sm truncate flex-1" }, ko = {
  key: 1,
  class: "text-[10px] text-gray-400 shrink-0"
}, $o = {
  key: 0,
  class: "hidden group-hover/item:flex shrink-0"
}, ct = "__favs__", Bt = 40, Co = 8, Lo = /* @__PURE__ */ le({
  name: "TreeList",
  __name: "TreeList",
  props: {
    nodes: {},
    selectedId: {},
    defaultCollapsed: { default: () => [] },
    collapseKey: {},
    draggable: { type: Boolean, default: !1 },
    reorderable: { type: Boolean, default: !1 },
    showFavourites: { type: Boolean, default: !1 },
    favouriteIds: { default: () => [] },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: {},
    flatViewToggle: { type: Boolean, default: !1 },
    filterPredicate: {},
    sortPredicate: {},
    swipeActions: { type: Boolean, default: !1 },
    swipeRevealWidth: { default: 120 },
    bareItems: { type: Boolean, default: !1 },
    canDrag: {},
    canDrop: {},
    enrichDrag: {}
  },
  emits: ["select", "toggle", "reorder", "move", "reorderFavourites", "dblclick"],
  setup(e, { expose: r, emit: t }) {
    const a = e, n = t;
    function o() {
      if (a.collapseKey)
        try {
          const T = localStorage.getItem(a.collapseKey);
          if (T) {
            const D = JSON.parse(T);
            if (Array.isArray(D)) return new Set(D);
          }
        } catch {
        }
      return new Set(a.defaultCollapsed);
    }
    const c = P(o());
    ce(c, (T) => {
      if (a.collapseKey)
        try {
          localStorage.setItem(a.collapseKey, JSON.stringify([...T]));
        } catch {
        }
    }, { deep: !0 }), ce(() => a.collapseKey, () => {
      c.value = o();
    });
    function d(T) {
      return c.value.has(T);
    }
    function i(T) {
      const D = new Set(c.value);
      D.has(T) ? D.delete(T) : D.add(T), c.value = D, n("toggle", T, !D.has(T));
    }
    function h(T, D, g) {
      for (const W of T)
        g.push({ node: W, depth: D }), W.type === "group" && W.children?.length && !d(W.id) && h(W.children, D + 1, g);
    }
    const x = C(() => {
      const T = [];
      return h(a.nodes, 0, T), T;
    }), y = P(""), S = P(!1), m = C(() => a.searchable && y.value.trim().length > 0), v = C(() => m.value || S.value);
    function f(T, D) {
      return T.label.toLowerCase().includes(D.toLowerCase());
    }
    const b = C(() => {
      if (!v.value) return [];
      const T = [];
      function D(ae) {
        for (const ve of ae)
          ve.type === "item" && ve.meta?.kind !== "load-more" && T.push(ve), ve.children?.length && D(ve.children);
      }
      D(a.nodes);
      const g = y.value.trim(), W = a.filterPredicate ?? f, R = g ? T.filter((ae) => W(ae, g)) : T;
      return a.sortPredicate ? [...R].sort(a.sortPredicate) : R;
    });
    function p(T) {
      function D(g, W) {
        for (const R of g) {
          if (R.id === T) return W;
          if (R.children?.length) {
            const ae = D(R.children, [...W, R.id]);
            if (ae) return ae;
          }
        }
        return null;
      }
      return D(a.nodes, []);
    }
    const L = C(() => {
      if (!a.showFavourites || !a.favouriteIds?.length) return [];
      const T = /* @__PURE__ */ new Map();
      function D(g) {
        for (const W of g)
          W.type === "item" && a.favouriteIds.includes(W.id) && T.set(W.id, W), W.children && D(W.children);
      }
      return D(a.nodes), a.favouriteIds.map((g) => T.get(g)).filter((g) => !!g);
    }), w = C({
      get: () => c.value.has(ct),
      set: (T) => {
        const D = new Set(c.value);
        T ? D.add(ct) : D.delete(ct), c.value = D;
      }
    });
    function M(T) {
      function D(g) {
        for (const W of g) {
          if (W.id === T) return W;
          if (W.children?.length) {
            const R = D(W.children);
            if (R) return R;
          }
        }
        return null;
      }
      return D(a.nodes);
    }
    function F(T) {
      function D(g, W) {
        for (const R of g) {
          if (R.id === T) return W;
          if (R.children?.length) {
            const ae = D(R.children, R.type === "group" ? R : W);
            if (ae !== void 0) return ae;
          }
        }
      }
      return D(a.nodes, null) ?? null;
    }
    function V(T, D) {
      if (T === D) return !0;
      const g = M(D);
      if (!g?.children?.length) return !1;
      function W(R) {
        for (const ae of R)
          if (ae.id === T || ae.children?.length && W(ae.children)) return !0;
        return !1;
      }
      return W(g.children);
    }
    const B = P(null), O = P(null), j = P(null), J = P("before"), $ = P(!1), A = C(() => J.value === "after" ? "after" : "before"), z = C(() => {
      if (!j.value || J.value !== "into") return /* @__PURE__ */ new Set();
      const T = M(j.value);
      if (!T || T.type !== "group") return /* @__PURE__ */ new Set();
      const D = /* @__PURE__ */ new Set([j.value]);
      function g(W) {
        for (const R of W)
          D.add(R.id), R.type === "group" && R.children?.length && !d(R.id) && g(R.children);
      }
      return T.children?.length && !d(T.id) && g(T.children), D;
    });
    function K() {
      B.value = null, O.value = null, j.value = null, $.value = !1, ut();
    }
    function de(T, D, g = "tree") {
      if (a.draggable) {
        if (a.canDrag && !a.canDrag(D)) {
          T.preventDefault();
          return;
        }
        B.value = D, O.value = g, T.dataTransfer && (T.dataTransfer.effectAllowed = "move"), a.enrichDrag?.(D, T);
      }
    }
    function ue(T, D, g = "tree") {
      if (!a.reorderable || !B.value || B.value === D || O.value !== g || g === "tree" && V(D, B.value)) return;
      const W = T.currentTarget.getBoundingClientRect(), R = T.clientY - W.top, ae = W.height, ve = g === "tree" ? M(D) : null, Oe = g === "tree" ? M(B.value) : null;
      let $e = D, Ae;
      if (ve?.type === "group")
        if (Oe?.type === "group")
          Ae = R < ae * 0.25 ? "before" : R > ae * 0.75 ? "after" : "into";
        else {
          const Ge = !d(D) && !!ve.children?.length;
          Ae = R > ae * 0.75 && Ge ? "after" : "into";
        }
      else if (Oe?.type === "group" && g === "tree") {
        const Ge = F(D);
        Ge && !V(Ge.id, B.value) ? ($e = Ge.id, Ae = "into") : ($e = null, Ae = "before");
      } else
        Ae = R < ae / 2 ? "before" : "after";
      if (!$e || a.canDrop && !a.canDrop(B.value, $e, Ae)) {
        $e ? (T.preventDefault(), T.dataTransfer && (T.dataTransfer.dropEffect = "none"), j.value = $e, J.value = Ae, $.value = !0) : (j.value = null, $.value = !1);
        return;
      }
      T.preventDefault(), j.value = $e, J.value = Ae, $.value = !1, at(T);
    }
    function ie() {
      j.value = null, $.value = !1;
    }
    function he(T, D, g = "tree") {
      if ($.value) {
        K();
        return;
      }
      if (!(!a.reorderable || !B.value || B.value === D)) {
        if (O.value !== g) {
          K();
          return;
        }
        if (g === "tree" && V(D, B.value)) {
          K();
          return;
        }
        if (T.preventDefault(), g === "favs") {
          const W = L.value.map(($e) => $e.id), R = B.value, ae = W.filter(($e) => $e !== R), ve = ae.indexOf(D);
          if (ve === -1) {
            K();
            return;
          }
          const Oe = J.value === "before" ? ve : ve + 1;
          ae.splice(Oe, 0, R), n("reorderFavourites", ae);
        } else {
          const W = J.value, R = j.value ?? D;
          if (V(R, B.value)) {
            K();
            return;
          }
          const ae = W === "into" ? { intoGroup: !0, groupId: R } : {
            ...W === "before" ? { beforeId: R } : { afterId: R },
            parentGroupId: F(R)?.id ?? void 0
          };
          n("move", B.value, ae), W !== "into" && n("reorder", B.value, R, W);
        }
        K();
      }
    }
    function X() {
      K();
    }
    let Y = null, Q = 0, be = null;
    function Ye(T) {
      let D = T;
      for (; D && D !== document.body; ) {
        const g = getComputedStyle(D);
        if (/(auto|scroll|overlay)/.test(g.overflowY)) return D;
        D = D.parentElement;
      }
      return null;
    }
    function at(T) {
      if (be || (be = Ye(ye.value)), !be) return;
      const D = be.getBoundingClientRect();
      if (T.clientY < D.top + Bt ? Q = -1 : T.clientY > D.bottom - Bt ? Q = 1 : Q = 0, Q !== 0 && Y === null) {
        const g = () => {
          if (Q === 0 || !be) {
            Y = null;
            return;
          }
          be.scrollTop += Q * Co, Y = requestAnimationFrame(g);
        };
        Y = requestAnimationFrame(g);
      }
    }
    function ut() {
      Y !== null && (cancelAnimationFrame(Y), Y = null), Q = 0, be = null;
    }
    const ge = P(null), Ce = P(0), Te = P(!1);
    let Le = null, Se = null;
    function H() {
      ge.value === null && Ce.value === 0 || (Te.value = !0, Ce.value = 0, ge.value = null, setTimeout(() => {
        Te.value = !1;
      }, 200));
    }
    function G(T, D) {
      if (!a.swipeActions) return;
      const g = T.touches[0];
      if (!g) return;
      const W = ge.value === D ? Ce.value : 0;
      ge.value && ge.value !== D && H(), Le = { x: g.clientX, y: g.clientY, id: D, baseDx: W }, Se = null, Te.value = !1;
    }
    function ee(T, D) {
      if (!a.swipeActions || !Le || Le.id !== D) return;
      const g = T.touches[0];
      if (!g) return;
      const W = g.clientX - Le.x, R = g.clientY - Le.y;
      if (Se === null) {
        const ae = Math.abs(W), ve = Math.abs(R);
        ae > 8 && ae > ve ? Se = "h" : ve > 8 && (Se = "v");
      }
      if (Se === "h") {
        T.cancelable && T.preventDefault();
        const ae = Le.baseDx + W;
        Ce.value = Math.max(-a.swipeRevealWidth, Math.min(0, ae)), ge.value = D;
      }
    }
    function ne(T) {
      if (a.swipeActions) {
        if (Se !== "h") {
          Le = null, Se = null;
          return;
        }
        Le = null, Se = null, Te.value = !0, Ce.value < -a.swipeRevealWidth / 2 ? (Ce.value = -a.swipeRevealWidth, ge.value = T) : (Ce.value = 0, ge.value = null), setTimeout(() => {
          Te.value = !1;
        }, 200);
      }
    }
    function xe(T) {
      return ge.value === T ? Ce.value : 0;
    }
    const ye = P(null);
    async function ze(T, D = { behavior: "smooth", block: "nearest" }) {
      const g = p(T);
      if (g === null) return;
      if (g.length) {
        const ae = new Set(c.value);
        let ve = !1;
        for (const Oe of g)
          ae.delete(Oe) && (ve = !0);
        ve && (c.value = ae);
      }
      await pe();
      const W = ye.value;
      if (!W) return;
      const R = W.querySelector(`[data-tree-id="${CSS.escape(T)}"]`);
      R && R.scrollIntoView(D);
    }
    function Be(T) {
      if (!c.value.has(T)) return;
      const D = new Set(c.value);
      D.delete(T), c.value = D;
    }
    function We(T) {
      if (c.value.has(T)) return;
      const D = new Set(c.value);
      D.add(T), c.value = D;
    }
    r({ scrollIntoView: ze, expand: Be, collapse: We, closeSwipe: H });
    function Ve(T) {
      return T > 0 ? { paddingLeft: `${8 + T * 14}px` } : void 0;
    }
    return (T, D) => (l(), s("div", {
      ref_key: "rootRef",
      ref: ye,
      class: E(["tree-list relative flex flex-col select-none", { "gap-1": e.bareItems }])
    }, [
      e.searchable ? (l(), s("div", Js, [
        u("div", Qs, [
          U(q, {
            name: "Search",
            size: 13,
            class: "absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
          }),
          ht(u("input", {
            "onUpdate:modelValue": D[0] || (D[0] = (g) => y.value = g),
            type: "text",
            placeholder: e.searchPlaceholder ?? "Search...",
            class: "w-full pl-8 pr-7 py-1.5 text-sm bg-gray-100 dark:bg-dark-200 rounded-md outline-none focus:ring-1 focus:ring-primary/40 text-gray-800 dark:text-gray-200 placeholder-gray-400"
          }, null, 8, _s), [
            [Dt, y.value]
          ]),
          y.value ? (l(), s("button", {
            key: 0,
            onClick: D[1] || (D[1] = (g) => y.value = ""),
            class: "absolute right-1.5 top-1/2 -translate-y-1/2 p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded transition-colors"
          }, [
            U(q, {
              name: "X",
              size: 11
            })
          ])) : k("", !0)
        ])
      ])) : k("", !0),
      e.flatViewToggle && !m.value ? (l(), s("div", eo, [
        u("button", {
          onClick: D[2] || (D[2] = (g) => S.value = !S.value),
          class: "text-[10px] uppercase tracking-wider text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 flex items-center gap-1 px-1.5 py-0.5 rounded transition-colors"
        }, [
          U(q, {
            name: S.value ? "List" : "FolderTree",
            size: 11
          }, null, 8, ["name"]),
          we(" " + I(S.value ? "Flat" : "Tree"), 1)
        ])
      ])) : k("", !0),
      e.showFavourites && L.value.length && !m.value ? (l(), s("div", to, [
        u("button", {
          class: "w-full flex items-center gap-1.5 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 transition-colors rounded-md",
          onClick: D[3] || (D[3] = (g) => w.value = !w.value)
        }, [
          U(q, {
            name: w.value ? "ChevronRight" : "ChevronDown",
            size: 10,
            class: "shrink-0"
          }, null, 8, ["name"]),
          U(q, {
            name: "Star",
            size: 10,
            class: "shrink-0 text-amber-400"
          }),
          D[4] || (D[4] = u("span", null, "Favourites", -1)),
          u("span", ao, I(L.value.length), 1)
        ]),
        w.value ? k("", !0) : (l(), _(qe, {
          key: 0,
          name: "tree-row",
          tag: "div",
          class: "space-y-0.5 mt-0.5"
        }, {
          default: se(() => [
            (l(!0), s(te, null, oe(L.value, (g) => (l(), s("div", {
              key: "fav-" + g.id,
              "data-tree-id": "fav-" + g.id,
              class: E(["relative", e.swipeActions ? "overflow-hidden" : ""]),
              onTouchstart: (W) => G(W, "fav-" + g.id),
              onTouchmove: (W) => ee(W, "fav-" + g.id),
              onTouchend: (W) => ne("fav-" + g.id)
            }, [
              e.swipeActions && T.$slots["swipe-actions"] && ge.value === "fav-" + g.id ? (l(), s("div", {
                key: 0,
                class: "absolute right-0 top-0 bottom-0 flex items-stretch",
                style: re({ width: e.swipeRevealWidth + "px" })
              }, [
                N(T.$slots, "swipe-actions", {
                  node: g,
                  close: H
                }, void 0, !0)
              ], 4)) : k("", !0),
              u("div", {
                class: E(["group/item relative", [
                  e.bareItems ? "block cursor-pointer min-w-0" : "flex items-center gap-2 px-2 py-1.5 rounded-md transition-colors",
                  !e.bareItems && (e.selectedId === g.id ? "bg-primary/10 text-primary dark:text-primary" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-200"),
                  !e.bareItems && (e.draggable ? "cursor-grab active:cursor-grabbing" : "cursor-pointer"),
                  j.value === g.id && O.value === "favs" && A.value === "before" ? "border-t-2 border-primary" : "",
                  j.value === g.id && O.value === "favs" && A.value === "after" ? "border-b-2 border-primary" : ""
                ]]),
                style: re({
                  transform: e.swipeActions ? `translateX(${xe("fav-" + g.id)}px)` : void 0,
                  transition: e.swipeActions && Te.value ? "transform 200ms" : void 0
                }),
                draggable: e.draggable,
                onClick: (W) => n("select", g.id, !0),
                onDragstart: (W) => de(W, g.id, "favs"),
                onDragover: (W) => ue(W, g.id, "favs"),
                onDragleave: ie,
                onDrop: (W) => he(W, g.id, "favs"),
                onDragend: X
              }, [
                N(T.$slots, "item", {
                  node: g,
                  selected: e.selectedId === g.id,
                  depth: 0,
                  isFav: !0
                }, () => [
                  g.icon ? (l(), _(q, {
                    key: 0,
                    name: g.icon,
                    size: 13,
                    class: "shrink-0 text-gray-400"
                  }, null, 8, ["name"])) : k("", !0),
                  u("span", no, I(g.label), 1),
                  g.badge !== void 0 ? (l(), s("span", so, I(g.badge), 1)) : k("", !0)
                ], !0),
                T.$slots["item-actions"] ? (l(), s("div", oo, [
                  N(T.$slots, "item-actions", { node: g }, void 0, !0)
                ])) : k("", !0)
              ], 46, ro)
            ], 42, lo))), 128))
          ]),
          _: 3
        }))
      ])) : k("", !0),
      (v.value ? b.value.length === 0 : x.value.length === 0) ? (l(), s("div", io, [
        N(T.$slots, "empty", {
          searching: m.value,
          query: y.value
        }, () => [
          we(I(m.value ? "No matches" : "No items"), 1)
        ], !0)
      ])) : k("", !0),
      v.value ? (l(!0), s(te, { key: 4 }, oe(b.value, (g) => (l(), s("div", {
        key: "flat-" + g.id,
        "data-tree-id": g.id,
        class: E(["group/item relative flex items-center cursor-pointer", [
          e.bareItems ? "" : "gap-2 rounded-md transition-colors px-2",
          !e.bareItems && (e.selectedId === g.id ? "bg-primary/10 text-primary dark:text-primary" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-200")
        ]]),
        onClick: (W) => n("select", g.id),
        onDblclick: (W) => n("dblclick", g.id)
      }, [
        N(T.$slots, "item", {
          node: g,
          selected: e.selectedId === g.id,
          depth: 0,
          isFav: !1
        }, () => [
          g.icon ? (l(), _(q, {
            key: 0,
            name: g.icon,
            size: 13,
            class: "shrink-0 text-gray-400"
          }, null, 8, ["name"])) : k("", !0),
          u("span", co, I(g.label), 1),
          g.badge !== void 0 ? (l(), s("span", fo, I(g.badge), 1)) : k("", !0)
        ], !0),
        T.$slots["item-actions"] ? (l(), s("div", mo, [
          N(T.$slots, "item-actions", { node: g }, void 0, !0)
        ])) : k("", !0)
      ], 42, uo))), 128)) : (l(), _(qe, {
        key: 5,
        name: "tree-row",
        tag: "div",
        class: E(["flex flex-col min-w-0", { "gap-1": e.bareItems }])
      }, {
        default: se(() => [
          (l(!0), s(te, null, oe(x.value, ({ node: g, depth: W }) => (l(), s(te, {
            key: g.id
          }, [
            g.type === "group" ? (l(), s("div", {
              key: 0,
              "data-tree-id": g.id,
              class: E(["group flex items-center gap-1 rounded-md transition-colors pr-2 shrink-0", [
                W === 0 ? "h-8 pl-2 font-semibold" : "h-7 font-medium",
                "hover:bg-gray-100 dark:hover:bg-dark-200",
                e.draggable && (!e.canDrag || e.canDrag(g.id)) ? "cursor-grab active:cursor-grabbing" : "cursor-pointer",
                O.value === "tree" && j.value === g.id && J.value === "into" && !$.value ? "ring-2 ring-primary/60 bg-primary/5" : "",
                O.value === "tree" && j.value === g.id && J.value === "into" && $.value ? "ring-2 ring-red-400/50 bg-red-500/5" : "",
                O.value === "tree" && j.value === g.id && J.value === "before" && !$.value ? "border-t-2 border-primary" : "",
                O.value === "tree" && j.value === g.id && J.value === "after" && !$.value ? "border-b-2 border-primary" : "",
                O.value === "tree" && z.value.has(g.id) && j.value !== g.id && !$.value ? "bg-primary/5" : "",
                O.value === "tree" && z.value.has(g.id) && j.value !== g.id && $.value ? "bg-red-500/5" : ""
              ]]),
              style: re(Ve(W)),
              draggable: e.draggable && (!e.canDrag || e.canDrag(g.id)),
              onClick: (R) => n("select", g.id),
              onDragstart: (R) => de(R, g.id),
              onDragover: (R) => ue(R, g.id),
              onDragleave: ie,
              onDrop: (R) => he(R, g.id),
              onDragend: X
            }, [
              N(T.$slots, "group-header", {
                node: g,
                collapsed: d(g.id),
                depth: W,
                toggle: () => i(g.id)
              }, () => [
                u("button", {
                  class: "shrink-0 p-0.5 -ml-0.5 rounded hover:bg-black/10 dark:hover:bg-white/10 transition-colors",
                  onClick: me((R) => i(g.id), ["stop"])
                }, [
                  U(q, {
                    name: d(g.id) ? "ChevronRight" : "ChevronDown",
                    size: W === 0 ? 12 : 10,
                    class: "text-gray-500 dark:text-gray-400 transition-transform duration-150"
                  }, null, 8, ["name", "size"])
                ], 8, bo),
                U(q, {
                  name: g.meta?.loading ? "Loader2" : g.icon ?? (W === 0 ? "Folder" : "FolderOpen"),
                  size: W === 0 ? 12 : 10,
                  class: E(["shrink-0 text-gray-500 dark:text-gray-400", g.meta?.loading ? "animate-spin" : ""])
                }, null, 8, ["name", "size", "class"]),
                u("span", go, [
                  N(T.$slots, "group-label", {
                    node: g,
                    depth: W
                  }, () => [
                    we(I(g.label), 1)
                  ], !0)
                ]),
                g.badge !== void 0 ? (l(), s("span", ho, I(g.badge), 1)) : k("", !0)
              ], !0),
              T.$slots["group-actions"] ? (l(), s("div", yo, [
                N(T.$slots, "group-actions", { node: g }, void 0, !0)
              ])) : k("", !0)
            ], 46, vo)) : (l(), s("div", {
              key: 1,
              "data-tree-id": g.id,
              class: E(["relative", e.swipeActions ? "overflow-hidden" : ""]),
              onTouchstart: (R) => G(R, g.id),
              onTouchmove: (R) => ee(R, g.id),
              onTouchend: (R) => ne(g.id)
            }, [
              e.swipeActions && T.$slots["swipe-actions"] && ge.value === g.id ? (l(), s("div", {
                key: 0,
                class: "absolute right-0 top-0 bottom-0 flex items-stretch",
                style: re({ width: e.swipeRevealWidth + "px" })
              }, [
                N(T.$slots, "swipe-actions", {
                  node: g,
                  close: H
                }, void 0, !0)
              ], 4)) : k("", !0),
              u("div", {
                class: E(["group/item relative cursor-pointer min-w-0", [
                  e.bareItems ? "block" : "flex items-center gap-2 rounded-md bg-gray-50 dark:bg-dark-50",
                  !e.bareItems && (e.swipeActions ? "" : "transition-colors"),
                  !e.bareItems && (e.selectedId === g.id ? "bg-primary/10 text-primary dark:text-primary" : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-200"),
                  O.value === "tree" && j.value === g.id && A.value === "before" && !$.value ? "border-t-2 border-primary" : "",
                  O.value === "tree" && j.value === g.id && A.value === "after" && !$.value ? "border-b-2 border-primary" : "",
                  O.value === "tree" && z.value.has(g.id) && !$.value ? "bg-primary/5" : "",
                  O.value === "tree" && z.value.has(g.id) && $.value ? "bg-red-500/5" : "",
                  e.draggable ? "cursor-grab active:cursor-grabbing" : ""
                ]]),
                style: re({
                  paddingLeft: e.bareItems ? `${W * 8}px` : `${8 + W * 14}px`,
                  paddingRight: e.bareItems ? void 0 : "8px",
                  transform: e.swipeActions ? `translateX(${xe(g.id)}px)` : void 0,
                  transition: e.swipeActions && Te.value ? "transform 200ms" : void 0
                }),
                draggable: e.draggable,
                onClick: (R) => n("select", g.id),
                onDblclick: (R) => n("dblclick", g.id),
                onDragstart: (R) => de(R, g.id),
                onDragover: (R) => ue(R, g.id),
                onDragleave: ie,
                onDrop: (R) => he(R, g.id),
                onDragend: X
              }, [
                N(T.$slots, "item", {
                  node: g,
                  selected: e.selectedId === g.id,
                  depth: W,
                  isFav: !1
                }, () => [
                  g.icon ? (l(), _(q, {
                    key: 0,
                    name: g.icon,
                    size: 13,
                    class: "shrink-0 text-gray-400"
                  }, null, 8, ["name"])) : k("", !0),
                  u("span", wo, I(g.label), 1),
                  g.badge !== void 0 ? (l(), s("span", ko, I(g.badge), 1)) : k("", !0)
                ], !0),
                T.$slots["item-actions"] ? (l(), s("div", $o, [
                  N(T.$slots, "item-actions", { node: g }, void 0, !0)
                ])) : k("", !0)
              ], 46, xo)
            ], 42, po))
          ], 64))), 128))
        ]),
        _: 3
      }, 8, ["class"])),
      N(T.$slots, "footer", {}, void 0, !0)
    ], 2));
  }
}), wi = /* @__PURE__ */ fe(Lo, [["__scopeId", "data-v-49d31aac"]]), So = {
  light: {
    primary: "#2563eb",
    primaryLight: "#60a5fa",
    primaryHover: "#1d4ed8",
    primary50: "#eff6ff",
    primary100: "#dbeafe",
    primary200: "#bfdbfe",
    primary300: "#93c5fd",
    primary400: "#60a5fa",
    primary500: "#3b82f6",
    primary600: "#2563eb",
    primary700: "#1d4ed8",
    primary800: "#1e40af",
    primary900: "#1e3a8a",
    surface: "#ffffff",
    surfaceMuted: "#f9fafb",
    surfaceElevated: "#ffffff",
    surfaceInverse: "#111827",
    tooltipSurface: "#1f2937",
    tooltipText: "#f9fafb",
    tooltipBorder: "#374151",
    shadow: "rgba(15, 23, 42, 0.18)",
    text: "#111827",
    textMuted: "#6b7280",
    textDim: "#9ca3af",
    border: "#e5e7eb",
    borderStrong: "#d1d5db",
    scrollbarThumb: "#cbd5e1",
    scrollbarThumbHover: "#94a3b8",
    scrollbarTrack: "transparent",
    focus: "#2563eb",
    success: "#16a34a",
    warning: "#d97706",
    danger: "#dc2626",
    info: "#2563eb"
  },
  dark: {
    primary: "#60a5fa",
    primaryLight: "#93c5fd",
    primaryHover: "#3b82f6",
    primary500: "#60a5fa",
    surface: "#111827",
    surfaceMuted: "#0f172a",
    surfaceElevated: "#1f2937",
    surfaceInverse: "#ffffff",
    tooltipSurface: "#121f28",
    tooltipText: "#e5edf8",
    tooltipBorder: "#385163",
    shadow: "rgba(0, 0, 0, 0.55)",
    text: "#f9fafb",
    textMuted: "#d1d5db",
    textDim: "#9ca3af",
    border: "#1f2937",
    borderStrong: "#374151",
    scrollbarThumb: "#475569",
    scrollbarThumbHover: "#64748b",
    scrollbarTrack: "transparent",
    focus: "#93c5fd",
    success: "#4ade80",
    warning: "#fbbf24",
    danger: "#f87171",
    info: "#93c5fd",
    dark50: "#0f172a",
    dark100: "#111827",
    dark200: "#1f2937",
    dark300: "#374151",
    darkText: "#f9fafb",
    darkTextMuted: "#d1d5db",
    darkTextDim: "#9ca3af"
  }
}, Tt = "luna-vue-ui-theme";
function zo(e) {
  return `--color-${e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`).replace(/([a-z])([0-9])/g, "$1-$2")}`;
}
function Mt(e) {
  return e ? Object.entries(e).filter((r) => typeof r[1] == "string" && r[1].length > 0).map(([r, t]) => `  ${zo(r)}: ${t};`).join(`
`) : "";
}
function Bo(e = So) {
  if (typeof document > "u") return;
  let r = document.getElementById(Tt);
  r || (r = document.createElement("style"), r.id = Tt, r.dataset.vueUiTheme = "true", document.head.appendChild(r));
  const t = Mt(e.light), a = Mt(e.dark);
  r.textContent = [
    t ? `:root {
${t}
}` : "",
    a ? `.dark {
${a}
}` : ""
  ].filter(Boolean).join(`
`);
}
function To(e = {}) {
  return {
    install(r) {
      r.provide(At, Pt(e.icons)), r.directive("base-hover-label", $t), r.directive("basehoverlabel", $t), e.theme && Bo(e.theme);
    }
  };
}
const ki = To();
function Mo(e) {
  return typeof DOMException < "u" && e instanceof DOMException && e.name === "AbortError";
}
function Eo() {
  const e = P(!1), r = P(null);
  let t = 0, a = null;
  const n = () => {
    t += 1, a?.abort(), a = null, e.value = !1;
  };
  return { loading: e, error: r, run: async (c) => {
    n();
    const d = t, i = new AbortController();
    a = i, r.value = null, e.value = !0;
    try {
      const h = await c(i.signal);
      return d === t ? h : void 0;
    } catch (h) {
      if (d === t && !i.signal.aborted && !Mo(h))
        throw r.value = h, h;
      return;
    } finally {
      d === t && (a = null, e.value = !1);
    }
  }, cancel: n };
}
function $i(e) {
  const r = Zt([]), t = P(0), a = P(Math.max(1, e.page ?? 1)), n = P(Math.max(1, e.pageSize ?? 10)), o = Eo(), c = C(() => Math.max(1, Math.ceil(t.value / n.value))), d = C(() => a.value > 1), i = C(() => a.value < c.value), h = async (v = {}) => {
    const f = Math.max(1, v.page ?? a.value), b = Math.max(1, v.pageSize ?? n.value);
    a.value = f, n.value = b;
    const p = await o.run((L) => e.fetcher({ page: f, pageSize: b, signal: L }));
    return p && (r.value = p.items, t.value = Math.max(0, p.total)), p;
  }, x = (v) => h({ page: v }), y = (v) => h({ page: 1, pageSize: v }), S = () => {
    o.cancel(), r.value = [], t.value = 0, a.value = Math.max(1, e.page ?? 1), n.value = Math.max(1, e.pageSize ?? 10);
  }, m = {
    items: r,
    total: t,
    page: a,
    pageSize: n,
    totalPages: c,
    hasPrevious: d,
    hasNext: i,
    loading: o.loading,
    error: o.error,
    request: o,
    load: h,
    setPage: x,
    setPageSize: y,
    reset: S
  };
  return e.immediate !== !1 && h(), m;
}
const Xe = P([]);
function Ze(e) {
  Xe.value = Xe.value.filter((r) => r.id !== e);
}
function Ci() {
  function e(c) {
    const d = crypto.randomUUID();
    Xe.value = [...Xe.value, { ...c, id: d, startTime: Date.now() }];
    const i = c.life ?? 3e3;
    i > 0 && setTimeout(() => Ze(d), i);
  }
  function r(c, d, i = 3e3) {
    e({ severity: "success", summary: c, detail: d, life: i });
  }
  function t(c, d, i = 5e3) {
    e({ severity: "error", summary: c, detail: d, life: i });
  }
  function a(c, d, i = 4e3) {
    e({ severity: "warning", summary: c, detail: d, life: i });
  }
  function n(c, d, i = 3e3) {
    e({ severity: "info", summary: c, detail: d, life: i });
  }
  function o() {
    Xe.value = [];
  }
  return { add: e, success: r, error: t, warning: a, info: n, clear: o };
}
const Io = ["onClick", "onTouchstart", "onTouchmove", "onTouchend"], Do = { class: "toast-content flex items-start" }, Vo = { class: "toast-icon shrink-0 w-8 h-8 flex items-center justify-center rounded-full text-xl" }, Ao = { class: "flex-1 min-w-0" }, Po = {
  key: 0,
  class: "font-semibold text-sm mb-1 text-inherit leading-tight"
}, Ro = {
  key: 1,
  class: "text-sm m-0 text-inherit opacity-90 leading-snug wrap-break-word whitespace-pre-wrap"
}, Ho = ["onClick"], Wo = ["onClick"], ft = 80, Et = 5, Oo = /* @__PURE__ */ le({
  __name: "ToastNotification",
  props: {
    position: { default: "top-right" },
    toastClass: {},
    toastStyle: {}
  },
  setup(e) {
    const r = /* @__PURE__ */ new Map();
    function t(y, S) {
      const m = y.touches[0];
      if (!m) return;
      const v = y.currentTarget;
      v.style.transition = "none", r.set(S, { startX: m.clientX, startY: m.clientY, el: v, dir: null, locked: !1 });
    }
    function a(y, S) {
      const m = r.get(S);
      if (!m) return;
      const v = y.touches[0];
      if (!v) return;
      const f = v.clientX - m.startX, b = v.clientY - m.startY;
      if (!m.locked) {
        if (Math.abs(f) < Et && Math.abs(b) < Et) return;
        m.dir = Math.abs(f) >= Math.abs(b) ? "h" : "v", m.locked = !0;
      }
      if (m.dir === "v" && b > 0) return;
      y.preventDefault();
      let p = 0, L = 0;
      m.dir === "h" ? p = f > 0 ? f : f * 0.15 : L = b < 0 ? b : b * 0.15;
      const w = m.dir === "h" ? Math.max(0, f) : Math.max(0, -b), M = Math.max(0.3, 1 - w / ft * 0.7);
      m.el.style.transform = `translate(${p}px,${L}px)`, m.el.style.opacity = String(M);
    }
    function n(y, S) {
      const m = r.get(S);
      if (r.delete(S), !m) return;
      const v = y.changedTouches[0];
      if (!v) return;
      const f = v.clientX - m.startX, b = v.clientY - m.startY;
      m.dir === "h" && f > ft || m.dir === "v" && b < -ft ? (m.el.style.transition = "transform 0.2s ease-out, opacity 0.2s ease-out", m.el.style.transform = m.dir === "h" ? "translateX(120%)" : "translateY(-120%)", m.el.style.opacity = "0", setTimeout(() => Ze(S), 200)) : (m.el.style.transition = "transform 0.3s cubic-bezier(0.34,1.56,0.64,1), opacity 0.2s ease", m.el.style.transform = "", m.el.style.opacity = "");
    }
    const o = e, c = C(() => ({
      "top-right": "top-4 right-4 items-end",
      "top-center": "top-4 left-1/2 -translate-x-1/2 items-center",
      "top-left": "top-4 left-4 items-start",
      "bottom-right": "bottom-4 right-4 items-end",
      "bottom-center": "bottom-4 left-1/2 -translate-x-1/2 items-center",
      "bottom-left": "bottom-4 left-4 items-start"
    })[o.position] + " flex flex-col");
    function d(y) {
      return {
        success: "toast-success",
        error: "toast-error",
        warning: "toast-warning",
        info: "toast-info"
      }[y];
    }
    function i(y) {
      return {
        success: "CheckCircle2",
        error: "XCircle",
        warning: "AlertTriangle",
        info: "Info"
      }[y];
    }
    function h(y) {
      return typeof o.toastClass == "function" ? o.toastClass(y) : o.toastClass;
    }
    function x(y) {
      return { ...typeof o.toastStyle == "function" ? o.toastStyle(y) : o.toastStyle, ...y.style };
    }
    return (y, S) => (l(), _(De, { to: "body" }, [
      u("div", {
        class: E(["fixed z-20000 pointer-events-none sm:mx-0 mx-4", c.value])
      }, [
        U(qe, { name: "toast" }, {
          default: se(() => [
            (l(!0), s(te, null, oe(Z(Xe), (m) => (l(), s("div", {
              key: m.id,
              class: E(["toast-shell pointer-events-auto mb-3 overflow-hidden relative transition-all duration-300 ease-out hover:-translate-y-0.5 w-full max-w-sm sm:min-w-75", [d(m.severity), m.class, h(m), m.action ? "" : "cursor-pointer"]]),
              style: re(x(m)),
              onClick: (v) => !m.action && Z(Ze)(m.id),
              onTouchstart: (v) => t(v, m.id),
              onTouchmove: (v) => a(v, m.id),
              onTouchend: (v) => n(v, m.id)
            }, [
              u("div", Do, [
                u("div", Vo, [
                  U(q, {
                    name: i(m.severity),
                    size: 24
                  }, null, 8, ["name"])
                ]),
                u("div", Ao, [
                  m.summary ? (l(), s("h4", Po, I(m.summary), 1)) : k("", !0),
                  m.detail ? (l(), s("p", Ro, I(m.detail), 1)) : k("", !0),
                  m.action ? (l(), s("button", {
                    key: 2,
                    class: "toast-action mt-3 px-3 py-1.5 rounded-md text-xs font-semibold transition-colors cursor-pointer",
                    onClick: me((v) => {
                      Z(Ze)(m.id), m.action.onClick();
                    }, ["stop"])
                  }, I(m.action.label) + " → ", 9, Ho)) : k("", !0)
                ]),
                u("button", {
                  class: "toast-dismiss shrink-0 bg-transparent border-none cursor-pointer p-1 opacity-70 hover:opacity-100 transition-opacity",
                  onClick: me((v) => Z(Ze)(m.id), ["stop"])
                }, [
                  U(q, {
                    name: "X",
                    size: 14
                  })
                ], 8, Wo)
              ]),
              m.life ? (l(), s("div", {
                key: 0,
                class: "toast-progress h-0.75 absolute bottom-0 left-0 progress-bar",
                style: re({ animationDuration: `${m.life}ms` })
              }, null, 4)) : k("", !0)
            ], 46, Io))), 128))
          ]),
          _: 1
        })
      ], 2)
    ]));
  }
}), Li = /* @__PURE__ */ fe(Oo, [["__scopeId", "data-v-4fd11d07"]]);
export {
  Uo as BaseAlert,
  di as BaseAudioPlayer,
  ui as BaseAutocomplete,
  _o as BaseBreadcrumb,
  et as BaseButton,
  gi as BaseCollectionView,
  ii as BaseContextMenu,
  ln as BaseDialog,
  mi as BaseDrawer,
  vi as BaseEditableTable,
  Yo as BaseHoverLabel,
  q as BaseIcon,
  Fe as BaseInput,
  ei as BasePagination,
  ti as BasePasswordInput,
  Rt as BasePopover,
  qa as BasePopoverButton,
  Go as BaseProgressBar,
  Zo as BasePullToRefresh,
  Jo as BasePullToRefreshTrigger,
  vt as BaseSelect,
  ai as BaseSplitButton,
  Qo as BaseSwitch,
  ri as BaseTab,
  ni as BaseTabList,
  oi as BaseTabPanel,
  si as BaseTabPanels,
  bi as BaseTable,
  li as BaseTabs,
  Xo as BaseTag,
  qo as BaseTooltip,
  hi as BatchActionBar,
  pi as ConfirmationDialog,
  So as DEFAULT_VUE_UI_THEME,
  xi as JsonViewer,
  Li as ToastNotification,
  wi as TreeList,
  ki as VueUiPlugin,
  Bo as applyVueUiTheme,
  $t as baseHoverLabel,
  No as clearIconRegistry,
  Ee as confirmQueue,
  Pt as createIconRegistry,
  To as createVueUi,
  ci as disableCloseWatcherPath,
  fi as getMobileCloseStack,
  At as iconRegistryKey,
  st as normalizeIconName,
  Ba as registerIcon,
  Ta as registerIcons,
  Ze as removeToast,
  Ma as resolveIcon,
  Xe as toasts,
  yi as useConfirmDialog,
  Ea as useIconRegistry,
  Wt as useIsMobile,
  Eo as useLatestRequest,
  Fr as useMobileHistoryEntry,
  $i as usePaginatedQuery,
  Cl as usePullToRefresh,
  zl as usePullToRefreshTrigger,
  Ci as useToast
};
